import { HELP_FAZ8_AR } from './entries.faz8.ar';
import { AI_HELP_AR } from './entries.ai.ar';
import type { HelpContent, HelpKey } from './entries.tr';
import type { MobileHelpKey } from './entries.mobile';

type Loc = Pick<HelpContent, 'title' | 'short'>;

/** Yardım başlıkları ve kısa açıklamalar — Arapça (F7-17). Ayrıntı alanları Türkçe kayda düşer (İngilizcedeki gibi). */
export const HELP_AR: Record<HelpKey, Loc> = {
  ...HELP_FAZ8_AR,
  ...AI_HELP_AR,
  'page.dashboard': { title: 'لوحة المعلومات', short: 'يعرض نشاطك التجاري في لمحة سريعة.' },
  'page.setup': {
    title: 'معالج الإعداد',
    short: 'الخطوات الـ24 اللازمة للانتقال إلى التشغيل المباشر، بالترتيب.',
  },
  'page.organization': { title: 'بيانات المنشأة', short: 'الاسم القانوني وبيانات الضريبة والاتصال.' },
  'page.brands': {
    title: 'العلامات التجارية',
    short: 'العلامات التجارية التي تبيعها (مثل Zootopia Global وVITATOPIA).',
  },
  'page.stores': { title: 'المتاجر', short: 'قنوات البيع: النطاقات والأسواق حسب الدولة/اللغة/العملة.' },
  'page.users': { title: 'المستخدمون', short: 'الموظفون الذين يمكنهم الوصول إلى لوحة التحكم وأدوارهم.' },
  'page.roles': { title: 'الأدوار والصلاحيات', short: 'ما يمكن لكل دور فعله؛ وإنشاء أدوار مخصصة.' },
  'page.api_keys': { title: 'مفاتيح API', short: 'مفاتيح لربط البرامج الخارجية (المحاسبة، ERP، n8n).' },
  'page.webhooks': { title: 'خطافات الويب (Webhooks)', short: 'يُبلغ برنامجًا آخر فورًا عند حدوث أمر ما.' },
  'page.integrations': { title: 'التكاملات', short: 'حالة الاتصال الفعلية للخدمات الخارجية.' },
  'page.audit': { title: 'سجل التدقيق', short: 'من غيّر ماذا ومتى، مع القيم القديمة والجديدة.' },
  'page.system': {
    title: 'حالة النظام',
    short: 'قاعدة البيانات وقوائم الانتظار والبريد الإلكتروني وSSL والنسخ الاحتياطية.',
  },
  'page.migration': {
    title: 'حزمة النقل',
    short: 'ينقل متجرًا مُعدًّا في بيئة الاختبار (staging) إلى التشغيل المباشر (أو إلى متجر ثانٍ) بملف واحد.',
  },
  'page.privacy': {
    title: 'طلبات أصحاب البيانات',
    short: 'يسجّل طلبات البيانات الشخصية ويتابعها ويبتّ فيها خلال المهلة القانونية البالغة 30 يومًا.',
  },
  'page.account': { title: 'حسابي', short: 'الملف الشخصي وكلمة المرور واللغة والجلسات المفتوحة.' },
  'page.help_editor': { title: 'نصوص المساعدة', short: 'عدّل الشروح المعروضة في لوحة التحكم.' },
  'auth.sign_in': {
    title: 'تسجيل الدخول',
    short: 'يسجّل الدخول بالبريد الإلكتروني وكلمة المرور، ثم يُطلب رمز تحقق.',
  },
  'auth.mfa_enroll': { title: 'إعداد التحقق بخطوتين', short: 'يربط تطبيق المصادقة على هاتفك بحسابك.' },
  'auth.mfa_verify': { title: 'رمز التحقق', short: 'أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة.' },
  'auth.backup_codes': {
    title: 'الرموز الاحتياطية',
    short: '10 رموز تُستخدم مرة واحدة عندما لا تتمكن من الوصول إلى هاتفك.',
  },
  'auth.forgot_password': {
    title: 'نسيت كلمة المرور',
    short: 'يرسل عبر البريد الإلكتروني رابط إعادة تعيين صالحًا لمدة ساعة واحدة.',
  },
  'organization.save': { title: 'حفظ بيانات المنشأة', short: 'يحفظ تغييراتك.' },
  'organization.tax_number': {
    title: 'الرقم الضريبي / رقم الهوية الوطنية',
    short: 'رقم ضريبي من 10 أرقام أو رقم هوية وطنية من 11 رقمًا.',
  },
  'organization.mersis': { title: 'رقم MERSIS', short: 'رقم السجل المركزي المكوّن من 16 رقمًا.' },
  'organization.kep': { title: 'عنوان KEP', short: 'عنوان البريد الإلكتروني المسجَّل (إن وُجد).' },
  'organization.etbis': {
    title: 'رابط التحقق من ETBİS',
    short: 'عنوان ETBİS الذي يفتحه رمز QR الخاص بتسجيلك؛ يظهر في تذييل واجهة المتجر.',
  },
  'brands.create': { title: 'إضافة علامة تجارية', short: 'ينشئ علامة تجارية جديدة.' },
  'brands.edit': { title: 'تعديل العلامة التجارية', short: 'يغيّر الاسم أو الوصف أو اللون أو الشعار.' },
  'brands.archive': { title: 'أرشفة', short: 'يُخفي العلامة التجارية دون حذفها.' },
  'brands.logo_upload': {
    title: 'رفع الشعار',
    short: 'PNG أو JPEG أو WebP أو AVIF أو GIF؛ بحد أقصى 5 ميغابايت.',
  },
  'brands.slug': {
    title: 'الاسم المختصر',
    short: 'الاسم المستخدم في عناوين URL: أحرف لاتينية صغيرة وأرقام وشرطات.',
  },
  'brands.primary_color': { title: 'اللون الأساسي', short: 'اللون الرئيسي للعلامة التجارية (مثل #0F766E).' },
  'stores.create': { title: 'إضافة متجر', short: 'ينشئ قناة بيع جديدة.' },
  'stores.edit': { title: 'تعديل المتجر', short: 'يغيّر الاسم ونوع القناة والعلامات التجارية.' },
  'stores.channel_type': { title: 'نوع القناة', short: 'B2C أو B2B أو هجين (كلاهما).' },
  'stores.status': {
    title: 'حالة النشر',
    short:
      'معاينة أو مباشر أو صيانة. يتطلب الانتقال إلى التشغيل المباشر قائمة الجاهزية وتأكيدًا صريحًا والتحقق بخطوتين.',
  },
  'stores.go_live': { title: 'تشغيل المتجر مباشرةً', short: 'يفتح واجهة المتجر للعملاء الحقيقيين.' },
  'stores.maintenance': { title: 'صيانة', short: 'يغلق واجهة المتجر مؤقتًا مع عرض صفحة صيانة (503).' },
  'stores.to_draft': {
    title: 'العودة إلى المعاينة',
    short: 'يوقف التشغيل المباشر للمتجر ويعيده إلى وضع المعاينة.',
  },
  'stores.go_live_confirm': {
    title: 'تأكيد التشغيل المباشر',
    short: 'تؤكد أنه تم التحقق من الأسعار وطرق الدفع والنصوص القانونية.',
  },
  'stores.status_note': { title: 'ملاحظة', short: 'سبب التغيير؛ يُسجَّل في سجل التدقيق.' },
  'stores.add_domain': { title: 'إضافة نطاق', short: 'يربط نطاقًا بالمتجر.' },
  'stores.remove_domain': { title: 'إزالة النطاق', short: 'يفصل النطاق عن المتجر.' },
  'stores.default_market': { title: 'تعيين كافتراضي', short: 'تُفتح واجهة المتجر بلغة هذا السوق وعملته.' },
  'stores.add_market': { title: 'إضافة سوق', short: 'يضيف تركيبة من الدولة واللغة والعملة.' },
  'stores.return_policy': {
    title: 'سياسة الإرجاع (لمحركات البحث)',
    short: 'مهلة الإرجاع وطريقته ورسومه المُبلَّغ عنها إلى Google؛ يجب أن تتوافق مع نصوصك القانونية.',
  },
  'stores.return_days': { title: 'مهلة الإرجاع (بالأيام)', short: '14 يومًا على الأقل في البيع عن بُعد.' },
  'stores.return_method': { title: 'طريقة الإرجاع', short: 'عبر البريد أو في المتجر.' },
  'stores.return_fees': { title: 'رسوم شحن الإرجاع', short: '«مجاني» فقط إذا كنت تتحمّل تكلفة شحن الإرجاع.' },
  'stores.remove_market': { title: 'إزالة السوق', short: 'يحذف السوق. لا يمكن إزالة السوق الافتراضي.' },
  'users.copy_invite_link': {
    title: 'نسخ الرابط',
    short: 'ينسخ رابط الدعوة لتتمكن من مشاركته عبر WhatsApp أو الرسائل النصية أو شخصيًا.',
  },
  'users.invite': {
    title: 'دعوة مستخدم',
    short: 'ينشئ رابط دعوة صالحًا لمدة 7 أيام، ويرسله بالبريد الإلكتروني إذا كانت خدمة البريد مُعدّة.',
  },
  'users.change_role': { title: 'تغيير الدور', short: 'يغيّر الدور الذي يحدد الصلاحيات.' },
  'users.store_scope': { title: 'تقييد المتاجر', short: 'فارغ = جميع المتاجر؛ وإلا فالمتاجر المحددة فقط.' },
  'users.dealer_scope': {
    title: 'نطاق الموزّعين',
    short:
      '«الموزّعون المعيّنون فقط»: يرى المستخدم الموزّعين المعيّنين له أو الموجودين في المناطق التي يديرها، مع مستخدميهم وطلباتهم وعروض أسعارهم وكشوف حساباتهم؛ ويبقى عملاء التجزئة والموزّعون الآخرون مخفيين.',
  },
  'users.suspend': { title: 'إيقاف مؤقت', short: 'يوقف الوصول إلى لوحة التحكم مع الاحتفاظ بالسجلات.' },
  'users.remove': { title: 'إزالة العضو', short: 'يزيل الشخص من هذه المنشأة.' },
  'users.revoke_invitation': { title: 'إلغاء الدعوة', short: 'يُبطل دعوة معلّقة.' },
  'roles.create_custom': { title: 'إنشاء دور مخصص', short: 'يحدد دورًا جديدًا صلاحيةً تلو الأخرى.' },
  'roles.edit_custom': { title: 'تعديل الدور المخصص', short: 'يغيّر صلاحيات الدور لكل من يستخدمه.' },
  'roles.delete_custom': { title: 'حذف الدور المخصص', short: 'يحذف الدور.' },
  'api_keys.create': { title: 'إنشاء مفتاح API', short: 'ينشئ مفتاحًا يتيح لبرنامج خارجي الاتصال.' },
  'api_keys.scopes': { title: 'نطاقات الصلاحية', short: 'ما يُسمح للمفتاح بفعله. اختر ما يلزم فقط.' },
  'api_keys.revoke': { title: 'إبطال', short: 'يُبطل المفتاح فورًا.' },
  'webhooks.create': { title: 'إضافة Webhook', short: 'يسجّل عنوان URL لإشعاره عند وقوع أحداث محددة.' },
  'webhooks.events': { title: 'الأحداث', short: 'الأحداث التي تُطلق إشعارًا. «*» تعني جميع الأحداث.' },
  'webhooks.test': {
    title: 'إرسال حدث تجريبي',
    short: 'يرسل حدث «webhook.test» إلى جميع خطافات الويب النشطة.',
  },
  'webhooks.rotate_secret': {
    title: 'تدوير المفتاح السري',
    short: 'ينشئ مفتاح توقيع سريًا جديدًا؛ ويتوقف المفتاح القديم عن العمل.',
  },
  'webhooks.redeliver': { title: 'إعادة الإرسال', short: 'يعيد الآن محاولة إرسال فشل سابقًا.' },
  'webhooks.delete': { title: 'حذف Webhook', short: 'يوقف الإشعارات إلى عنوان URL هذا.' },
  'integrations.save_credentials': {
    title: 'حفظ بيانات الاعتماد',
    short: 'يحفظ البيانات مشفّرة. تبقى الحالة «يتطلب الإعداد» حتى يتم اختبارها.',
  },
  'integrations.test': {
    title: 'اختبار الاتصال',
    short: 'يحاول الاتصال بالخدمة الفعلية باستخدام البيانات المحفوظة.',
  },
  'integrations.disconnect': { title: 'قطع الاتصال', short: 'يحذف البيانات المحفوظة ويعطّل التكامل.' },
  'integrations.environment': {
    title: 'البيئة',
    short: 'تجريبي (Sandbox): بلا أموال حقيقية. مباشر: معاملات حقيقية.',
  },
  'audit.filter': { title: 'تصفية', short: 'يصفّي السجلات حسب النوع (مثل تغييرات المتاجر فقط).' },
  'system.refresh': { title: 'تحديث', short: 'يقيس الحالة من جديد.' },
  'setup.skip_step': { title: 'تخطي الخطوة', short: 'يحدد هذه الخطوة على أنها غير مطلوبة حاليًا.' },
  'account.change_password': {
    title: 'تغيير كلمة المرور',
    short: '12 حرفًا على الأقل. يتم تسجيل الخروج من الجلسات الأخرى.',
  },
  'account.sessions_revoke': { title: 'تسجيل الخروج من الجلسة', short: 'ينهي الجلسة على الجهاز المحدد.' },
  'account.ui_mode': {
    title: 'وضع الاستخدام',
    short: 'يعرض وضع المبتدئ الشروح؛ ويُبقي الوضع المتقدم الشاشة بسيطة.',
  },
  'account.language': { title: 'لغة لوحة التحكم', short: 'Türkçe أو English أو Deutsch أو العربية.' },
  'help.edit': { title: 'تعديل الشرح', short: 'يغيّر نص المساعدة هذا؛ مع الاحتفاظ بالنسخة القديمة.' },
  'page.products': {
    title: 'المنتجات',
    short: 'جميع المنتجات: المتغيرات والمخزون والمراجعة البيطرية وحالة النشر.',
  },
  'page.product_editor': {
    title: 'تعديل المنتج',
    short: 'التفاصيل والمحتوى والمتغيرات والصور والأسعار والنشر.',
  },
  'page.categories': { title: 'الفئات', short: 'مجموعات المنتجات في واجهة المتجر.' },
  'page.pricing': {
    title: 'التسعير',
    short: 'مجموعات العملاء وقوائم الأسعار وفئات الضريبة وتغييرات الأسعار المجمّعة.',
  },
  'page.discounts': { title: 'رموز الخصم', short: 'خصومات بنسبة مئوية أو بمبلغ ثابت تُطبَّق برمز.' },
  'page.stock': {
    title: 'المخزون',
    short: 'المستودعات ومخزون المتغيرات والدفعات / تواريخ انتهاء الصلاحية والحركات.',
  },
  'page.customers': { title: 'العملاء', short: 'أعضاء واجهة المتجر ومستخدمو الموزّعين.' },
  'page.customer_detail': {
    title: 'العميل',
    short: 'الملف الشخصي والشركات والموافقات والوسوم وملخص الطلبات (RFM) والعناوين والطلبات.',
  },
  'page.dealers': { title: 'الموزّعون', short: 'شركات الموزّعين وحالاتها ومجموعات الأسعار.' },
  'page.dealer_detail': {
    title: 'الموزّع',
    short: 'بيانات الشركة وإجراءات الحالة والمستخدمون وطلبات الانضمام.',
  },
  'page.dealer_applications': {
    title: 'طلبات الانضمام كموزّع',
    short: 'الطلبات المقدَّمة عبر واجهة المتجر.',
  },
  'page.imports': {
    title: 'الاستيراد / التصدير',
    short: 'رفع وتنزيل المنتجات والموزّعين بشكل مجمّع (Excel/CSV).',
  },
  'page.orders': { title: 'الطلبات', short: 'الطلبات الواردة من واجهة المتجر والموزّعين ولوحة التحكم.' },
  'page.order_detail': {
    title: 'الطلب',
    short: 'البنود والإجماليات والعناوين والتسلسل الزمني وإجراءات الحالة.',
  },
  'products.create': { title: 'منتج جديد', short: 'ينشئ منتجًا بصفة مسودة.' },
  'products.slug': {
    title: 'الاسم المختصر (URL)',
    short: 'عنوان صفحة المنتج. يُنشأ تلقائيًا من اسم المنتج إذا تُرك فارغًا.',
  },
  'products.species': { title: 'فصيلة الحيوان', short: 'الحيوانات المخصّص لها المنتج.' },
  'products.tax_class': { title: 'فئة الضريبة', short: 'إذا تُرك فارغًا تُستخدم فئة الضريبة الافتراضية.' },
  'products.status': { title: 'الحالة', short: 'مسودة · نشط (قابل للبيع) · مؤرشف.' },
  'products.dealer_min_quantity': {
    title: 'الحد الأدنى للكمية للموزّعين',
    short:
      'يطلب الموزّعون من المتغير هذه الكمية على الأقل (لا ينطبق على التجزئة). تُقرَّب للأعلى إلى حجم الكرتونة. فارغ: لا توجد قاعدة.',
  },
  'products.dealer_pack_size': {
    title: 'حجم الكرتونة للموزّعين',
    short:
      'يطلب الموزّعون بمضاعفات هذه الكمية (مثل 12 أو 24). يظهر في صفحة المنتج وسلة التسوق. فارغ: لا توجد قاعدة.',
  },
  'pricing.group_min_order': {
    title: 'الحد الأدنى لمبلغ الطلب',
    short: 'لا يمكن لموزّعي هذه المجموعة الطلب بأقل من إجمالي السلة هذا (دون الشحن). فارغ: لا يوجد حد أدنى.',
  },
  'dealers.po_requirement': {
    title: 'اشتراط أمر الشراء (PO)',
    short:
      'تتطلب طلبات واجهة المتجر رقم PO، أو رقمًا ومستندًا. لا يلزم ذلك للطلبات التي تنشئها في لوحة التحكم.',
  },
  'dealers.min_order': {
    title: 'الحد الأدنى لطلب الموزّع',
    short: 'يحلّ محل مبلغ المجموعة لهذا الموزّع. فارغ: يُطبَّق مبلغ مجموعة الموزّع.',
  },
  'products.visibility': { title: 'مرئي لـ', short: 'عملاء التجزئة و/أو الموزّعون المعتمدون.' },
  'products.health_content': {
    title: 'المحتوى الصحي',
    short: 'يتطلب موافقة المراجع البيطري المختص قبل النشر.',
  },
  'products.feed_registration_no': {
    title: 'رقم تسجيل الأعلاف',
    short: 'رقم التسجيل/الموافقة الصادر عن الوزارة.',
  },
  'products.variants': {
    title: 'الخيارات والمتغيرات',
    short: 'كل تركيبة خيارات هي متغير له SKU ومخزون خاصان به.',
  },
  'products.sku': { title: 'SKU', short: 'رمز مخزون فريد.' },
  'products.cost': { title: 'التكلفة', short: 'تكلفة الشراء؛ تظهر فقط لمن لديه صلاحية التكلفة.' },
  'products.vet_review': { title: 'المراجعة البيطرية', short: 'يوافق المراجع البيطري على المحتوى أو يرفضه.' },
  'products.media_upload': { title: 'إضافة صورة', short: 'PNG/JPEG/WebP حتى 5 ميغابايت؛ تُحوَّل إلى WebP.' },
  'products.prices': { title: 'أسعار المنتج', short: 'السعر في كل قائمة أسعار؛ يُحفظ عند مغادرة الحقل.' },
  'products.publish': { title: 'نشر', short: 'يعرض المنتج في المتجر المحدد.' },
  'categories.parent': { title: 'الفئة الأم', short: 'الفارغ يعني المستوى الأعلى.' },
  'pricing.group_kind': { title: 'نوع المجموعة', short: 'تضم مجموعات الموزّعين شركات الموزّعين المعتمدة.' },
  'pricing.list_group': {
    title: 'مجموعة القائمة',
    short: 'فارغ: قائمة أساسية للجميع؛ وتحديد مجموعة يقصر القائمة عليها.',
  },
  'pricing.tax_inclusive': {
    title: 'الأسعار شاملة الضريبة',
    short: 'يمكن إدخال قوائم الموزّعين دون الضريبة.',
  },
  'pricing.priority': {
    title: 'الأولوية',
    short: 'عند انطباق عدة قوائم، تُعتمد القائمة ذات الأولوية الأعلى.',
  },
  'pricing.tax_class': { title: 'فئات الضريبة', short: 'معدلات الضريبة المخصّصة للمنتجات.' },
  'pricing.bulk_preview': {
    title: 'معاينة الأسعار المجمّعة',
    short: 'يحسب الأسعار الجديدة دون تغيير أي شيء.',
  },
  'pricing.bulk_apply': {
    title: 'تطبيق الأسعار المجمّعة',
    short: 'يعتمد الأسعار التي تمت معاينتها (يتطلب تحققًا بخطوتين حديثًا).',
  },
  'pricing.bulk_revert': {
    title: 'التراجع عن الأسعار المجمّعة',
    short: 'يستعيد الأسعار القديمة؛ مع الاحتفاظ بالتغييرات اليدوية.',
  },
  'pricing.price_ending': { title: 'نهاية السعر', short: 'يقرّب للأعلى إلى رقم صحيح أو .90 أو .99.' },
  'discounts.code': { title: 'رمز الخصم', short: '3–32 حرفًا؛ أحرف وأرقام و- و_.' },
  'discounts.min_subtotal': {
    title: 'الحد الأدنى لإجمالي السلة',
    short: 'لا يُطبَّق رمز الخصم إذا كان المجموع الفرعي أقل من هذا المبلغ.',
  },
  'discounts.usage_limit': { title: 'حد الاستخدام', short: 'عدد الطلبات التي يمكنها استخدامه إجمالًا.' },
  'discounts.companies': {
    title: 'شركات الموزّعين',
    short: 'رمز خصم للموزّعين فقط: لا يمكن استخدام الرمز إلا لمستخدمي شركات الموزّعين المعتمدة المحددة.',
  },
  'discounts.groups': { title: 'المجموعات المشمولة', short: 'الفارغ يعني الجميع.' },
  'stock.change_type': { title: 'نوع الحركة', short: 'استلام أو تسوية أو تلف أو جرد.' },
  'stock.lot': {
    title: 'الدفعة وتاريخ انتهاء الصلاحية',
    short: 'تُباع الدفعة الأقرب انتهاءً أولًا؛ ولا تُباع الدفعات منتهية الصلاحية.',
  },
  'stock.transfer': { title: 'تحويل', short: 'ينقل المخزون بين المستودعات.' },
  'stock.expiring': {
    title: 'تنتهي صلاحيتها قريبًا',
    short: 'الدفعات التي لديها مخزون وتنتهي صلاحيتها خلال عدد الأيام المحدد.',
  },
  'customers.pii_masked': {
    title: 'بيانات شخصية مُقنَّعة',
    short: 'يُقنَّع البريد الإلكتروني والهاتف والعنوان دون صلاحية البيانات الشخصية (PII).',
  },
  'customers.access_link': {
    title: 'رابط الوصول',
    short: 'رابط تفعيل أو إعادة تعيين كلمة المرور؛ يُعرض على الشاشة إذا لم يكن البريد الإلكتروني مُعدًّا.',
  },
  'customers.unlock': { title: 'إلغاء القفل', short: 'يفتح حسابًا مقفلًا بعد محاولات تسجيل دخول فاشلة.' },
  'customers.consents': {
    title: 'موافقات التسويق',
    short: 'سجل موافقات البريد الإلكتروني/الرسائل النصية؛ لا يُحذف أبدًا.',
  },
  'dealers.tax_number': {
    title: 'الرقم الضريبي / رقم الهوية الوطنية',
    short: 'يُخزَّن مشفّرًا؛ ويجب أن يكون فريدًا.',
  },
  'dealers.external_code': {
    title: 'رمز الموزّع',
    short: 'الرمز من نظامك السابق؛ يُستخدم للمطابقة عند الاستيراد.',
  },
  'dealers.group': { title: 'مجموعة الموزّع', short: 'تحدد قائمة الأسعار التي يراها الموزّع.' },
  'dealers.status_action': { title: 'حالة الموزّع', short: 'اعتماد أو إيقاف مؤقت أو رفض.' },
  'dealers.add_member': { title: 'إضافة مستخدم', short: 'يربط موظفًا لدى الموزّع وينشئ رابط تفعيل.' },
  'applications.documents': {
    title: 'المستندات',
    short: 'ملفات خاصة؛ لا يمكن تنزيلها إلا لمستخدمي لوحة التحكم المخوّلين.',
  },
  'applications.decision': { title: 'القرار', short: 'اختر مجموعة موزّعين للاعتماد؛ واذكر سببًا للرفض.' },
  'imports.products_file': {
    title: 'رفع ملف المنتجات',
    short: 'قالبنا، أو ملف CSV للمنتجات من Shopify، أو مستند منتجات بصيغة JSON/XML.',
  },
  'imports.dealers_file': {
    title: 'رفع قائمة الموزّعين',
    short: 'ملف Excel/CSV يتضمن اسم الشركة ورمز الموزّع أو الرقم الضريبي.',
  },
  'imports.price_list': { title: 'قائمة الأسعار المستهدفة', short: 'يُكتب عمود «السعر» في هذه القائمة.' },
  'imports.warehouse': { title: 'المستودع المستهدف', short: 'يُكتب عمود «المخزون» هنا كقيمة جرد.' },
  'imports.default_brand': {
    title: 'العلامة التجارية الافتراضية',
    short:
      'تُسنَد هذه العلامة التجارية إلى المنتجات الجديدة في الصفوف التي يكون فيها عمود «العلامة التجارية» فارغًا.',
  },
  'imports.default_status': { title: 'الحالة الافتراضية', short: 'تُستخدم عندما يكون عمود الحالة فارغًا.' },
  'imports.send_links': {
    title: 'بريد التفعيل',
    short: 'يرسل روابط تعيين كلمة المرور إذا كان البريد الإلكتروني مُعدًّا.',
  },
  'imports.download_issues': {
    title: 'تنزيل قائمة المشكلات',
    short: 'ينزّل مشكلات المعاينة بصيغة CSV مع أرقام الصفوف.',
  },
  'imports.export': { title: 'تصدير', short: 'ينزّل الأعمدة نفسها بصيغة Excel، أو كمستند JSON/XML.' },
  'orders.manual_create': { title: 'إنشاء طلب', short: 'ينشئ طلبًا بسعر العميل.' },
  'orders.ledger_settled': {
    title: 'مُسدَّد عبر الحساب الجاري',
    short: 'تمت تغطية دين الحساب الآجل بالكامل بالدفعات المسجّلة في الحساب الجاري للموزّع.',
  },
  'orders.status_change': {
    title: 'تغيير الحالة',
    short: 'ينقل الطلب إلى المرحلة التالية؛ والإلغاء يحرّر المخزون.',
  },
  'orders.payment_note': { title: 'ملاحظة الدفع', short: 'صِف كيف تم استلام الدفعة.' },
  'orders.notes': { title: 'ملاحظة داخلية', short: 'تظهر في لوحة التحكم فقط.' },
  'orders.po': {
    title: 'أمر الشراء وموافقة الشركة',
    short: 'رقم أمر الشراء (PO) الخاص بالموزّع ومستنده؛ ومن وافق على طلب المشتري الذي تجاوز حدّه.',
  },
  'orders.po_number': {
    title: 'رقم PO',
    short: 'رقم أمر الشراء الخاص بالموزّع (حتى 50 حرفًا). يمكن البحث عن الطلبات به.',
  },
  'orders.po_document': {
    title: 'إرفاق مستند PO أو استبداله',
    short:
      'PDF أو JPEG أو PNG (حتى 10 ميغابايت). يُخزَّن بشكل خاص؛ ولا يمكن تنزيله إلا لمستخدمي لوحة التحكم الذين يمكنهم رؤية الطلبات.',
  },
  'orders.company_approval': {
    title: 'موافقة الشركة',
    short: 'وافق المسؤول المفوّض عن الشركة في واجهة المتجر على سلة المشتري التي تجاوزت حدّه.',
  },
  'page.order_print': { title: 'طباعة الطلبات', short: 'ملخص الطلب أو قائمة التعبئة للطلبات المحددة.' },
  'orders.guest': {
    title: 'نوع العميل',
    short: 'عميل مسجّل (سعر مجموعته) أو زائر (سعر التجزئة؛ البريد الإلكتروني مطلوب).',
  },
  'orders.shipping_fee': {
    title: 'الشحن',
    short: 'رسوم من طريقة الشحن، أو رسوم يدوية لمن لديه صلاحية التسعير.',
  },
  'orders.manual_discount': { title: 'الخصم', short: 'رمز خصم أو مبلغ يدوي؛ وليس كليهما.' },
  'orders.edit_draft': {
    title: 'تعديل المسودة',
    short: 'يمكن تغيير كل شيء في المسودة؛ ويُعاد حساب الأسعار.',
  },
  'orders.edit_lines': { title: 'تعديل البنود', short: 'يمكن تغيير البنود والكميات قبل الدفع.' },
  'orders.edit_address': { title: 'تعديل العنوان والملاحظة', short: 'ممكن حتى إنشاء الشحنة.' },
  'orders.payment_link': {
    title: 'رابط الدفع',
    short: 'ينشئ رابطًا محدود المدة يستخدمه العميل لدفع قيمة الطلب بالبطاقة.',
  },
  'orders.payment_link_hours': { title: 'صالح لمدة', short: 'بعد انقضاء هذه المدة، لا يقبل الرابط أي دفع.' },
  'orders.payment_link_email': {
    title: 'إرسال بالبريد الإلكتروني',
    short: 'يرسل الرابط إلى عنوان البريد الإلكتروني الخاص بالطلب.',
  },
  'orders.bulk_status': {
    title: 'تغيير الحالة بشكل مجمّع',
    short: 'تتغير حالة كل طلب محدد وفق قواعده الخاصة.',
  },
  'orders.bulk_print': { title: 'طباعة', short: 'يفتح ملخص الطلب أو قائمة التعبئة للطلبات المحددة.' },
  'orders.bulk_export': {
    title: 'تنزيل بصيغة Excel',
    short: 'يصدّر الطلبات المحددة مع بيانات شخصية مُقنَّعة.',
  },
  'orders.print': { title: 'طباعة / حفظ بصيغة PDF', short: 'يفتح نافذة الطباعة في المتصفح.' },
  'page.payment_settings': {
    title: 'إعدادات الدفع (إعداد نقاط البيع POS)',
    short:
      'الدفع بالبطاقة (iyzico/PayTR)، والتحويل البنكي، والدفع عند الاستلام، والحساب الآجل للموزّعين؛ وقائمة التحقق للتشغيل المباشر.',
  },
  'page.payments': {
    title: 'المدفوعات',
    short: 'جميع محاولات الدفع وعمليات التحصيل واسترداد المبالغ والمطابقة مع مزوّد الخدمة.',
  },
  'page.invoices': { title: 'الفواتير', short: 'فواتير الطلبات المرسلة إلى BizimHesap أو المسجّلة يدويًا.' },
  'page.redirects': {
    title: 'إعادة التوجيه',
    short: 'يوجّه العناوين القديمة إلى عناوين جديدة (301 دائم، 302 مؤقت).',
  },
  'redirects.add': { title: 'إضافة إعادة توجيه', short: 'يوجّه عنوانًا قديمًا واحدًا إلى عنوان جديد.' },
  'redirects.import': {
    title: 'الاستيراد من ملف',
    short: 'يحمّل قائمة عناوين الموقع القديم دفعةً واحدة (CSV/Excel)؛ مع عرض معاينة أولًا.',
  },
  'redirects.search': { title: 'البحث في العناوين', short: 'اكتب جزءًا من عنوان قديم أو جديد.' },
  'redirects.from': { title: 'العنوان القديم', short: 'المسار المراد إعادة توجيهه، ويبدأ بـ «/».' },
  'redirects.to': { title: 'العنوان الجديد', short: 'مسار على هذا الموقع أو عنوان كامل يبدأ بـ https://.' },
  'redirects.code': {
    title: 'نوع إعادة التوجيه',
    short: '301 دائم ويُعلم محركات البحث بأن الصفحة انتقلت؛ و302 مؤقت.',
  },
  'redirects.note': { title: 'ملاحظة', short: 'ملاحظة لنفسك.' },
  'redirects.template': { title: 'تنزيل القالب', short: 'قالب CSV فارغ بعناوين الأعمدة الصحيحة.' },
  'page.shipping': { title: 'طرق الشحن', short: 'خيارات الشحن وأسعاره المعروضة عند إتمام الطلب.' },
  'page.legal': {
    title: 'النصوص القانونية',
    short:
      'إشعار الخصوصية، وعقد العضوية وعقد البيع عن بُعد، ونموذج المعلومات المسبقة، والإرجاع، وسياسة الخصوصية وملفات تعريف الارتباط.',
  },
  'payments.card_provider': {
    title: 'مزوّد خدمة البطاقات',
    short: 'iyzico أو PayTR أو Sipay؛ يجب أن ينجح اختبار الاتصال للبيئة المحددة.',
  },
  'payments.environment': {
    title: 'البيئة',
    short: 'لا تُخصم أموال حقيقية في البيئة التجريبية (Sandbox). يتطلب التشغيل المباشر تأكيدًا منفصلًا.',
  },
  'payments.max_installments': { title: 'التقسيط', short: 'الحد الأقصى لعدد الأقساط المعروضة على العملاء.' },
  'payments.card_capture': {
    title: 'توقيت الخصم',
    short: 'تفويض مسبق (حجز المبلغ) عند إتمام الطلب والخصم عند الشحن (iyzico فقط).',
  },
  'orders.preauth_capture': {
    title: 'تحصيل',
    short: 'يخصم إجمالي الطلب الحالي من المبلغ المحجوز على البطاقة.',
  },
  'orders.preauth_release': {
    title: 'إلغاء التفويض المسبق',
    short: 'يحرّر المبلغ المحجوز على البطاقة ويلغي الطلب.',
  },
  'payments.card_timeout': {
    title: 'مهلة الدفع بالبطاقة',
    short: 'تُلغى عمليات الدفع بالبطاقة غير المكتملة بعد هذه المدة؛ ويُحرَّر المخزون.',
  },
  'payments.bank_transfer_hold': {
    title: 'مهلة الدفع بالتحويل البنكي',
    short: 'تُلغى تلقائيًا طلبات التحويل البنكي غير المدفوعة خلال هذه المدة، ويُحرَّر المخزون.',
  },
  'payments.notify_urls': {
    title: 'عناوين URL للإشعارات',
    short: 'العناوين التي يجب إدخالها كعنوان URL لرد الاتصال/الإشعارات في لوحات تحكم مزوّدي الخدمة.',
  },
  'payments.other_methods': {
    title: 'طرق دفع أخرى',
    short: 'التحويل البنكي والدفع عند الاستلام والحساب الآجل للموزّعين والشراء كزائر.',
  },
  'payments.cod_fee': {
    title: 'رسوم الدفع عند الاستلام',
    short: 'رسوم خدمة تُضاف إلى الطلب (شاملة الضريبة).',
  },
  'payments.cod_max': {
    title: 'الحد الأقصى للدفع عند الاستلام',
    short: 'لا يُعرض إذا تجاوز إجمالي الطلب هذا المبلغ. فارغ: بلا حد.',
  },
  'payments.bank_account': {
    title: 'الحساب البنكي',
    short: 'أرقام IBAN المعروضة للتحويل البنكي؛ التغييرات حساسة وتخضع للتدقيق.',
  },
  'payments.iban': { title: 'IBAN', short: '26 حرفًا تبدأ بـ TR.' },
  'payments.reconcile': { title: 'المطابقة', short: 'يقارن التقرير اليومي لمزوّد الخدمة بمدفوعاتك.' },
  'shipping.method': { title: 'طريقة الشحن', short: 'يضيف خيار شحن عند إتمام الطلب أو يعدّله.' },
  'shipping.handling_days': {
    title: 'مدة التجهيز (أيام عمل)',
    short: 'من الطلب حتى التسليم إلى شركة الشحن.',
  },
  'shipping.transit_days': {
    title: 'مدة النقل (أيام عمل)',
    short: 'المدة التي تستغرقها الشحنة لدى شركة الشحن.',
  },
  'shipping.carrier': {
    title: 'شركة الشحن',
    short: 'تظهر في روابط التتبع ورسائل البريد الإلكتروني؛ لا حاجة إلى API.',
  },
  'shipping.audience': {
    title: 'الفئة المستهدفة',
    short: 'الجميع، أو عملاء التجزئة فقط، أو الموزّعون المعتمدون فقط.',
  },
  'shipping.rate_type': { title: 'نوع التسعيرة', short: 'سعر ثابت أو حسب شرائح وزن السلة.' },
  'shipping.free_over': {
    title: 'شحن مجاني ابتداءً من',
    short: 'يصبح الشحن مجانيًا عندما يبلغ إجمالي البضائع هذا المبلغ.',
  },
  'legal.variables': {
    title: 'المتغيرات',
    short: 'تُملأ العناصر النائبة {{field}} ببيانات حقيقية عند العرض.',
  },
  'legal.languages': {
    title: 'النسخ اللغوية',
    short: 'لكل نص مسودة ونشر وإقرار مراجعة قانونية مستقلة لكل لغة. النسخة التركية هي الأساس.',
  },
  'legal.language': { title: 'لغة النص', short: 'اللغة التي تحررها. تُحفظ كل لغة وتُنشر على حدة.' },
  'legal.copy_tr': {
    title: 'البدء من النص التركي',
    short: 'ينسخ النص التركي (مع المتغيرات) إلى مسودة هذه اللغة لتترجمه.',
  },
  'legal.reviewed': { title: 'المراجعة القانونية', short: 'يُقرّ بأن محاميًا قد راجع النص.' },
  'legal.publish': {
    title: 'نشر النص القانوني',
    short: 'ينشر المسودة المحفوظة لهذه اللغة كإصدار جديد، ويُؤرشف الإصدار السابق.',
  },
  'invoices.send': {
    title: 'إرسال إلى BizimHesap',
    short: 'يرسل الفاتورة إلى BizimHesap؛ وتصبح «غير مؤكدة» عند انتهاء المهلة.',
  },
  'invoices.uncertain': {
    title: 'فاتورة غير مؤكدة',
    short: 'تحقق في BizimHesap وسجّل ما إذا كانت الفاتورة قد أُنشئت.',
  },
  'invoices.create': {
    title: 'إنشاء فاتورة',
    short: 'مسودة فاتورة لـ BizimHesap أو سجل لفاتورة صادرة في مكان آخر.',
  },
  'orders.capture': {
    title: 'تم استلام الدفعة',
    short: 'يسجّل دفعة بالتحويل البنكي أو عند الاستلام أو عبر الحساب الآجل.',
  },
  'orders.refund': {
    title: 'استرداد المبلغ',
    short: 'تتم عمليات استرداد البطاقات عبر مزوّد الخدمة؛ أما غيرها فيُسجَّل لها استرداد يدوي.',
  },
  'orders.resolve_refund': {
    title: 'تحديد نتيجة الاسترداد',
    short: 'يُغلق عملية استرداد متقطعة على أنها تمت أو لم تتم بعد التحقق من لوحة تحكم مزوّد الخدمة.',
  },
  'orders.resolve_refund_outcome': {
    title: 'النتيجة في لوحة تحكم مزوّد الخدمة',
    short: 'ما إذا كان هذا الاسترداد يظهر في قائمة معاملات iyzico أو PayTR.',
  },
  'orders.resolve_refund_note': {
    title: 'ملاحظة',
    short: 'ما الذي تحققت منه لاتخاذ القرار؛ يُسجَّل في سجل التدقيق.',
  },
  'orders.returns': {
    title: 'طلبات الإرجاع / الانسحاب',
    short:
      'طلبات الإرجاع والانسحاب والاستبدال التي يفتحها العملاء من صفحة طلبهم؛ الموافقة لا تعني استرداد المبلغ.',
  },
  'orders.address_place': {
    title: 'الولاية والقضاء',
    short:
      'بالنسبة للعناوين في تركيا، اختر الولاية والقضاء من القائمة. يجب أن يبدأ الرمز البريدي برمز الولاية.',
  },
  'orders.cancel_items': {
    title: 'إلغاء البنود المتبقية',
    short:
      'يلغي بنود طلب مشحون جزئيًا لا يمكن شحنها؛ ويُحرَّر المخزون المحجوز ويُبلَّغ العميل بالبريد الإلكتروني.',
  },
  'orders.exchange_ship': {
    title: 'شحن الاستبدال',
    short:
      'عند وصول المنتج المُرجَع، يشحن المنتج الجديد برقم تتبع؛ ويخرج المنتج المحجوز من المخزون ويكتمل الطلب.',
  },
  'orders.return_note': {
    title: 'ملاحظة / سبب',
    short: 'تُرسل إلى العميل بالبريد الإلكتروني وتظهر في صفحة طلبه. مطلوبة عند الرفض والإلغاء.',
  },
  'orders.restock': { title: 'إعادة إلى المخزون', short: 'يعيد المنتجات المُرجَعة إلى الدفعة نفسها.' },
  'orders.ship': {
    title: 'شحن',
    short:
      'ينشئ شحنة برقم تتبع؛ وتخرج الكميات المعبأة من المخزون. عندما لا يتبقى شيء للشحن، تصبح حالة الطلب «تم الشحن».',
  },
  'orders.ship_lines': {
    title: 'البنود في هذا الطرد',
    short: 'الكميات المشحونة في هذا الطرد. افتراضيًا كل ما لم يُشحن بعد؛ اضبط بندًا على 0 لتركه لطرد لاحق.',
  },
  'orders.manual_payment_method': {
    title: 'طريقة الدفع',
    short:
      'يدوي/تحويل بنكي: حدّده لاحقًا بـ «تم استلام الدفعة». حساب آجل/الدفع عند الاستلام: يُجهَّز الطلب مباشرةً.',
  },
  'page.page_designs': {
    title: 'تصاميم الصفحات',
    short: 'يختار أحد ثلاثة خيارات تصميم للقائمة العلوية وصفحة المقالات.',
  },
  'page_designs.header': {
    title: 'تصميم القائمة العلوية',
    short: 'ترتيب الشعار وعناصر القائمة والبحث والسلة في الرأس.',
  },
  'page_designs.articles': { title: 'تصميم المقالات', short: 'مظهر قائمة المدونة وصفحات الفئات والأرشيف.' },
  'page_designs.preview': { title: 'معاينة', short: 'يفتح الخيار في المتجر في متصفحك فقط دون نشر.' },
  'page_designs.publish': { title: 'نشر', short: 'يتيح الخيار لكل الزوار فورًا.' },
  'page_designs.history': {
    title: 'سجل التغييرات',
    short: 'آخر 30 تغييرًا: التاريخ والشخص والقسم والتغيير.',
  },
  'page.sales_points': { title: 'نقاط البيع', short: 'يدير الوكلاء المدرجين في صفحة «نقاط البيع» بالمتجر.' },
  'dealers.sales_points': { title: 'نقطة البيع', short: 'بيانات نشاط هذا الوكيل في صفحة «نقاط البيع».' },
  'sales_points.auto_add': {
    title: 'الإضافة التلقائية',
    short: 'يُضاف الوكلاء المعتمدون حديثًا من مواقعهم (مفعّل افتراضيًا).',
  },
  'sales_points.visible': {
    title: 'إظهار في المتجر',
    short: 'عند الإيقاف تُخفى النقطة في المتجر ويبقى السجل.',
  },
  'sales_points.name': { title: 'الاسم الظاهر', short: 'اسم المتجر أو النشاط الظاهر في المتجر.' },
  'sales_points.neighbourhood': {
    title: 'الحي',
    short: 'الأحياء من قائمة PTT؛ يمكن للزوار التصفية حسب الحي.',
  },
  'sales_points.pin': { title: 'الموقع (دبوس الخريطة)', short: 'إحداثيات أو رابط منسوخ من خرائط Google.' },
  'sales_points.phone': { title: 'هاتف المتجر', short: 'رقم النشاط الذي يتصل به الزوار.' },
  'sales_points.hours': {
    title: 'ساعات العمل',
    short: 'مفتوح/مغلق والساعات لكل يوم؛ لا تُعرض الأيام غير المحددة.',
  },
  'sales_points.note': { title: 'ملاحظة', short: 'ملاحظة قصيرة تحت البطاقة (مثل «يوجد موقف سيارات»).' },
  'sales_points.bulk': {
    title: 'إظهار/إخفاء جماعي',
    short: 'يُظهر النقاط المحددة أو يخفيها؛ يُسجَّل في سجل التدقيق.',
  },
  'sales_points.from_location': { title: 'إضافة من موقع', short: 'ينشئ نقطة بيع من أحد مواقع الوكيل.' },
  'sales_points.geocode': {
    title: 'تحديد الموقع من العنوان',
    short:
      'تُحدَّد مواقع نقاط البيع التي لا تحتوي على دبوس يدوي من عناوينها عبر OpenStreetMap (مفعّل افتراضيًا).',
  },
  'sales_points.backfill': {
    title: 'إنشاء من الوكلاء المعتمدين',
    short: 'يضيف نقطة بيع ظاهرة لكل وكيل معتمد ليس له نقطة، من مواقعه أو من عنوان الشركة.',
  },
  'sales_points.geocode_now': {
    title: 'تحديد المواقع الآن',
    short: 'يبحث فورًا عن عناوين ما يصل إلى 10 نقاط بانتظار الموقع (طلب واحد في الثانية).',
  },
  'sales_points.geocode_one': {
    title: 'تحديد الموقع من العنوان',
    short: 'يبحث عن هذه النقطة في OpenStreetMap ويحفظ النتيجة كدبوس.',
  },
  'page_designs.store_locator': {
    title: 'تصميم نقاط البيع',
    short: 'مظهر صفحة نقاط البيع وصفحات الولايات والمناطق.',
  },
  'page.design': { title: 'التصميم', short: 'غيّر ألوان واجهة المتجر وخطوطها وتخطيطها دون برمجة.' },
  'design.preview': {
    title: 'المعاينة على واجهة المتجر',
    short: 'يعرض المسودة على واجهة المتجر الفعلية لك وحدك (الرابط صالح لمدة ساعتين).',
  },
  'design.save': { title: 'حفظ المسودة', short: 'يحفظ التغييرات كمسودة؛ ولا تتغير واجهة المتجر.' },
  'design.publish': { title: 'نشر', short: 'يجعل المسودة عامة ويحفظها كنسخة جديدة.' },
  'design.revert_local': {
    title: 'تجاهل تغييراتي',
    short: 'يتجاهل التغييرات غير المحفوظة ويعرض المسودة المحفوظة.',
  },
  'design.discard': {
    title: 'العودة إلى السمة المنشورة',
    short: 'يحذف تغييرات المسودة غير المنشورة؛ فتطابق المسودة النسخة المنشورة.',
  },
  'design.templates': { title: 'القوالب', short: 'نقاط بداية جاهزة تغيّر الألوان والخطوط والتخطيط معًا.' },
  'design.palettes': {
    title: 'لوحات ألوان جاهزة',
    short: 'مجموعات ألوان مُتحقَّق من تباينها؛ مع الإبقاء على الخطوط والتخطيط.',
  },
  'design.color.background': { title: 'الخلفية', short: 'الخلفية الرئيسية للصفحة.' },
  'design.color.surface': {
    title: 'خلفية البطاقات والحقول',
    short: 'خلفية بطاقات المنتجات والترويسة والملخصات والحقول.',
  },
  'design.color.text': { title: 'النص', short: 'لون النص الأساسي والعناوين؛ يتطلب تباينًا لا يقل عن 4.5:1.' },
  'design.color.muted_text': {
    title: 'النص الثانوي',
    short: 'الأوصاف وأسماء العلامات التجارية والتواريخ؛ يتطلب تباينًا لا يقل عن 4.5:1.',
  },
  'design.color.border': { title: 'الفواصل والحدود', short: 'حدود البطاقات والخطوط الفاصلة.' },
  'design.color.primary': {
    title: 'اللون الأساسي',
    short: 'الروابط وعلامات التبويب المحددة والعناصر المميزة؛ يتطلب تباينًا لا يقل عن 4.5:1.',
  },
  'design.color.secondary': {
    title: 'اللون الثانوي',
    short: 'التسميات والشارات الثانوية؛ يُختار لون النص تلقائيًا.',
  },
  'design.color.accent': {
    title: 'لون التمييز',
    short: 'تسميات الحملات والخصومات؛ يُختار لون النص تلقائيًا.',
  },
  'design.color.button': { title: 'الزر', short: 'لون الأزرار الرئيسية مثل «أضف إلى السلة».' },
  'design.color.button_text': {
    title: 'نص الزر',
    short: 'النص على الأزرار الرئيسية؛ يتطلب تباينًا لا يقل عن 4.5:1.',
  },
  'design.color.button_hover': {
    title: 'الزر (عند التمرير فوقه)',
    short: 'لون الزر أثناء وجود المؤشر فوقه.',
  },
  'design.dark_mode': {
    title: 'المظهر الداكن',
    short: 'يستخدم ألوانًا داكنة منفصلة عندما يكون جهاز الزائر في الوضع الداكن.',
  },
  'design.font_body': {
    title: 'خط النص الأساسي',
    short: 'الخط المستخدم للنصوص والأسعار والنماذج. يُقدَّم مع واجهة المتجر.',
  },
  'design.font_heading': { title: 'خط العناوين', short: 'الخط المستخدم لعناوين الصفحات والمنتجات.' },
  'design.base_size': {
    title: 'حجم النص الأساسي',
    short: 'الحجم الأساسي للنص؛ وتتدرج أحجام العناوين انطلاقًا منه.',
  },
  'design.heading_scale': { title: 'أحجام العناوين', short: 'مقدار كِبَر العناوين مقارنةً بالنص الأساسي.' },
  'design.heading_weight': { title: 'سماكة العناوين', short: 'درجة سماكة خط العناوين.' },
  'design.radius': { title: 'استدارة الزوايا', short: 'زوايا البطاقات والحقول والصور (0 = زوايا حادة).' },
  'design.button_shape': { title: 'شكل الزر', short: 'أزرار مربعة أو مستديرة الزوايا أو على شكل كبسولة.' },
  'design.shadow': { title: 'الظل', short: 'الظل المستخدم على البطاقات البارزة ومربعات الملخص.' },
  'design.card_style': { title: 'بطاقة المنتج', short: 'بطاقات منتجات بحدود أو مسطحة أو بارزة.' },
  'design.image_ratio': { title: 'نسبة أبعاد صورة المنتج', short: 'شكل منطقة الصورة في قوائم المنتجات.' },
  'design.grid_desktop': {
    title: 'الأعمدة على أجهزة الكمبيوتر',
    short: 'عدد المنتجات في كل صف على الشاشات العريضة؛ وتستخدم الأجهزة اللوحية 3 كحد أقصى.',
  },
  'design.grid_mobile': { title: 'الأعمدة على الهواتف', short: 'منتج واحد أو منتجان في كل صف على الهواتف.' },
  'design.header_layout': { title: 'موضع الشعار', short: 'الشعار على اليسار أو في المنتصف داخل الترويسة.' },
  'design.header_style': { title: 'خلفية الترويسة', short: 'ترويسة فاتحة أو باللون الأساسي.' },
  'design.header_sticky': { title: 'ترويسة ثابتة', short: 'تُبقي الترويسة في الأعلى أثناء التمرير.' },
  'design.footer_style': { title: 'خلفية التذييل', short: 'تذييل فاتح أو داكن أو باللون الأساسي.' },
  'design.gallery': {
    title: 'صورة صفحة المنتج',
    short: 'صورة المنتج على اليسار أو اليمين على الشاشات العريضة.',
  },
  'design.blog_layout': { title: 'صفحة المدونة', short: 'مقالات المدونة على شكل شبكة أو قائمة.' },
  'design.input_style': { title: 'حقول النماذج', short: 'حقول نماذج بإطار أو بخلفية ملوّنة.' },
  'design.live_preview': {
    title: 'المعاينة المباشرة',
    short: 'كيف تبدو التغييرات على صفحة نموذجية من واجهة المتجر قبل الحفظ.',
  },
  'design.device': { title: 'الجهاز', short: 'يعرض المعاينة بعرض الهاتف أو الجهاز اللوحي أو الكمبيوتر.' },
  'design.contrast': {
    title: 'فحص قابلية القراءة',
    short: 'يتحقق من تباين WCAG AA (لا يقل عن 4.5:1) بين النص والخلفيات.',
  },
  'design.versions': { title: 'سجل النسخ', short: 'كل سمة منشورة وتاريخ نشرها ومن نشرها.' },
  'design.rollback': {
    title: 'العودة إلى هذه النسخة',
    short: 'يعيد نشر النسخة المحددة ويحمّلها في المسودة.',
  },
  'design.note': { title: 'ملاحظة النسخة', short: 'سبب النشر؛ تظهر في سجل النسخ.' },
  'page.menus': {
    title: 'القوائم',
    short: 'عدّل قائمة الترويسة (القائمة الموسّعة) وقائمة التذييل في واجهة المتجر.',
  },
  'menus.location': { title: 'موضع القائمة', short: 'قائمة الترويسة أو التذييل؛ تُحفظ كل منهما على حدة.' },
  'menus.add': { title: 'إضافة عنصر', short: 'يضيف عنصرًا جديدًا في المستوى الأعلى في النهاية.' },
  'menus.add_child': { title: 'إضافة عنصر فرعي', short: 'يضيف عنصرًا أسفل هذا العنصر.' },
  'menus.label': { title: 'الاسم المعروض في القائمة', short: 'النص الذي يراه الزوار (60 حرفًا كحد أقصى).' },
  'menus.link': {
    title: 'الرابط',
    short: 'وجهة العنصر: فئة، أو منتج، أو جميع المنتجات، أو صفحة، أو عنوان URL، أو نص عنوان دون رابط.',
  },
  'menus.category': { title: 'الفئة', short: 'الفئة المراد الربط بها. لا تُعرض الفئات المخفية.' },
  'menus.product': { title: 'المنتج', short: 'ابحث بالاسم أو SKU أو الباركود واختر منتجًا.' },
  'menus.url': { title: 'العنوان', short: 'مسار في الموقع (مثل /iletisim) أو عنوان كامل يبدأ بـ https://.' },
  'menus.new_tab': { title: 'فتح في علامة تبويب جديدة', short: 'للروابط المؤدية إلى مواقع أخرى.' },
  'menus.move': { title: 'إعادة الترتيب', short: 'ينقل العنصر لأعلى أو لأسفل ضمن مستواه.' },
  'menus.remove': { title: 'إزالة', short: 'يزيل العنصر وعناصره الفرعية (تتغير واجهة المتجر عند الحفظ).' },
  'menus.save': { title: 'حفظ القائمة', short: 'يحفظ القائمة للموضع المحدد.' },
  'menus.page': {
    title: 'الصفحة',
    short: 'صفحة تعريفية بالشركة أو صفحة حملة؛ تظهر في القائمة فقط ما دامت منشورة.',
  },
  'menus.unavailable': {
    title: 'الوجهة غير مرئية',
    short: 'الفئة مخفية، أو المنتج أو الصفحة غير منشورين؛ لذلك لا يُعرض العنصر.',
  },
  'page.pages': {
    title: 'الصفحات',
    short: 'أنشئ تخطيط الصفحة الرئيسية وصفحات الشركة وصفحات الحملات قسمًا تلو الآخر.',
  },
  'page.page_editor': { title: 'محرر الصفحات', short: 'عدّل عنوان الصفحة ومسارها وبيانات SEO والأقسام.' },
  'pages.create': { title: 'صفحة جديدة', short: 'ينشئ صفحة بصفة مسودة ويفتح المحرر.' },
  'pages.kind': {
    title: 'نوع الصفحة',
    short:
      'تخطيط الصفحة الرئيسية (واحد لكل متجر، على «/»)، أو صفحة الشركة، أو صفحة حملة (على /sayfa/short-name).',
  },
  'pages.title': {
    title: 'عنوان الصفحة',
    short: 'يظهر في لوحة التحكم وعلى واجهة المتجر (120 حرفًا كحد أقصى).',
  },
  'pages.slug': {
    title: 'الاسم المختصر (المسار)',
    short:
      'أحرف لاتينية صغيرة وأرقام وشرطات. في الصفحة المنشورة يتغير عند الحفظ ويُعاد توجيه المسار القديم (يتطلب صلاحية النشر).',
  },
  'pages.seo_title': {
    title: 'عنوان SEO',
    short: 'يظهر في نتائج البحث وعلامة تبويب المتصفح (70 حرفًا كحد أقصى).',
  },
  'pages.seo_description': {
    title: 'وصف SEO',
    short: 'نص قصير أسفل العنوان في نتائج البحث (170 حرفًا كحد أقصى).',
  },
  'pages.health_content': {
    title: 'المحتوى الصحي',
    short: 'تتطلب الصفحات المتعلقة بصحة الحيوانات الأليفة موافقة المراجع البيطري المختص قبل النشر.',
  },
  'pages.preview': {
    title: 'معاينة',
    short:
      'يحفظ التغييرات ويفتح المسودة على واجهة المتجر في علامة تبويب جديدة (رابط موقّع صالح لمدة ساعتين).',
  },
  'pages.save': { title: 'حفظ المسودة', short: 'يحفظ التغييرات كمسودة؛ ولا تتغير واجهة المتجر.' },
  'pages.publish': {
    title: 'نشر',
    short: 'ينشر المسودة كنسخة جديدة، مع إمكانية تحديد تاريخ بدء وتاريخ انتهاء.',
  },
  'pages.schedule': {
    title: 'تاريخا النشر والانتهاء',
    short: 'اتركه فارغًا للنشر الآن دون تاريخ انتهاء. يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء.',
  },
  'pages.unpublish': {
    title: 'إلغاء النشر',
    short: 'يزيل الصفحة من واجهة المتجر؛ مع الاحتفاظ بالمسودات والنسخ.',
  },
  'pages.delete': { title: 'حذف الصفحة', short: 'يحذف نهائيًا صفحة لم تُنشر قط.' },
  'pages.review': {
    title: 'مراجعة المختص',
    short: 'يوافق المراجع البيطري المختص أو يرفض مع ذكر السبب. ترتبط الموافقة بالمحتوى الحالي.',
  },
  'pages.review_note': { title: 'ملاحظة المراجعة', short: 'مطلوبة عند الرفض: أخبر المحرر بما يجب تصحيحه.' },
  'pages.section_add': { title: 'إضافة قسم', short: 'يضيف قسمًا من النوع المختار في النهاية (40 كحد أقصى).' },
  'pages.section_hide': { title: 'إخفاء القسم', short: 'يُبقي القسم في المسودة لكنه يخفيه في واجهة المتجر.' },
  'pages.section_move': { title: 'نقل القسم', short: 'ينقل القسم لأعلى أو لأسفل.' },
  'pages.section_remove': { title: 'إزالة القسم', short: 'يزيل القسم من المسودة.' },
  'pages.heading': {
    title: 'عنوان القسم',
    short: 'يظهر فوق القسم. عنوان أول قسم رئيسي (Hero) هو عنوان الصفحة.',
  },
  'pages.cta': {
    title: 'الزر',
    short: 'نص زر القسم الرئيسي (Hero) ورابطه (مثل /urunler أو عنوان يبدأ بـ https://).',
  },
  'pages.rich_text': {
    title: 'محرر النصوص',
    short:
      'فقرات وعناوين وخط عريض ومائل وقوائم واقتباسات وخطوط فاصلة وروابط وصور (النص البديل مطلوب). انقل أي كتلة بالسحب أو بزرَّي الأعلى/الأسفل.',
  },
  'pages.image': { title: 'رفع صورة', short: 'يرفع صورة بصيغة PNG أو JPEG أو WebP أو AVIF أو GIF.' },
  'pages.image_alt': { title: 'النص البديل', short: 'صِف باختصار ما تعرضه الصورة. مطلوب.' },
  'pages.image_position': {
    title: 'موضع الصورة',
    short: 'الصورة على يسار النص أو يمينه على أجهزة الكمبيوتر.',
  },
  'pages.grid_source': { title: 'مصدر المنتجات', short: 'أحدث المنتجات، أو فئة، أو منتجات تختارها بنفسك.' },
  'pages.grid_collection': { title: 'المجموعة', short: 'إحدى المجموعات ضمن الكتالوج ← المجموعات.' },
  'pages.grid_brand': {
    title: 'العلامة التجارية',
    short: 'المنتجات المنشورة للعلامة التجارية؛ ويفتح «عرض الكل» صفحة العلامة التجارية.',
  },
  'pages.grid_limit': { title: 'عدد المنتجات', short: 'عدد المنتجات المراد عرضها (2–24).' },
  'pages.products': {
    title: 'المنتجات المختارة',
    short: 'ابحث عن المنتجات وأضفها (24 كحد أقصى)؛ وتُعرض بهذا الترتيب.',
  },
  'pages.tiles': { title: 'مربعات الفئات', short: 'فئات معروضة على شكل مربعات. لا تُعرض الفئات المخفية.' },
  'pages.faq': { title: 'سؤال وجواب', short: 'كل إدخال في الأسئلة الشائعة؛ يُعرض كقائمة قابلة للتوسيع.' },
  'page.banners': {
    title: 'اللافتات',
    short:
      'إدارة شريط العرض في الصفحة الرئيسية والمربعات الترويجية ولافتة الفئة وشريط الإعلانات والنافذة المنبثقة.',
  },
  'page.banner_editor': {
    title: 'محرر اللافتات',
    short: 'موضع اللافتة ونصها وصورها والفئة المستهدفة وتواريخها.',
  },
  'banners.create': { title: 'لافتة جديدة', short: 'ينشئ لافتة بصفة مسودة؛ ولا تُعرض حتى يتم تفعيلها.' },
  'banners.placement': {
    title: 'الموضع',
    short:
      'شريط العرض في الصفحة الرئيسية، أو المنطقة الثانوية في الصفحة الرئيسية، أو أعلى صفحة الفئة، أو شريط الإعلانات، أو نافذة منبثقة.',
  },
  'banners.name': { title: 'الاسم الداخلي', short: 'يظهر في لوحة التحكم فقط.' },
  'banners.title': { title: 'العنوان', short: 'النص الكبير على اللافتة (120 حرفًا كحد أقصى).' },
  'banners.text': { title: 'النص', short: 'نص قصير (300 حرف كحد أقصى). مطلوب لشريط الإعلانات.' },
  'banners.cta': { title: 'نص الزر', short: 'بدون نص للزر، تصبح اللافتة كلها هي الرابط.' },
  'banners.href': {
    title: 'عنوان الرابط',
    short: 'مسار في الموقع (مثل /urunler) أو عنوان يبدأ بـ https://.',
  },
  'banners.desktop_image': {
    title: 'صورة سطح المكتب',
    short: 'مطلوبة لشريط العرض والمنطقة الثانوية وأعلى صفحة الفئة.',
  },
  'banners.mobile_image': { title: 'صورة الجوال', short: 'اختيارية؛ تُستخدم صورة سطح المكتب إذا لم تتوفر.' },
  'banners.image_alt': { title: 'النص البديل', short: 'صِف الصورة. مطلوب عند وجود صورة.' },
  'banners.audience': {
    title: 'الفئة المستهدفة',
    short: 'الجميع، أو غير الموزّعين، أو الموزّعون المعتمدون فقط.',
  },
  'banners.dates': { title: 'البداية والنهاية', short: 'الفارغ يعني من التفعيل حتى الإيقاف.' },
  'banners.dismiss_days': {
    title: 'الإخفاء بعد الإغلاق',
    short: 'عدد الأيام التي تبقى فيها النافذة المنبثقة مخفية بعد أن يغلقها الزائر.',
  },
  'banners.categories': { title: 'الفئات', short: 'أماكن ظهور لافتة الفئة؛ وعدم الاختيار يعني جميع الفئات.' },
  'banners.save': { title: 'حفظ', short: 'يحفظ اللافتة؛ وتُطبَّق التغييرات على اللافتة النشطة فورًا.' },
  'banners.activate': { title: 'تفعيل', short: 'يعرض اللافتة بين تاريخي البدء والانتهاء.' },
  'banners.deactivate': { title: 'إيقاف', short: 'يزيل اللافتة من واجهة المتجر فورًا.' },
  'banners.move': { title: 'إعادة الترتيب', short: 'ينقل اللافتة ضمن موضعها؛ ويتبع شريط العرض هذا الترتيب.' },
  'banners.delete': { title: 'حذف اللافتة', short: 'يحذف لافتة غير نشطة نهائيًا.' },
  'pages.post_list': {
    title: 'مقالات المدونة',
    short: 'يعرض أحدث المقالات المنشورة من الفئة المختارة (1–12).',
  },
  'pages.banners': { title: 'منطقة اللافتات', short: 'يعرض اللافتات النشطة في المنطقة المختارة.' },
  'products.media_alt': {
    title: 'النص البديل للصورة',
    short: 'صف الصورة؛ إذا تُرك الحقل فارغًا يُستخدم اسم المنتج.',
  },
  'products.media_order': {
    title: 'ترتيب الصور',
    short: 'الصورة الأولى هي صورة الغلاف؛ ويتبع معرض الصور هذا الترتيب.',
  },
  'page.blog': { title: 'المدونة', short: 'إدارة المقالات والأدلة وتصنيفات المدونة.' },
  'page.post_editor': {
    title: 'محرر المقالات',
    short: 'عنوان المقالة ونصها وصورة الغلاف والمراجع والمنتجات ذات الصلة وإعدادات SEO.',
  },
  'blog.create': { title: 'مقالة جديدة', short: 'ينشئ مقالة بصفة مسودة ويفتح المحرر.' },
  'blog.filter': { title: 'تصفية', short: 'الكل، أو بانتظار موافقة المختص، أو المنشورة، أو المسودات.' },
  'page.content_calendar': {
    title: 'تقويم المحتوى',
    short: 'أحداث النشر المخططة والسابقة خلال الشهر: المقالات والصفحات واللافتات، يومًا بيوم.',
  },
  'content_calendar.month': {
    title: 'اختيار الشهر',
    short:
      'انتقل إلى الشهر السابق أو التالي؛ ويعيدك «هذا الشهر» إلى اليوم الحالي. تُحتسب حدود الشهر بتوقيت تركيا.',
  },
  'content_calendar.kind': {
    title: 'النوع',
    short: 'اقصر التقويم على مقالات المدونة أو الصفحات أو اللافتات.',
  },
  'page.content_report': {
    title: 'تقرير المحتوى',
    short:
      'حالات المقالات والصفحات واللافتات؛ والنشر حسب التصنيف والشهر؛ والمقالات التي لم تُحدَّث منذ مدة طويلة؛ ونقرات Search Console.',
  },
  'content_report.states': {
    title: 'ملخص الحالات',
    short: 'منشور: ظاهر في واجهة المتجر. مخطط: مجدول للنشر. مسودة: لم يُنشر قط. منتهٍ: انقضى تاريخ الانتهاء.',
  },
  'content_report.stale': {
    title: 'مقالات لم تُحدَّث',
    short:
      'المقالات المنشورة التي مضى على آخر نسخة منشورة منها أكثر من 365 يومًا، مرتبة من الأقدم. راجعها وأعد نشرها.',
  },
  'content_report.search_console': {
    title: 'نقرات Search Console',
    short:
      'آخر 28 يومًا من خاصية Search Console المرتبطة: النقرات ومرات الظهور ونسبة النقر (CTR) ومتوسط الترتيب لكل مقالة. بلغة واجهة المتجر فقط.',
  },
  'page.forms': {
    title: 'النماذج',
    short: 'تعديل حقول نموذج الاتصال والحقول الإضافية في طلب الانضمام كموزّع.',
  },
  'forms.kind': {
    title: 'النموذج',
    short:
      'نموذج الاتصال: جميع الحقول قابلة للتعديل. طلب الموزّع: حقول الشركة والضرائب ثابتة؛ يمكن إضافة حقول إضافية فقط.',
  },
  'forms.enabled': {
    title: 'عرض النموذج في صفحة الاتصال',
    short: 'عند التفعيل يظهر النموذج في صفحة الاتصال بواجهة المتجر. ولا يمكن تفعيله قبل نشر إشعار الخصوصية.',
  },
  'forms.notify': {
    title: 'إشعار بالبريد الإلكتروني عند وصول رسائل جديدة',
    short:
      'يتلقى المالكون والمسؤولون رسالة بريد إلكتروني دون محتوى الرسالة، مع رابط إلى لوحة التحكم؛ مرة واحدة كل 15 دقيقة على الأكثر.',
  },
  'forms.fields': {
    title: 'حقول النموذج',
    short:
      'التسمية والنوع والنص المساعد وعلامة الإلزام لكل حقل؛ غيّر الترتيب بالأسهم. حقل البريد الإلكتروني في نموذج الاتصال إلزامي ولا يمكن حذفه.',
  },
  'forms.add_field': { title: 'إضافة حقل', short: 'يضيف حقل نص قصير فارغًا في النهاية (20 حقلًا كحد أقصى).' },
  'forms.save': { title: 'حفظ النموذج', short: 'يحفظ الحقول والإعدادات؛ وتُطبَّق فورًا.' },
  'forms.label': {
    title: 'التسمية',
    short:
      'اسم الحقل الذي يظهر للزوار (80 حرفًا كحد أقصى). إذا تُرك فارغًا في حقل معدّ مسبقًا تُستخدم التسمية الافتراضية.',
  },
  'forms.type': {
    title: 'نوع الحقل',
    short:
      'يُتحقق من الإدخال حسب النوع: بريد إلكتروني، هاتف، رقم، تاريخ؛ وقائمة الاختيار لا تقبل إلا خياراتها.',
  },
  'forms.help_text': { title: 'النص المساعد', short: 'ملاحظة قصيرة تظهر أسفل الحقل (200 حرف كحد أقصى).' },
  'forms.options': { title: 'الخيارات', short: 'خيار واحد في كل سطر (من 2 إلى 30، وكلها مختلفة).' },
  'forms.required': { title: 'حقل إلزامي', short: 'يجب على الزوار تعبئته؛ ويجب تحديد مربع الاختيار.' },
  'page.contact_messages': {
    title: 'رسائل الاتصال',
    short: 'الرسائل المرسلة عبر نموذج الاتصال في واجهة المتجر.',
  },
  'messages.filter': { title: 'عرض', short: 'الرسائل الجديدة (غير المعالجة)، أو المعالجة، أو الكل.' },
  'messages.handle': {
    title: 'تعليم كمعالجة',
    short: 'يسجّل أنك قمت بالرد؛ ويمكن التراجع عبر «تعليم كجديدة».',
  },
  'messages.delete': { title: 'حذف الرسالة', short: 'يحذف الرسالة نهائيًا (لا يمكن التراجع عن ذلك).' },
  'topbar.store': {
    title: 'المتجر الحالي',
    short:
      'تختار شاشات لوحة التحكم هذا المتجر افتراضيًا؛ وتغيير المتجر في أي شاشة يغيّره أيضًا. يُحفظ في هذا المتصفح.',
  },
  'topbar.jobs': {
    title: 'المهام في الخلفية',
    short:
      'تقدّم المهام الطويلة (الاستيراد، والإجراءات الجماعية على المنتجات، وفحص الموقع، وسرعة الصفحات). المهام الجارية وتلك التي انتهت خلال آخر 10 دقائق.',
  },
  'system.observability': {
    title: 'المراقبة (OpenTelemetry)',
    short:
      'تُرسَل مدد الطلبات ومهام الخلفية ومعدلات الأخطاء والتتبّعات إلى مُجمِّع (Grafana Cloud أو Honeycomb أو New Relic أو OpenTelemetry Collector خاص بك). لا بيانات شخصية: فقط الطريقة وقالب المسار ورمز الحالة واسم المهمة. فعّلها من التكاملات ← المراقبة.',
  },
  'system.csp_reports': {
    title: 'مخالفات أمان المحتوى في المتجر',
    short:
      'عندما تحظر سياسة أمان المتجر نصًا برمجيًا أو صورة أو إطارًا أو اتصالًا غير مسموح به، يُبلغ متصفح الزائر عن ذلك. يظهر هنا وسم أو فيديو أُضيف حديثًا ولا يعمل، أو محاولة لحقن تعليمات برمجية في صفحة. يُحفظ ملخص فقط (القاعدة، النطاق المحظور، مسار الصفحة، العدد، التاريخ)؛ بلا بيانات شخصية أو عناوين IP أو بلاغات إضافات المتصفح. تُحذف السجلات التي لم تظهر منذ 30 يومًا.',
  },
  'system.offsite': {
    title: 'نسخة احتياطية خارج الموقع',
    short:
      'تُشفَّر النسخة الاحتياطية الليلية وتُرفع إلى تخزين الكائنات (S3 / R2). فعّلها من التكاملات ← تخزين الكائنات.',
  },
  'page.marketing_audience': {
    title: 'المشتركون والموافقات',
    short: 'مشتركو النشرة البريدية وقائمة الحظر وسجلات موافقات İYS.',
  },
  'audience.subscribers': {
    title: 'مشتركو النشرة البريدية',
    short: 'اشتركوا عبر نموذج واجهة المتجر (تأكيد مزدوج).',
  },
  'audience.status': { title: 'الحالة', short: 'مشترك، أو بانتظار التأكيد، أو ملغى الاشتراك، أو الكل.' },
  'audience.search': {
    title: 'البحث عن بريد إلكتروني',
    short: 'يبحث بجزء من العنوان (يتطلب صلاحية البيانات الشخصية).',
  },
  'audience.subscriber_actions': {
    title: 'إنهاء الاشتراك / حذف',
    short:
      'يؤدي الإنهاء إلى إضافة العنوان إلى قائمة الحظر وإبلاغ İYS بالرفض. أما الحذف فمخصص لطلبات الخصوصية.',
  },
  'audience.suppressions': { title: 'قائمة الحظر', short: 'لا تُرسل أي رسائل تسويقية إلى هذه العناوين.' },
  'audience.channel': { title: 'القناة', short: 'البريد الإلكتروني أو الرسائل النصية (SMS) أو WhatsApp.' },
  'audience.address': { title: 'العنوان', short: 'عنوان البريد الإلكتروني أو رقم الهاتف.' },
  'audience.note': { title: 'ملاحظة', short: 'سبب الحظر.' },
  'audience.suppress': { title: 'حظر', short: 'يضيف العنوان إلى القائمة ويبلغ İYS بالرفض.' },
  'audience.channel_filter': { title: 'القناة', short: 'يصفّي القائمة حسب القناة.' },
  'audience.unsuppress': { title: 'إزالة', short: 'يرفع الحظر؛ ويجب منح الموافقة من جديد.' },
  'audience.iys': {
    title: 'سجلات İYS',
    short: 'يجب أن تصل الموافقات وحالات الرفض إلى İYS خلال ثلاثة أيام عمل.',
  },
  'audience.iys_filter': {
    title: 'عرض',
    short: 'السجلات المطلوب إبلاغها، أو المرسلة، أو المُبلَّغ عنها يدويًا، أو الكل.',
  },
  'audience.iys_download': { title: 'تنزيل الملف (CSV)', short: 'السجلات المطلوب إبلاغها، بأسماء حقول İYS.' },
  'audience.iys_mark': { title: 'تعليم كمُبلَّغ عنها', short: 'يعلّم السجلات التي رفعتها في لوحة İYS.' },
  'page.segments': { title: 'الشرائح', short: 'مجموعات RFM وشرائح العملاء القائمة على القواعد.' },
  'page.segment_editor': { title: 'الشريحة', short: 'اسم الشريحة وقواعدها ومعاينتها وأعضاؤها.' },
  'segments.rfm': {
    title: 'مجموعات RFM',
    short: 'تُقيَّم الحداثة والتكرار والإنفاق من 1 إلى 5؛ وتُحدَّد المجموعات بناءً على الدرجات.',
  },
  'segments.recompute': {
    title: 'إعادة الحساب الآن',
    short: 'يحدّث درجات RFM وأعداد الشرائح (يعمل كل ليلة).',
  },
  'segments.save_rfm': { title: 'حفظ كشريحة', short: 'يحفظ مجموعة RFM هذه كشريحة لاستخدامها في الحملات.' },
  'segments.list': {
    title: 'الشرائح',
    short: 'الأعداد مأخوذة من آخر عدّ (عند الحفظ أو إعادة الحساب أو ليلًا).',
  },
  'segments.name': { title: 'الاسم', short: 'يظهر عند اختيار الجمهور؛ ويجب أن يكون فريدًا.' },
  'segments.description': { title: 'الوصف', short: 'الغرض من الشريحة.' },
  'segments.match': { title: 'المطابقة', short: 'جميع الشروط، أو أيٌّ منها.' },
  'segments.conditions': {
    title: 'الشروط',
    short: 'حتى 10 شروط. يُحتسب الإنفاق بعد خصم المبالغ المستردة والإلغاءات.',
  },
  'segments.preview': { title: 'معاينة', short: 'يعرض عدد المطابقات وأول 10 عملاء دون حفظ.' },
  'segments.save': { title: 'حفظ', short: 'يحفظ الشريحة ويحدّث عددها.' },
  'segments.delete': { title: 'حذف', short: 'يحذف الشريحة؛ ولا يتأثر العملاء.' },
  'segments.members': {
    title: 'العملاء في الشريحة',
    short: 'العملاء المطابقون حاليًا؛ تُخفى عناوين البريد الإلكتروني دون صلاحية البيانات الشخصية.',
  },
  'customers.tags': {
    title: 'الوسوم',
    short: 'تسميات تُستخدم للتصفية وفي قواعد الشرائح (30 كحد أقصى)؛ وتُدرج في نسخ البيانات وفق KVKK.',
  },
  'customers.save_tags': { title: 'حفظ الوسوم', short: 'يحفظ الوسوم.' },
  'customers.tag_filter': { title: 'الوسم', short: 'يصفّي القائمة حسب الوسم.' },
  'customers.summary': {
    title: 'ملخص العميل',
    short:
      'مباشرةً من الطلبات: الإنفاق الإجمالي وخلال آخر 12 شهرًا، والطلبات، ومتوسط قيمة السلة، والفاصل بين الطلبات، وRFM.',
  },
  'customers.notes': { title: 'ملاحظات داخلية', short: 'ملاحظات الفريق؛ وتُدرج في نسخ البيانات وفق KVKK.' },
  'customers.save_notes': { title: 'حفظ الملاحظة', short: 'يحفظ الملاحظة (تُسجَّل في سجل التدقيق).' },
  'customers.timeline': {
    title: 'النشاط',
    short: 'الطلبات والمرتجعات والتقييمات والأسئلة والموافقات والرسائل وطلبات KVKK في قائمة واحدة.',
  },
  'email_routing.transactional': {
    title: 'رسائل البريد الإلكتروني الخاصة بالمعاملات',
    short: 'الطلبات والشحن وكلمات المرور والدعوات.',
  },
  'email_routing.marketing': {
    title: 'رسائل البريد الإلكتروني التسويقية',
    short: 'النشرات البريدية والحملات؛ ويحمي مسار الإرسال المنفصل السمعة.',
  },
  'email_routing.save': { title: 'حفظ خيار الإرسال', short: 'يسري فورًا.' },
  'email_routing.webhooks': {
    title: 'روابط الإشعارات',
    short: 'العناوين التي يرسل إليها المزوّد أحداث الارتداد والشكاوى وإلغاء الاشتراك.',
  },
  'email_routing.rotate': { title: 'إعادة إنشاء الروابط', short: 'تتوقف الروابط القديمة عن العمل فورًا.' },
  'page.email_templates': {
    title: 'قوالب البريد الإلكتروني',
    short: 'قوالب قائمة على الكتل للنشرات البريدية والحملات.',
  },
  'page.email_template_editor': {
    title: 'قالب البريد الإلكتروني',
    short: 'أضف الكتل ورتّبها؛ وعاين القالب وأرسل رسالة تجريبية إلى نفسك.',
  },
  'email_templates.create': { title: 'قالب جديد', short: 'يفتح قالبًا فارغًا في المتجر واللغة المختارين.' },
  'email_templates.save': { title: 'حفظ', short: 'يحفظ القالب؛ ويُعاد التحقق من الادعاءات الصحية.' },
  'email_templates.name': { title: 'اسم القالب', short: 'يظهر في لوحة التحكم فقط.' },
  'email_templates.subject': { title: 'الموضوع', short: 'الموضوع الظاهر في صندوق الوارد، حتى 200 حرف.' },
  'email_templates.preheader': {
    title: 'النص التمهيدي',
    short: 'نص قصير يظهر بجانب الموضوع في صندوق الوارد.',
  },
  'email_templates.merge_fields': {
    title: 'حقول التخصيص',
    short: 'يُستخدم النص الوارد بعد الشريط العمودي عند عدم وجود قيمة.',
  },
  'email_templates.blocks': { title: 'كتل المحتوى', short: 'حتى 40 كتلة؛ والكتل غير المكتملة تمنع الحفظ.' },
  'email_templates.move': { title: 'إعادة الترتيب', short: 'اسحب من المقبض أو استخدم أزرار الأسهم.' },
  'email_templates.add_block': { title: 'إضافة كتلة', short: 'يضيف الكتلة إلى نهاية القالب.' },
  'email_templates.delete': { title: 'حذف', short: 'يحذف القالب؛ وتبقى اللغات الأخرى.' },
  'email_templates.align': { title: 'المحاذاة', short: 'يسار أو وسط.' },
  'email_templates.heading': { title: 'العنوان', short: 'حتى 200 حرف.' },
  'email_templates.level': { title: 'الحجم', short: 'عنوان كبير أو عنوان فرعي.' },
  'email_templates.text': { title: 'النص', short: 'نص عادي؛ سطر فارغ للفقرات، و**غامق**.' },
  'email_templates.image': { title: 'الصورة', short: 'PNG أو JPEG أو WebP أو GIF؛ ويكفي عرض 1200 بكسل.' },
  'email_templates.image_alt': {
    title: 'وصف الصورة',
    short: 'يظهر عند تعطيل عرض الصور؛ وهو إلزامي للصور المرتبطة برابط.',
  },
  'email_templates.link': { title: 'الرابط', short: 'مسار داخل المتجر (/campaign) أو عنوان http(s) كامل.' },
  'email_templates.width': { title: 'العرض', short: 'عرض كامل أو نصف عرض في المنتصف.' },
  'email_templates.button_label': { title: 'نص الزر', short: 'نص قصير يوضح ما سيحدث.' },
  'email_templates.products_source': {
    title: 'مصدر المنتجات',
    short: 'الأحدث، أو مجموعة، أو تصنيف، أو منتجات مختارة يدويًا.',
  },
  'email_templates.columns': { title: 'الأعمدة', short: 'البطاقات جنبًا إلى جنب على شاشة الحاسوب.' },
  'email_templates.limit': { title: 'عدد المنتجات', short: 'من 1 إلى 12 منتجًا من المصدر.' },
  'email_templates.collection': { title: 'المجموعة', short: 'المنتجات المطابقة للمجموعة، مرتبة حسب الاسم.' },
  'email_templates.category': { title: 'التصنيف', short: 'منتجات التصنيف، مرتبة حسب الاسم.' },
  'email_templates.products_pick': {
    title: 'المنتجات',
    short: 'ابحث بالاسم أو SKU أو الباركود؛ ويُحتفظ بالترتيب.',
  },
  'email_templates.show_price': { title: 'عرض السعر', short: 'أدنى سعر شامل للضريبة وقت الإرسال.' },
  'email_templates.spacer': { title: 'فاصل', short: 'يضيف مسافة عمودية.' },
  'email_templates.cart': { title: 'كتلة سلة التسوق', short: 'تُملأ في أتمتة السلة المتروكة.' },
  'email_templates.order': { title: 'كتلة الطلب', short: 'تُملأ في عمليات الأتمتة التالية للشراء.' },
  'email_templates.quote': { title: 'كتلة عرض السعر', short: 'تُملأ في أتمتة متابعة عروض أسعار الموزّعين.' },
  'email_templates.preview': { title: 'معاينة', short: 'تتحدّث أثناء الكتابة؛ والحقول الشخصية قيم نائبة.' },
  'email_templates.device': { title: 'الشاشة والتنسيق', short: 'الحاسوب والهاتف والنسخة النصية العادية.' },
  'email_templates.test_send': {
    title: 'إرسال رسالة تجريبية',
    short: 'يرسل النسخة المحفوظة إلى مستخدمي لوحة التحكم فقط.',
  },
  'email_templates.test_to': {
    title: 'المستلمون',
    short: 'عناوين البريد الإلكتروني لمستخدمي لوحة التحكم، حتى 5.',
  },
  'page.campaigns': {
    title: 'حملات البريد الإلكتروني',
    short: 'أرسل قالبًا إلى جمهور؛ وتابع التقدم والنتائج.',
  },
  'page.campaign_editor': {
    title: 'حملة البريد الإلكتروني',
    short: 'القالب والموضوع والجمهور واختبار A/B والسرعة؛ والإرسال والتقرير.',
  },
  'campaigns.create': { title: 'حملة جديدة', short: 'يفتح حملة بصفة مسودة للمتجر المختار.' },
  'campaigns.save': { title: 'حفظ', short: 'يحفظ المسودة؛ ولا تُرسل أي رسالة بريد إلكتروني.' },
  'campaigns.name': { title: 'اسم الحملة', short: 'يُستخدم في التقارير وفي رمز الحملة ضمن الروابط.' },
  'campaigns.template': {
    title: 'قالب البريد الإلكتروني',
    short: 'القالب الرئيسي؛ وتُرسل النسخ باللغات الأخرى إلى مستلميها.',
  },
  'campaigns.subject': { title: 'الموضوع', short: 'يحل محل موضوع القالب لمستلمي اللغة الرئيسية.' },
  'campaigns.preheader': { title: 'النص التمهيدي', short: 'يحل محل النص التمهيدي للقالب.' },
  'campaigns.audience': { title: 'الجمهور', short: 'تُقيَّم الشرائح عند بدء الإرسال.' },
  'campaigns.subscribers': { title: 'مشتركو النشرة البريدية', short: 'المشتركون المؤكَّدون في هذا المتجر.' },
  'campaigns.estimate': {
    title: 'عدّ المستلمين',
    short: 'يعرض عدد من يمكنهم استلامها وسبب استبعاد الآخرين.',
  },
  'campaigns.ab': { title: 'اختبار A/B', short: 'يُرسل الموضوع صاحب معدل النقر الأعلى إلى بقية المستلمين.' },
  'campaigns.subject_b': { title: 'الموضوع B', short: 'الموضوع A هو موضوع الحملة (أو القالب).' },
  'campaigns.ab_percent': { title: 'مجموعة الاختبار', short: 'نسبة المستلمين في الاختبار (10–50%).' },
  'campaigns.ab_wait': { title: 'مدة الانتظار', short: 'المدة قبل اختيار الفائز.' },
  'campaigns.rate': { title: 'سرعة الإرسال', short: 'عدد الرسائل في الدقيقة (10–3000).' },
  'campaigns.delete': { title: 'حذف', short: 'لا يمكن حذف إلا المسودات.' },
  'campaigns.send': { title: 'إرسال', short: 'يعرض عدد المستلمين؛ ويرسل الآن أو لاحقًا بعد التأكيد.' },
  'campaigns.scheduled_at': { title: 'وقت الإرسال', short: 'حتى 90 يومًا مقدمًا.' },
  'campaigns.status': { title: 'حالة الإرسال', short: 'تتحدّث كل 5 ثوانٍ.' },
  'campaigns.resume': { title: 'استئناف', short: 'يواصل الإرسال إلى المستلمين الذين لم تُرسل إليهم بعد.' },
  'campaigns.cancel': {
    title: 'إيقاف الإرسال',
    short: 'لن يتلقى المستلمون الذين لم تُرسل إليهم بعد الرسالة.',
  },
  'campaigns.report': { title: 'التقرير', short: 'تُحتسب النقرات عبر عنوان تتبّع؛ ولا تُقاس مرات الفتح.' },
  'page.automations': {
    title: 'أتمتة التسويق',
    short: 'تدفقات البريد الإلكتروني التي تُطلقها الأحداث، وقواعد الإرسال.',
  },
  'page.automation_editor': {
    title: 'تدفق الأتمتة',
    short: 'التشغيل/الإيقاف؛ وتأخير المُشغِّل والخطوات والقوالب؛ والتقرير.',
  },
  'automations.settings': { title: 'قواعد الإرسال', short: 'حد التكرار وساعات الهدوء لجميع التدفقات.' },
  'automations.frequency_cap': {
    title: 'حد التكرار',
    short: 'يتخطى الرسالة إذا تلقى الشخص رسالة تسويقية أخرى خلال هذه المدة.',
  },
  'automations.quiet_hours': {
    title: 'ساعات الهدوء',
    short: 'لا تُرسل رسائل بريد إلكتروني خلال هذه الفترة (بتوقيت تركيا).',
  },
  'automations.settings_save': { title: 'حفظ القواعد', short: 'تسري اعتبارًا من الإرسال التالي.' },
  'automations.save': { title: 'حفظ', short: 'يحفظ التدفق؛ ويتطلب تشغيله تأكيدًا.' },
  'automations.enabled': {
    title: 'التدفق مُفعَّل',
    short: 'يتطلب قالبًا لكل خطوة بريد إلكتروني وإعداد إرسال البريد الإلكتروني.',
  },
  'automations.trigger': { title: 'المُشغِّل', short: 'الحدث الذي يُدخل الشخص في التدفق.' },
  'automations.store': { title: 'المتجر', short: 'تُؤخذ العلامة التجارية والروابط والقوالب من هذا المتجر.' },
  'automations.after_hours': {
    title: 'بعد كم من الوقت',
    short: 'مدة التأخير بعد تغيير السلة أو الطلب (1–72 ساعة).',
  },
  'automations.days': {
    title: 'الأيام',
    short: 'عدد الأيام بعد التسليم أو آخر طلب أو إرسال عرض السعر (1–365).',
  },
  'automations.steps': {
    title: 'الخطوات',
    short: 'حتى 10 خطوات؛ رسالة بريد إلكتروني واحدة على الأقل؛ ولا يمكن أن ينتهي بخطوة انتظار.',
  },
  'automations.step_tools': { title: 'نقل الخطوة أو حذفها', short: 'يسري بعد الحفظ.' },
  'automations.add_step': {
    title: 'إضافة خطوة',
    short: 'يضيف خطوة انتظار أو شرط أو بريد إلكتروني في النهاية.',
  },
  'automations.reset': {
    title: 'العودة إلى الإعدادات الافتراضية',
    short: 'يستعيد الخطوات المعدّة مسبقًا (لم تُحفظ بعد).',
  },
  'automations.report': { title: 'التقرير', short: 'تُحتسب الطلبات عبر رمز حملة التدفق في الروابط.' },
  'page.product_alerts': {
    title: 'تنبيهات المخزون والأسعار',
    short: 'طلبات «أعلمني» ورسائل انخفاض السعر للمنتجات المفضلة.',
  },
  'product_alerts.settings': {
    title: 'الإعدادات',
    short: 'كلاهما معطّل افتراضيًا؛ ويتطلبان إعداد إرسال البريد الإلكتروني.',
  },
  'product_alerts.stock_toggle': {
    title: '«أعلمني» في واجهة المتجر',
    short: 'يعرض نموذج البريد الإلكتروني على المنتجات غير المتوفرة في المخزون.',
  },
  'product_alerts.price_drop': {
    title: 'إشعار انخفاض السعر',
    short: 'رسالة بريد إلكتروني يومية عندما ينخفض سعر منتج مفضّل بقدر كافٍ.',
  },
  'product_alerts.store': { title: 'المتجر', short: 'تُؤخذ الأسعار والبطاقات والروابط من هذا المتجر.' },
  'product_alerts.min_percent': { title: 'الحد الأدنى للانخفاض', short: 'مقارنةً بأدنى سعر مسجَّل.' },
  'product_alerts.save': { title: 'حفظ', short: 'يتطلب تفعيل الإشعار تأكيدًا.' },
  'product_alerts.requests': {
    title: 'طلبات التنبيه',
    short: 'تُظهر طلبات التنبيه المعلّقة الاهتمام بالمنتجات النافدة.',
  },
  'product_alerts.view': { title: 'طلبات التنبيه', short: 'يعرض طلبات التنبيه الخاصة بالمتغير بالترتيب.' },
  'product_alerts.cancel': { title: 'إلغاء', short: 'يغلق طلب التنبيه؛ ولا تُرسل أي رسالة بريد إلكتروني.' },
  'page.message_campaigns': {
    title: 'الرسائل النصية (SMS) وWhatsApp',
    short: 'حملات SMS وWhatsApp وحالة الإعداد وإعدادات الإرسال.',
  },
  'page.message_campaign_editor': {
    title: 'حملة SMS/WhatsApp',
    short: 'القناة والقالب والجمهور والتكلفة التقديرية؛ والإرسال والتقدم والتقرير.',
  },
  'page.sms_templates': { title: 'قوالب SMS', short: 'نصوص SMS المستخدمة في الحملات وموافقة المختص عليها.' },
  'page.sms_template_editor': {
    title: 'قالب SMS',
    short: 'النص والحقول الشخصية وعدّاد الطول المباشر وموافقة المختص.',
  },
  'messaging.create': { title: 'حملة SMS/WhatsApp جديدة', short: 'ينشئ مسودة؛ والحفظ لا يرسل شيئًا.' },
  'messaging.setup': { title: 'حالة الإعداد', short: 'تظهر القناة التي ينقصها شيء بحالة «يتطلب الإعداد».' },
  'messaging.settings': {
    title: 'الإعدادات',
    short: 'تنطبق على جميع حملات SMS/WhatsApp؛ وتتطلب التحقق بخطوتين.',
  },
  'messaging.sms_provider': { title: 'مزوّد SMS', short: 'اربطه واختبره أولًا من قسم التكاملات.' },
  'messaging.opt_out': {
    title: 'نص إلغاء الاشتراك',
    short: 'إلزامي في الرسائل النصية التجارية: كيفية إلغاء الاشتراك عبر القناة نفسها.',
  },
  'messaging.unit_cost_sms': { title: 'تكلفة كل جزء من رسالة SMS', short: 'يُستخدم لتقدير التكلفة فقط.' },
  'messaging.unit_cost_whatsapp': { title: 'تكلفة كل رسالة WhatsApp', short: 'يُستخدم لتقدير التكلفة فقط.' },
  'messaging.frequency_cap': {
    title: 'حد التكرار',
    short: 'لا تُرسل رسالة حملة ثانية إلى الرقم نفسه خلال هذه المدة.',
  },
  'messaging.staging_phones': {
    title: 'أرقام الاختبار في بيئة التجهيز (Staging)',
    short: 'في بيئة التجهيز (Staging) لا تتلقى الرسائل إلا هذه الأرقام.',
  },
  'messaging.settings_save': {
    title: 'حفظ الإعدادات',
    short: 'تنطبق أيضًا على عمليات الإرسال المجدولة والجارية.',
  },
  'messaging.save': { title: 'حفظ', short: 'يحفظ المسودة؛ ولا يرسل شيئًا.' },
  'messaging.channel': {
    title: 'القناة',
    short: 'تستخدم SMS قالبك، بينما يستخدم WhatsApp قالبًا معتمدًا من Meta.',
  },
  'messaging.name': { title: 'اسم الحملة', short: 'يظهر في لوحة التحكم، ولا يظهر للمستلمين.' },
  'messaging.sms_template': {
    title: 'قالب SMS',
    short: 'تتطلب القوالب التي تتضمن ادعاءات صحية موافقة المختص.',
  },
  'messaging.whatsapp_template': {
    title: 'قالب WhatsApp',
    short: 'قوالب معتمدة من Meta؛ يُعاد التحقق منها وقت الإرسال.',
  },
  'messaging.whatsapp_params': { title: 'متغيرات القالب', short: 'قيم {{1}} و{{2}}… في القالب.' },
  'messaging.segments': { title: 'الجمهور', short: 'يُعاد حساب الشرائح وقت الإرسال؛ رسالة واحدة لكل رقم.' },
  'messaging.estimate': {
    title: 'حساب المستلمين والتكلفة',
    short: 'المستلمون والاستثناءات وأجزاء SMS والتكلفة.',
  },
  'messaging.delete': { title: 'حذف', short: 'يحذف مسودة أو حملة متوقفة لم تبدأ قط.' },
  'messaging.send': { title: 'إرسال', short: 'يعرض المستلمين والتكلفة، ثم يرسل الآن أو يجدول الإرسال.' },
  'messaging.scheduled_at': { title: 'وقت الإرسال', short: 'حتى 90 يومًا مقدمًا؛ بتوقيت تركيا.' },
  'messaging.status': { title: 'حالة الإرسال', short: 'تتحدّث كل 5 ثوانٍ؛ وتوضح أسباب التوقف المؤقت.' },
  'messaging.resume': { title: 'استئناف', short: 'يواصل مع المستلمين الذين لم يُرسل إليهم بعد.' },
  'messaging.cancel': { title: 'إيقاف', short: 'يلغي الإرسال إلى المستلمين الذين لم يُرسل إليهم بعد.' },
  'messaging.report': {
    title: 'التقرير',
    short: 'المرسلة والمسلَّمة والفاشلة والمتخطّاة؛ مع الأسباب والتكلفة.',
  },
  'sms_templates.create': { title: 'قالب SMS جديد', short: 'يفتح قالبًا فارغًا.' },
  'sms_templates.save': { title: 'حفظ', short: 'يتطلب تغيير النص موافقة المختص من جديد.' },
  'sms_templates.name': { title: 'اسم القالب', short: 'يظهر عند اختيار قالب.' },
  'sms_templates.body': { title: 'النص', short: 'اجعله قصيرًا؛ إذ يُضاف رقم MERSİS ونص إلغاء الاشتراك.' },
  'sms_templates.fields': { title: 'الحقول الشخصية', short: 'يُدرج حقلًا في موضع المؤشر.' },
  'sms_templates.preview': { title: 'معاينة', short: 'النص الذي سيُرسل ومجموعة الأحرف وعدد الأجزاء.' },
  'sms_templates.delete': { title: 'حذف', short: 'يحذف القالب ما لم تستخدمه حملة معلّقة.' },
  'page.push': { title: 'الإشعارات الفورية', short: 'حملات إشعارات المتصفح وزر واجهة المتجر والإعداد.' },
  'page.push_editor': {
    title: 'حملة الإشعارات',
    short: 'العنوان والنص والصفحة والجمهور؛ والمعاينة والإرسال والتقرير.',
  },
  'push.create': { title: 'حملة إشعارات جديدة', short: 'ينشئ مسودة؛ ولا يرسل شيئًا.' },
  'push.setup': { title: 'الإعداد', short: 'تظهر العناصر الناقصة بحالة «يتطلب الإعداد» أو «ناقص».' },
  'push.create_key': {
    title: 'إنشاء مفتاح',
    short: 'يولّد زوج مفاتيح على الخادم؛ ويبقى المفتاح الخاص مشفّرًا.',
  },
  'push.replace_key': {
    title: 'استبدال المفتاح',
    short: 'تنتهي جميع الاشتراكات؛ ويجب على الزوار تفعيل الإشعارات من جديد.',
  },
  'push.contact': { title: 'عنوان التواصل', short: 'mailto: أو https:؛ تشترطه خدمات الإشعارات الفورية.' },
  'push.enabled': {
    title: 'زر واجهة المتجر',
    short: 'لا يُطلب الإذن إلا عندما يضغط الزائر عليه. معطّل افتراضيًا.',
  },
  'push.settings_save': { title: 'حفظ', short: 'يتطلب التفعيل مفتاحًا وعنوان تواصل.' },
  'push.save': { title: 'حفظ', short: 'يحفظ المسودة؛ ولا يرسل شيئًا.' },
  'push.name': { title: 'اسم الحملة', short: 'يظهر في لوحة التحكم، ولا يظهر للمستلمين.' },
  'push.title': { title: 'العنوان', short: 'اجعله قصيرًا؛ فقد تقطع المتصفحات النص بعد نحو 50 حرفًا.' },
  'push.body': { title: 'النص', short: '180 حرفًا كحد أقصى؛ وتتطلب الادعاءات الصحية موافقة المختص.' },
  'push.url': { title: 'الصفحة المراد فتحها', short: 'مسار داخل المتجر يبدأ بـ /؛ وتُضاف معلمات UTM.' },
  'push.audience': { title: 'الجمهور', short: 'جميع المشتركين، أو الأعضاء المسجَّل دخولهم ضمن الشرائح.' },
  'push.estimate': { title: 'عدّ المتصفحات', short: 'عدد الاشتراكات التي ستتلقاه؛ ولا يرسل شيئًا.' },
  'push.preview': { title: 'معاينة', short: 'الشكل التقريبي.' },
  'push.delete': { title: 'حذف', short: 'يحذف مسودة أو حملة متوقفة لم تبدأ قط.' },
  'push.send': { title: 'إرسال', short: 'يعرض العدد، ثم يرسل الآن أو يجدول الإرسال.' },
  'push.scheduled_at': { title: 'وقت الإرسال', short: 'حتى 90 يومًا مقدمًا.' },
  'push.status': { title: 'حالة الإرسال', short: 'تتحدّث كل 5 ثوانٍ؛ وتوضح أسباب التوقف المؤقت.' },
  'push.resume': { title: 'استئناف', short: 'يواصل مع المتصفحات التي لم يُرسل إليها بعد.' },
  'push.cancel': { title: 'إيقاف', short: 'يلغي الإرسال إلى المتصفحات التي لم يُرسل إليها بعد.' },
  'push.report': {
    title: 'التقرير',
    short: 'عمليات الإرسال المقبولة والاشتراكات المنتهية والأسباب والطلبات.',
  },
  'notifications.section': { title: 'إشعارات الجوال', short: 'أجهزتك والأحداث التي تُشعرك.' },
  'notifications.events': { title: 'الأحداث التي تُشعرني', short: 'فقط الأحداث التي لديك صلاحية عليها.' },
  'notifications.quiet_hours': { title: 'ساعات الهدوء', short: 'لا إشعارات خلال هذه الفترة.' },
  'notifications.save': { title: 'حفظ التفضيلات', short: 'يؤثر على إشعاراتك فقط.' },
  'notifications.test': { title: 'إشعار تجريبي', short: 'يرسل إشعارًا تجريبيًا إلى أجهزتك المسجّلة.' },
  'notifications.device_remove': {
    title: 'إزالة الجهاز',
    short: 'لن تُرسل إشعارات إلى هذا الجهاز بعد الآن. يؤثر على أجهزتك أنت فقط.',
  },
  'page.promotions': {
    title: 'العروض التلقائية',
    short: 'عروض بدون رمز خصم: خصم على المنتج، وشرائح السلة، واشترِ X وادفع ثمن Y، والشحن المجاني.',
  },
  'page.promotion_editor': {
    title: 'عرض تلقائي',
    short:
      'النوع والقاعدة والمنتجات المستهدفة والجمهور والأولوية وإمكانية الجمع والتواريخ؛ والنص الذي يراه العملاء.',
  },
  'promotions.create': { title: 'عرض جديد', short: 'يفتح مسودة؛ والمسودات غير مرئية للعملاء.' },
  'promotions.save': { title: 'حفظ', short: 'يحفظ عرضًا في حالة المسودة أو الإيقاف المؤقت.' },
  'promotions.activate': { title: 'تفعيل العرض', short: 'يبدأ العرض؛ ويطلب التحقق بخطوتين.' },
  'promotions.pause': { title: 'إيقاف مؤقت', short: 'يتوقف تطبيقه على سلال التسوق فورًا.' },
  'promotions.delete': { title: 'حذف المسودة', short: 'لا يمكن حذف إلا مسودة لم تُفعَّل قط.' },
  'promotions.name': { title: 'اسم العرض', short: 'يظهر في لوحة التحكم والتقارير فقط.' },
  'promotions.label': {
    title: 'الاسم الظاهر للعملاء',
    short: 'سلة التسوق وإتمام الطلب وصفحة المنتج؛ 80 حرفًا كحد أقصى.',
  },
  'promotions.kind': {
    title: 'نوع العرض',
    short: 'خصم على المنتج، أو شرائح السلة، أو اشترِ X وادفع ثمن Y، أو الشحن المجاني.',
  },
  'promotions.percent': { title: 'نسبة الخصم', short: 'مثل 20 أو 7.5؛ ويُقرَّب إلى الأدنى.' },
  'promotions.buy': { title: 'اشترِ', short: 'عدد القطع في كل مجموعة (2–20).' },
  'promotions.pay': { title: 'ادفع', short: 'عدد القطع المدفوعة في كل مجموعة؛ والأرخص منها مجانية.' },
  'promotions.min_subtotal': {
    title: 'الحد الأدنى لقيمة السلة',
    short: 'بعد خصومات المنتجات؛ فارغ = دائمًا.',
  },
  'promotions.basis': { title: 'نوع الحد', short: 'قيمة السلة أو عدد القطع المؤهلة.' },
  'promotions.tier_type': { title: 'نوع الخصم', short: 'نسبة مئوية أو مبلغ ثابت.' },
  'promotions.tiers': { title: 'الشرائح', short: 'حتى 5؛ وتُطبَّق أعلى شريحة مؤهلة.' },
  'promotions.add_tier': { title: 'إضافة شريحة', short: 'يضيف صفًا للحد والخصم.' },
  'promotions.remove_tier': { title: 'إزالة الشريحة', short: 'يزيل هذه الشريحة من المسودة.' },
  'promotions.currency': { title: 'العملة', short: 'يُطبَّق فقط على السلال بهذه العملة.' },
  'promotions.targets': { title: 'المنتجات المستهدفة', short: 'عدم الاختيار = جميع المنتجات.' },
  'promotions.categories': { title: 'التصنيفات', short: 'تشمل التصنيفات الفرعية.' },
  'promotions.brands': { title: 'العلامات التجارية', short: 'منتجات العلامات التجارية المختارة.' },
  'promotions.collections': { title: 'المجموعات', short: 'المنتجات الحالية في المجموعة.' },
  'promotions.products': { title: 'المنتجات', short: 'ابحث بالاسم أو SKU أو الباركود.' },
  'promotions.audience': {
    title: 'الجمهور',
    short: 'الجميع، أو عملاء التجزئة، أو الموزّعون؛ مع مجموعات وشرائح اختيارية.',
  },
  'page.dealer_reports': {
    title: 'تقارير الموزّعين',
    short:
      'مبيعات الموزّعين والمنتجات والتصنيفات وأعمار الديون والتحصيلات حسب الموزّع أو مندوب المبيعات أو المنطقة.',
  },
  'dealer_reports.report': {
    title: 'التقرير',
    short: 'المبيعات أو المنتجات أو التصنيفات أو أعمار الديون أو التحصيلات.',
  },
  'dealer_reports.period': { title: 'الفترة', short: 'يوما البداية والنهاية مشمولان؛ سنة واحدة كحد أقصى.' },
  'dealer_reports.group_by': {
    title: 'التجميع حسب',
    short: 'المجاميع حسب الموزّع أو مندوب المبيعات أو المنطقة.',
  },
  'dealer_reports.rep': { title: 'مندوب المبيعات', short: 'طلبات هذا المندوب أو موزّعوه فقط.' },
  'dealer_reports.region': { title: 'المنطقة', short: 'الموزّعون في هذه المنطقة فقط.' },
  'page.international_report': {
    title: 'المبيعات حسب الدولة',
    short:
      'الطلبات والتصدير والإجمالي وضريبة القيمة المضافة والشحن والمبالغ المستردة والصافي والمعادل بالليرة التركية حسب دولة الشحن والعملة.',
  },
  'international_report.period': {
    title: 'الفترة',
    short: 'يوم الطلب (بتوقيت تركيا)، مع احتساب اليومين؛ سنة واحدة كحد أقصى.',
  },
  'international_report.store': { title: 'المتجر', short: 'اتركه فارغًا لعرض جميع المتاجر المتاحة لك.' },
  'international_report.csv': { title: 'تنزيل CSV', short: 'ينزّل التقرير بعوامل التصفية نفسها.' },
  'international_report.try_total': {
    title: 'المعادل بالليرة التركية',
    short: 'المبالغ الصافية محوّلة بسعر TCMB المسجّل في كل طلب.',
  },
  'dealer_reports.csv': { title: 'تنزيل CSV', short: 'ينزّل التقرير بعوامل التصفية نفسها.' },
  'pricing.list_market': { title: 'السوق', short: 'عند تحديده، تُطبَّق القائمة في ذلك السوق فقط.' },
  'products.compliance': {
    title: 'الأهلية حسب الدولة',
    short: 'حالة البيع ورقم التسجيل/الترخيص والتحقق لكل دولة.',
  },
  'products.compliance_status': {
    title: 'حالة البيع',
    short: 'يلزم ذكر السبب عندما لا يكون المنتج معروضًا للبيع.',
  },
  'products.compliance_reason': { title: 'السبب', short: 'سبب عدم إمكانية البيع (داخلي).' },
  'products.compliance_registration': {
    title: 'رقم التسجيل / الترخيص',
    short: 'يظهر في صفحة المنتج بعد التحقق منه.',
  },
  'products.compliance_verification': {
    title: 'التحقق',
    short: 'ما إذا كان الرقم قد طوبق مع المصدر الرسمي.',
  },
  'page.fx': {
    title: 'أسعار الصرف',
    short: 'أسعار الصرف الإرشادية اليومية من TCMB وحالة الجلب وقوائم الأسعار المشتقة من سعر الصرف.',
  },
  'fx.refresh': {
    title: 'تحديث أسعار الصرف الآن',
    short: 'يجلب أحدث نشرة من TCMB الآن (مرة واحدة في الدقيقة كحد أقصى).',
  },
  'fx.rates': {
    title: 'أسعار الصرف',
    short: 'أسعار الشراء والبيع للعملات الأجنبية والأوراق النقدية في أحدث نشرة.',
  },
  'fx.derived': {
    title: 'القوائم المشتقة من سعر الصرف',
    short: 'قوائم تُحتسب أسعارها من قائمة أساسية وفق سعر الصرف.',
  },
  'fx.recompute': { title: 'إعادة الحساب الآن', short: 'يعيد حساب القائمة بأحدث سعر صرف.' },
  'pricing.fx': {
    title: 'الاشتقاق من سعر الصرف',
    short: 'يحسب أسعار القائمة من قائمة أساسية بعملة أخرى وفق سعر صرف TCMB.',
  },
  'pricing.fx_base': { title: 'القائمة الأساسية', short: 'قائمة مسعّرة يدويًا بعملة أخرى.' },
  'pricing.fx_rate_type': {
    title: 'نوع سعر الصرف',
    short: 'سعر الشراء أو البيع للعملات الأجنبية أو الأوراق النقدية.',
  },
  'pricing.fx_markup': {
    title: 'هامش الزيادة',
    short: 'نسبة مئوية تُضاف بعد التحويل؛ والقيمة السالبة تخفّض السعر.',
  },
  'pricing.fx_ending': {
    title: 'نهاية السعر',
    short: 'يقرّب السعر إلى الأعلى إلى عدد صحيح أو إلى .90 أو .99.',
  },
  'pricing.fx_auto': {
    title: 'التحديث التلقائي',
    short: 'يعيد الحساب عند صدور كل نشرة جديدة وعند تغيّر الأسعار الأساسية.',
  },
  'pricing.fx_clear': {
    title: 'التحويل إلى الأسعار اليدوية',
    short: 'يزيل الربط بسعر الصرف؛ وتبقى الأسعار الحالية.',
  },
  'orders.fx': { title: 'سعر الصرف', short: 'سعر شراء العملات الأجنبية من TCMB وقت الطلب؛ ولا يتغير أبدًا.' },
  'payments.card_currencies': {
    title: 'الدفع بالبطاقة بالعملات الأجنبية',
    short: 'يُتاح الدفع بالبطاقة فقط بالعملات المحددة التي يدعمها المزوّد.',
  },
  'shipping.currency': { title: 'عملة الرسوم', short: 'لا تُتاح هذه الطريقة إلا للطلبات بهذه العملة.' },
  'promotions.companies': {
    title: 'شركات الموزّعين',
    short: 'حملة خاصة بالموزّعين: تنطبق فقط على مستخدمي شركات الموزّعين المعتمدة المختارة.',
  },
  'promotions.groups': { title: 'مجموعات العملاء', short: 'يُعدّ الزوار أعضاءً في مجموعات التجزئة.' },
  'promotions.segments': { title: 'الشرائح', short: 'الأعضاء المسجَّل دخولهم في الشرائح المختارة.' },
  'promotions.priority': { title: 'الأولوية', short: 'تُجرَّب القيمة الأعلى أولًا (من −100 إلى 100).' },
  'promotions.stacking': { title: 'الجمع مع العروض', short: 'حصري أو قابل للجمع مع العروض الأخرى.' },
  'promotions.allow_coupon': {
    title: 'مع رمز الخصم',
    short: 'عند التعطيل تُرفض رموز الخصم طوال مدة تطبيق العرض.',
  },
  'promotions.starts_at': { title: 'البداية', short: 'فارغ = عند التفعيل.' },
  'promotions.ends_at': { title: 'النهاية', short: 'فارغ = بلا نهاية؛ ويظهر في صفحات المنتجات.' },
  'promotions.preview': { title: 'ما يراه العملاء', short: 'الاسم والشرط وتاريخ الانتهاء.' },
  'promotions.excluded': { title: 'منتجات بدون خصم', short: 'رُفع سعرها خلال 10 أيام قبل البداية.' },
  'promotions.usage': { title: 'الاستخدام', short: 'الطلبات وإجمالي الخصم وإجمالي الطلبات.' },
  'page.gift_cards': {
    title: 'بطاقات الهدايا',
    short: 'بطاقات مسبقة الدفع تُستخدم برمز عند إتمام الطلب: الإنشاء والرصيد والحالة وتاريخ الانتهاء.',
  },
  'page.gift_card_detail': {
    title: 'بطاقة هدية',
    short:
      'رصيد البطاقة والمعاملات (الإصدار، والاستخدام في الطلب، والاسترداد، والإلغاء، والتعديل) والإعدادات.',
  },
  'gift_cards.create': {
    title: 'إنشاء بطاقة هدية',
    short: 'ينشئ بطاقة بمبلغ وتاريخ انتهاء اختياري. يُعرض الرمز مرة واحدة فقط، وأنت من يسلّمه.',
  },
  'gift_cards.search': { title: 'آخر أربعة أحرف', short: 'يبحث بآخر أربعة أحرف؛ ولا تُخزَّن الرموز كاملة.' },
  'gift_cards.state_filter': {
    title: 'الحالة',
    short: 'قابلة للاستخدام، أو معطّلة، أو منتهية الصلاحية، أو بلا رصيد.',
  },
  'gift_cards.amount': { title: 'المبلغ', short: 'الرصيد الأولي للبطاقة (1.00 على الأقل).' },
  'gift_cards.currency': { title: 'العملة', short: 'لا تعمل البطاقة إلا في المتاجر التي تبيع بهذه العملة.' },
  'gift_cards.expires_at': {
    title: 'تاريخ الانتهاء',
    short: 'صالحة حتى نهاية اليوم؛ والحقل الفارغ يعني عدم انتهاء الصلاحية. استشر محاميك أولًا.',
  },
  'gift_cards.note': { title: 'ملاحظة داخلية', short: 'تظهر في لوحة التحكم فقط.' },
  'gift_cards.copy_code': { title: 'نسخ الرمز', short: 'ينسخ الرمز. لن يُعرض مرة أخرى بعد إغلاق النافذة.' },
  'gift_cards.adjust': {
    title: 'تعديل الرصيد',
    short: 'يضيف إلى الرصيد أو يخصم منه مع ذكر السبب. ولا يمكن أن يصبح الرصيد سالبًا.',
  },
  'gift_cards.toggle': {
    title: 'تعطيل البطاقة / إعادة تفعيلها',
    short: 'تُرفض البطاقة المعطّلة عند إتمام الطلب؛ ولا تتأثر الطلبات السابقة.',
  },
  'gift_cards.save': { title: 'حفظ', short: 'يحفظ تاريخ الانتهاء والملاحظة الداخلية.' },
  'tenders.adjust_direction': { title: 'الإجراء', short: 'إضافة رصيد أو الخصم منه.' },
  'tenders.adjust_amount': { title: 'المبلغ', short: 'مبلغ موجب؛ اختر الاتجاه من «الإجراء».' },
  'tenders.adjust_note': { title: 'السبب', short: 'إلزامي؛ ويُسجَّل في السجل التاريخي وسجل التدقيق.' },
  'customers.store_credit_adjust': {
    title: 'إضافة رصيد / خصمه',
    short: 'يضيف رصيد المتجر (مثلًا كبادرة حسن نية) أو يخصمه مع ذكر السبب. ولا يرى العميل سوى المبلغ.',
  },
  'customers.store_credit_currency': {
    title: 'العملة',
    short: 'يُحفظ الرصيد لكل عملة على حدة ولا يُستخدم إلا في الطلبات بالعملة نفسها.',
  },
  'customers.gift_card_issue': {
    title: 'إصدار بطاقة هدية',
    short: 'ينشئ بطاقة هدية مسجّلة لهذا العميل. ويُعرض الرمز مرة واحدة.',
  },
  'orders.refund_payment': {
    title: 'الدفعة المراد استردادها',
    short: 'عند وجود عدة دفعات (مثل بطاقة هدية + بطاقة مصرفية)، اختر الدفعة المراد استردادها.',
  },
  'orders.refund_store_credit': {
    title: 'الاسترداد كرصيد في المتجر',
    short:
      'يضيف المبلغ إلى رصيد المتجر بدلًا من رده نقدًا؛ بموافقة العميل فقط، ولا يُستخدم أبدًا في حالات الانسحاب.',
  },
  'orders.refund_consent': { title: 'موافقة العميل', short: 'أكّد أن العميل قبِل رصيد المتجر؛ إلزامي.' },
  'page.loyalty': {
    title: 'برنامج الولاء',
    short: 'معدلات الكسب والاستبدال، وفترات الانتظار والصلاحية، ومستويات VIP، وملخص البرنامج.',
  },
  'loyalty.enabled': {
    title: 'برنامج الولاء مُفعَّل',
    short: 'عند التفعيل يكسب الأعضاء النقاط ويستخدمونها وتُطبَّق مزايا المستويات.',
  },
  'loyalty.currency': { title: 'العملة', short: 'تُكسب النقاط وتُستخدم فقط في الطلبات بهذه العملة.' },
  'loyalty.earn': { title: 'النقاط لكل وحدة واحدة', short: 'مثلًا 10: تُمنح 10 نقاط مقابل كل 1 TRY يُنفَق.' },
  'loyalty.value': { title: 'النقاط المعادلة لوحدة واحدة', short: 'مثلًا 100: كل 100 نقطة = 1 TRY.' },
  'loyalty.min_redeem': {
    title: 'الحد الأدنى من النقاط للاستخدام',
    short: 'الحد الأدنى من الرصيد اللازم لاستخدام النقاط عند إتمام الطلب.',
  },
  'loyalty.hold_days': {
    title: 'مدة الانتظار بعد التسليم',
    short: 'تُضاف النقاط بعد هذا العدد من الأيام من التسليم.',
  },
  'loyalty.expiry': {
    title: 'صلاحية النقاط',
    short: 'تنتهي صلاحية النقاط المكتسبة بعد هذا العدد من الأشهر؛ 0 = أبدًا.',
  },
  'loyalty.tiers': {
    title: 'مستويات VIP',
    short: 'مستويات حسب صافي الإنفاق خلال آخر 12 شهرًا؛ مع خصم وشحن مجاني.',
  },
  'loyalty.tier_name': { title: 'اسم المستوى', short: 'يظهر للعملاء.' },
  'loyalty.tier_spend': {
    title: 'الحد الأدنى للإنفاق (12 شهرًا)',
    short: 'يحصل على المستوى الأعضاء الذين يبلغ إنفاقهم هذا الحد أو يتجاوزه.',
  },
  'loyalty.tier_discount': {
    title: 'خصم المستوى',
    short: 'نسبة خصم على المنتجات (50% كحد أقصى)، بعد العروض.',
  },
  'loyalty.tier_shipping': { title: 'شحن مجاني', short: 'لا رسوم شحن لهذا المستوى.' },
  'loyalty.tier_add': { title: 'إضافة مستوى', short: 'يضيف صف مستوى؛ ويسري عند الحفظ.' },
  'loyalty.tier_remove': { title: 'إزالة المستوى', short: 'يزيل صف المستوى؛ ويسري عند الحفظ.' },
  'loyalty.save': { title: 'حفظ', short: 'يحفظ الإعدادات (التحقق بخطوتين).' },
  'loyalty.adjust_points': { title: 'النقاط', short: 'النقاط المراد إضافتها أو خصمها (عدد صحيح موجب).' },
  'customers.loyalty_adjust': {
    title: 'إضافة نقاط / خصمها',
    short: 'يضيف نقاط الولاء أو يخصمها مع ذكر السبب؛ ولا يرى العميل السبب.',
  },
  'page.referrals': {
    title: 'برنامج الإحالة',
    short:
      'ادعُ صديقًا: خصم على الطلب الأول، ورمز خصم مكافأة للمُحيل، وفترة الانتظار، والحد الأقصى، وأحدث الدعوات.',
  },
  'referrals.enabled': {
    title: 'برنامج الإحالة مُفعَّل',
    short: 'عند التفعيل يمكن للأعضاء الحصول على رموز الدعوة، وتعمل الرموز في سلة التسوق.',
  },
  'referrals.currency': {
    title: 'العملة',
    short: 'لا تعمل رموز الدعوة ورموز خصم المكافآت إلا في السلال بهذه العملة.',
  },
  'referrals.friend': { title: 'خصم الصديق', short: 'خصم برمز للصديق الذي يقدّم طلبه الأول برمز دعوة.' },
  'referrals.referrer': {
    title: 'مكافأة المُحيل',
    short: 'رمز خصم لاستخدام واحد يُمنح للمُحيل بعد التسليم وانقضاء فترة الانتظار.',
  },
  'referrals.reward_type': { title: 'نوع الخصم', short: 'نسبة مئوية (50% كحد أقصى) أو مبلغ ثابت.' },
  'referrals.reward_value': { title: 'الخصم', short: 'نسبة مئوية (مثل 10) أو مبلغ ثابت (مثل 50.00).' },
  'referrals.reward_min': {
    title: 'الحد الأدنى لإجمالي السلة',
    short: 'الحد الأدنى لإجمالي السلة لاستخدام الرمز. فارغ: بلا حد أدنى.',
  },
  'referrals.hold_days': {
    title: 'مدة الانتظار بعد التسليم',
    short: 'تُصدر المكافأة بعد هذا العدد من الأيام من تسليم طلب الصديق.',
  },
  'referrals.valid_days': {
    title: 'صلاحية رمز خصم المكافأة',
    short: 'عدد الأيام التي يبقى فيها رمز خصم المكافأة صالحًا (7–365).',
  },
  'referrals.max_rewards': {
    title: 'الحد الأقصى للمكافآت لكل عضو',
    short: 'أكبر عدد من المكافآت يمكن أن يحصل عليه العضو الواحد.',
  },
  'referrals.save': { title: 'حفظ', short: 'يحفظ الإعدادات ويحدّث جميع رموز الدعوة (التحقق بخطوتين).' },
  'page.affiliates': {
    title: 'الشركاء التسويقيون',
    short: 'الشركاء التسويقيون والمؤثرون، والمطابقة عبر رمز الخصم أو الرابط، والعمولات والصرف اليدوي.',
  },
  'affiliates.create': { title: 'إضافة شريك تسويقي', short: 'ينشئ شريكًا تسويقيًا أو مؤثرًا جديدًا.' },
  'affiliates.edit': {
    title: 'تعديل',
    short: 'يغيّر النسبة أو رمز الخصم أو المصدر أو الحالة للطلبات المستقبلية.',
  },
  'affiliates.name': { title: 'الاسم', short: 'اسم الشريك أو القناة؛ ويظهر في ملف CSV.' },
  'affiliates.kind': { title: 'النوع', short: 'شريك تسويقي أو مؤثر؛ للتجميع فقط.' },
  'affiliates.email': {
    title: 'البريد الإلكتروني',
    short: 'سجل تواصل داخلي؛ ولا يرسل النظام رسائل بريد إلكتروني إلى الشركاء.',
  },
  'affiliates.source': {
    title: 'مصدر الرابط (utm_source)',
    short: 'قيمة تُضاف إلى روابط الشريك؛ أحرف لاتينية صغيرة وأرقام وشرطة وشرطة سفلية.',
  },
  'affiliates.discount': {
    title: 'رمز الخصم',
    short: 'رمز خصم الشريك؛ تُنسب الطلبات التي تستخدمه قبل الروابط.',
  },
  'affiliates.rate': {
    title: 'نسبة العمولة',
    short: 'نسبة مئوية من مبلغ المنتجات دون ضريبة القيمة المضافة والشحن (50% كحد أقصى).',
  },
  'affiliates.status': { title: 'الحالة', short: 'لا تُنسب طلبات جديدة إلى الشركاء الموقوفين مؤقتًا.' },
  'affiliates.note': { title: 'ملاحظة داخلية', short: 'ملاحظات داخلية؛ لا يراها الشريك.' },
  'affiliates.save': { title: 'حفظ', short: 'يحفظ الشريك التسويقي (التحقق بخطوتين).' },
  'commissions.filter_affiliate': {
    title: 'تصفية حسب الشريك التسويقي',
    short: 'يقصر القائمة وملف CSV على شريك تسويقي واحد.',
  },
  'commissions.filter_status': {
    title: 'تصفية حسب الحالة',
    short: 'دون تحديد حالة، يتضمن ملف CSV العمولات المعتمدة.',
  },
  'commissions.export': { title: 'تنزيل CSV', short: 'ملف CSV متوافق مع Excel لعمليات الصرف.' },
  'commissions.select': { title: 'التحديد', short: 'لا يمكن تحديد إلا العمولات المعتمدة.' },
  'commissions.mark_paid': {
    title: 'تعليم كمدفوعة',
    short: 'يضع علامة «مدفوعة» على العمولات المعتمدة المحددة؛ ولا يمكن التراجع عن ذلك.',
  },
  'commissions.paid_note': {
    title: 'ملاحظة الدفع',
    short: 'رقم الإيصال والتاريخ وغير ذلك (3 أحرف على الأقل).',
  },
  'page.support_tickets': {
    title: 'تذاكر الدعم',
    short: 'طلبات العملاء: الحالة والإسناد والأولوية؛ الردود المحفوظة؛ تقرير الدعم والرضا وأسباب الإرجاع.',
  },
  'page.support_ticket': {
    title: 'تذكرة دعم',
    short:
      'المحادثة، والرد على العميل، والملاحظة الداخلية، والرد المحفوظ؛ الحالة والأولوية والموضوع والمسؤول.',
  },
  'support.filter_status': {
    title: 'تصفية حسب الحالة',
    short: 'يعرض خيار «مفتوحة وقيد الانتظار» التذاكر التي تنتظر ردًا أو تنتظر العميل.',
  },
  'support.filter_assigned': {
    title: 'تصفية حسب المسؤول',
    short: 'التذاكر المسندة إليك أو غير المسندة أو المسندة إلى أحد الموظفين.',
  },
  'support.filter_priority': { title: 'تصفية حسب الأولوية', short: 'التذاكر ذات الأولوية المحددة فقط.' },
  'support.search': {
    title: 'بحث',
    short: 'رقم التذكرة، أو البريد الإلكتروني الكامل للعميل، أو كلمة من الموضوع.',
  },
  'support.report_period': { title: 'فترة التقرير', short: 'آخر 7 أو 30 أو 90 أو 365 يومًا.' },
  'support.macro_add': { title: 'إضافة رد محفوظ', short: 'يحفظ ردًا متكررًا باسم محدد.' },
  'support.macro_edit': { title: 'تعديل', short: 'يغيّر اسم الرد المحفوظ أو نصه.' },
  'support.macro_delete': { title: 'حذف', short: 'يحذف الرد المحفوظ؛ ولا تتأثر الردود المرسلة.' },
  'support.macro_title': { title: 'الاسم', short: 'اسم قصير وفريد (2–80 حرفًا).' },
  'support.macro_body': { title: 'نص الرد', short: 'يُستبدل {{name}} باسم العميل عند الإدراج.' },
  'support.status': {
    title: 'الحالة',
    short: 'بانتظار الرد، أو بانتظار العميل، أو تم الحل (يُعاد فتحها عند الرد)، أو مغلقة.',
  },
  'support.priority': {
    title: 'الأولوية',
    short: 'تظهر التذاكر العاجلة وذات الأولوية العالية أولًا؛ ولا يرى العملاء الأولوية.',
  },
  'support.category': { title: 'الموضوع', short: 'موضوع التذكرة؛ ويُحتسب في التقرير.' },
  'support.assignee': { title: 'المسؤول', short: 'الموظفون النشطون الذين يمكنهم الرد على التذاكر فقط.' },
  'support.notify_resolved': {
    title: 'بريد إلكتروني عند الحل',
    short: 'يرسل إلى العميل بريدًا إلكترونيًا يتضمن رابط تقييم.',
  },
  'support.save_details': { title: 'حفظ التغييرات', short: 'يحفظ الحالة والأولوية والموضوع والمسؤول.' },
  'support.insert_macro': { title: 'إدراج رد محفوظ', short: 'يُدرج الرد المحفوظ في مربع النص.' },
  'support.reply_body': { title: 'رد أو ملاحظة داخلية', short: 'حتى 5000 حرف.' },
  'support.send_reply': {
    title: 'إرسال الرد',
    short: 'يظهر في صفحة التذكرة ويُرسل إلى العميل بالبريد الإلكتروني.',
  },
  'support.send_resolve': {
    title: 'إرسال ووضع علامة «تم الحل»',
    short: 'يرسل الرد ويضع علامة «تم الحل» على التذكرة.',
  },
  'support.add_note': { title: 'إضافة ملاحظة داخلية', short: 'مرئية للفريق فقط.' },
  'support.convert_subject': {
    title: 'موضوع التذكرة',
    short: 'يظهر في القائمة وفي البريد الإلكتروني المرسل إلى العميل.',
  },
  'messages.convert': {
    title: 'تحويل إلى تذكرة',
    short: 'يحوّل الرسالة إلى تذكرة دعم؛ ويضع علامة «تمت المعالجة» على الرسالة.',
  },
  'page.live_chat': {
    title: 'الدردشة المباشرة',
    short:
      'محادثات الدعم المباشر من واجهة المتجر: التوفر، والمحادثات المنتظرة/الجارية، والرد، والإغلاق، والتحويل، والإعدادات.',
  },
  'chat.available': {
    title: 'متاح للدردشة',
    short: 'يمكن للزوار بدء المحادثات ما دام هذا الخيار مفعّلًا والصفحة مفتوحة.',
  },
  'chat.claim': { title: 'تولّي المحادثة', short: 'يُسند المحادثة المنتظرة إليك.' },
  'chat.reply': { title: 'الرد', short: 'حتى 2000 حرف.' },
  'chat.send': { title: 'إرسال', short: 'يرسل الرسالة إلى الزائر.' },
  'chat.close': { title: 'إغلاق المحادثة', short: 'ينهي المحادثة؛ ويمكن للزائر بدء محادثة جديدة.' },
  'chat.convert': { title: 'تحويل إلى تذكرة', short: 'ينقل المحادثة إلى تذكرة دعم (يلزم بريد إلكتروني).' },
  'chat.enabled': {
    title: 'نافذة الدعم المباشر',
    short: 'يعرض زر الدعم المباشر في واجهة المتجر؛ وهو معطّل افتراضيًا.',
  },
  'chat.retention': { title: 'الاحتفاظ', short: 'تُحذف المحادثات المغلقة بعد هذا العدد من الأيام.' },
  'chat.idle': {
    title: 'عدم النشاط',
    short: 'تُغلق المحادثات التي لم تُرسل فيها رسائل خلال هذا العدد من الدقائق.',
  },
  'chat.save': { title: 'حفظ الإعدادات', short: 'يحفظ إعدادات الدردشة.' },
  'page.google_ads_campaigns': {
    title: 'حملات Google Ads',
    short:
      'يُعدّ حملات Performance Max والتسوّق من منتجاتك ويحصل على الموافقة عليها ويطبّقها عبر Google Ads API.',
  },
  'page.google_ads_campaign': {
    title: 'حملة Google Ads',
    short: 'قيم الحملة ومنتجاتها وحالتها في Google؛ طلبات التغيير والسجل.',
  },
  'gads.settings': {
    title: 'سقف الميزانية والإعدادات',
    short: 'السقف الشهري لميزانية الإعلانات والإيقاف التلقائي عند بلوغه.',
  },
  'gads.new_campaign': {
    title: 'حملة جديدة',
    short: 'معالج: المتجر، النوع، المنتجات، الميزانية والعروض، المناطق/اللغات/التواريخ، الملخص.',
  },
  'gads.stop_all': {
    title: 'إيقاف كل حملات Google',
    short: 'طوارئ: يوقف كل الحملات المنشورة ويلغي طلبات الإنفاق المعلّقة.',
  },
  'gads.month': {
    title: 'هذا الشهر',
    short: 'الإنفاق الشهري والسقف والحد الأعلى الشهري المقدّر وعمليات API اليوم.',
  },
  'gads.campaigns': {
    title: 'الحملات',
    short: 'كل حملات Google Ads: الحالة والميزانية والحد الشهري والإنفاق والتنبيهات.',
  },
  'gads.approvals': { title: 'بانتظار الموافقة', short: 'الطلبات التي قد تسبب إنفاقًا وأثرها المالي.' },
  'gads.decide': {
    title: 'موافقة / رفض',
    short: 'تتطلب الموافقة التحقق بخطوتين؛ ولا يوافق على طلبه الخاص إلا المالك.',
  },
  'gads.decision_note': { title: 'ملاحظة', short: 'سبب القرار؛ يُسجَّل في سجل التدقيق.' },
  'gads.monthly_cap': {
    title: 'السقف الشهري لميزانية الإعلانات',
    short: 'الحد الأعلى الشهري لكل حملات Google Ads.',
  },
  'gads.auto_stop': {
    title: 'الإيقاف التلقائي',
    short: 'معطّل افتراضيًا. عند بلوغ الإنفاق الشهري السقف تُوقف الحملات المنشورة دون موافقة.',
  },
  'gads.daily_limit': {
    title: 'الحد اليومي لعمليات API',
    short: 'مع وصول Explorer يحدّ Google عدد العمليات اليومية على الحسابات الحقيقية.',
  },
  'gads.submit': {
    title: 'حفظ المسودة / إرسال للموافقة',
    short: 'لا تُرسل المسودة إلى Google؛ بعد الموافقة تُنشأ الحملة متوقفة مؤقتًا.',
  },
  'gads.store': {
    title: 'المتجر',
    short: 'تأتي حسابات Google Ads وMerchant Center من اتصالات Google للمتجر.',
  },
  'gads.kind': {
    title: 'نوع الحملة',
    short: 'تعمل Performance Max في كل قنوات Google؛ والتسوّق في Google Shopping فقط.',
  },
  'gads.name': { title: 'اسم الحملة', short: 'الاسم الظاهر في Google Ads؛ يجب أن يكون فريدًا في الحساب.' },
  'gads.daily_budget': {
    title: 'الميزانية اليومية',
    short: 'قد ينفق Google حتى الضعف في يوم؛ الحد الشهري ≈ اليومية × 30.4.',
  },
  'gads.bidding': {
    title: 'استراتيجية العروض',
    short: 'Performance Max: قيمة التحويل أو التحويلات؛ التسوّق: قيمة التحويل أو النقرات.',
  },
  'gads.target_roas': {
    title: 'العائد المستهدف',
    short: 'قيمة التحويل المستهدفة لكل وحدة إنفاق (نسبة مئوية). خفضه قد يزيد الإنفاق.',
  },
  'gads.target_cpa': {
    title: 'التكلفة المستهدفة لكل تحويل',
    short: 'متوسط التكلفة المستهدف لكل عملية شراء. رفعها قد يزيد الإنفاق.',
  },
  'gads.request_note': { title: 'ملاحظة', short: 'سبب لمن سيوافق؛ يُسجَّل في سجل التدقيق.' },
  'gads.products': {
    title: 'المنتجات',
    short: 'لا تُضاف إلا المنتجات التي تدخل خلاصة Google وليست في حملة أخرى.',
  },
  'gads.countries': {
    title: 'الدول',
    short: 'الدول التي تظهر فيها الإعلانات. إضافة دولة تحتاج موافقة؛ والإزالة لا.',
  },
  'gads.languages': { title: 'اللغات', short: 'لغات المستخدمين المستهدفة. إضافة لغة تحتاج موافقة.' },
  'gads.dates': {
    title: 'التواريخ',
    short: 'البدء والانتهاء (بتوقيت الحساب). تمديد النهاية أو إزالتها يحتاج موافقة.',
  },
  'gads.label': {
    title: 'تسمية المنتج',
    short: 'تسمية الحملة المرسلة إلى Merchant كـ custom_label_0؛ يتضمن مرشّح المنتجات هذه التسمية.',
  },
  'gads.accept_google': {
    title: 'قبول قيم Google',
    short: 'يطابق سجل النظام مع Google Ads؛ لا يُرسل شيء إلى Google.',
  },
  'gads.operations': {
    title: 'إجراءات الحملة',
    short: 'ما يحتاج موافقة يُرسل للموافقة، والباقي يدخل قائمة الانتظار بعد تحديد المربع.',
  },
  'gads.product_states': {
    title: 'حالة المنتج',
    short: 'في الانتظار ← أُرسل إلى Google ← مؤهل / محدود / غير مؤهل (مع أسباب Google).',
  },
  'gads.operation_history': {
    title: 'التغييرات',
    short: 'من طلب ومن وافق وهل طُبّق على Google؛ وسبب الفشل إن وجد.',
  },
  'gads.recommendations': {
    title: 'توصيات Google',
    short: 'تُقرأ من Google عند الطلب؛ ويتطلب تطبيقها موافقة دائمًا.',
  },
  'gads.change_history': {
    title: 'سجل التغييرات',
    short: 'سجل تغييرات Google Ads لآخر 14 يومًا؛ لا يُخزَّن.',
  },
  'gads.send_operation': {
    title: 'إرسال',
    short:
      'ما يحتاج موافقة يُرسل للموافقة والباقي لقائمة الانتظار؛ يتحقق العامل أولًا ثم يطبّق ويقرأ النتيجة.',
  },
  'gads.product_box': { title: 'إعلانات Google', short: 'حملة Google Ads للمنتج وحالته في Google وأهليته.' },
  'gads.bulk': {
    title: 'إضافة إلى حملة Google / إزالة',
    short: 'يضيف المنتجات المحددة إلى حملة أو يزيلها؛ وتُعرض غير المؤهلة مع الأسباب.',
  },
  'gads.filter': { title: 'مرشّح إعلانات Google', short: 'يصفّي المنتجات حسب حالتها في الحملات.' },
  'gads.search_source': {
    title: 'مصدر المسودة',
    short: 'المنتج أو الفئة التي تُبنى منها مسودة الإعلان.',
  },
  'gads.search_suggest': {
    title: 'مسودة من البيانات',
    short: 'يقترح العناوين والأوصاف والمسار المعروض والكلمات المفتاحية؛ تعدّلها وترسلها للموافقة.',
  },
  'gads.search_final_url': {
    title: 'عنوان URL النهائي',
    short: 'الصفحة التي تُفتح بعد النقر على الإعلان؛ يجب أن تكون على نطاق المتجر.',
  },
  'gads.search_path': {
    title: 'المسار المعروض',
    short: 'جزآن يظهران بعد النطاق في الإعلان (حتى 15 حرفًا لكل منهما).',
  },
  'gads.search_headlines': {
    title: 'العناوين',
    short: 'من 3 إلى 15 عنوانًا، كل منها حتى 30 حرفًا؛ يجرّب Google التركيبات.',
  },
  'gads.search_descriptions': {
    title: 'الأوصاف',
    short: 'من 2 إلى 4 أوصاف، كل منها حتى 90 حرفًا.',
  },
  'gads.search_keywords': {
    title: 'الكلمات المفتاحية',
    short: 'عمليات البحث التي قد يظهر فيها الإعلان، مع نوع المطابقة (واسعة، عبارة، تامة).',
  },
  'gads.search_negatives': {
    title: 'الكلمات المفتاحية السلبية',
    short: 'عمليات البحث التي يجب ألا يظهر فيها الإعلان (مثل «مجاني»).',
  },
  'gads.search_ideas': {
    title: 'اقتراح كلمات مفتاحية',
    short: 'اقتراحات وعدد عمليات البحث الشهرية من خدمة التخطيط في Google.',
  },
  'gads.text_review': {
    title: 'مراجعة الخبير',
    short: 'إذا احتوى نص الإعلان على ادعاءات صحية، يجب أن يوافق عليه المراجع البيطري.',
  },
  'gads.text_review_decide': {
    title: 'الموافقة على النص / رفضه',
    short: 'قرار الخبير؛ يتطلب الرفض سببًا.',
  },
  'gads.search_edit_ad': {
    title: 'تعديل نص الإعلان',
    short: 'يُحفظ مباشرة في المسودة؛ في الحملة الحية يكون تغيير النص طلب موافقة.',
  },
  'gads.search_edit_keywords': {
    title: 'تعديل الكلمات المفتاحية',
    short: 'تتطلب الإضافة موافقة؛ الحذف فقط يُطبّق فورًا بعد خانة التأكيد.',
  },
  'gads.search_edit_negatives': {
    title: 'تعديل الكلمات السلبية',
    short: 'تُطبّق الإضافة فورًا بعد خانة التأكيد؛ يتطلب الحذف موافقة.',
  },
  'gads.search_google_state': {
    title: 'الحالة في Google',
    short: 'موافقة السياسة وحالة المراجعة وقوة الإعلان من Google (تُقرأ كل ساعة).',
  },
  'gads.access_level': {
    title: 'مستوى الوصول إلى Google Ads API',
    short: 'المستوى الذي منحه Google لمشروع Cloud: Explorer أو Basic أو Standard.',
  },
  'page.needs_finder': {
    title: 'دليل الاحتياجات',
    short: 'يحرّر مجموعة أسئلة «احتياجات حيواني الأليف» ويعتمدها لدى الخبير وينشرها في المتجر.',
  },
  'needs_finder.generate': {
    title: 'المسودة الأولى من بيانات المنتجات',
    short: 'يُنشئ مجالات الدعم من الفئات وقواعد التوصية من المنتجات وسؤال طوارئ عامًا.',
  },
  'needs_finder.start_empty': {
    title: 'مسودة فارغة',
    short: 'تبدأ دون مجالات أو أسئلة أو قواعد؛ وتضيف كل شيء بنفسك.',
  },
  'needs_finder.save': {
    title: 'حفظ المسودة',
    short: 'يحفظ تعديلاتك؛ وإذا تغيّر المحتوى تسقط موافقة الخبير.',
  },
  'needs_finder.status': { title: 'الحالة والنشر', short: 'حالة المراجعة والنسخة المنشورة وقائمة التحقق.' },
  'needs_finder.problems': {
    title: 'قائمة التحقق',
    short: 'بنود تمنع النشر (أحمر) وبنود تحتاج انتباهًا (أصفر).',
  },
  'needs_finder.submit': {
    title: 'إرسال للمراجعة',
    short: 'يرسل المسودة المحفوظة إلى المراجِع البيطري للموافقة.',
  },
  'needs_finder.review': {
    title: 'قرار الخبير',
    short: 'يوافق المراجِع البيطري على المسودة أو يرفضها مع السبب.',
  },
  'needs_finder.review_note': {
    title: 'ملاحظة الخبير',
    short: 'سبب القرار؛ إلزامية عند الرفض وتُسجَّل في سجل التدقيق.',
  },
  'needs_finder.findings': {
    title: 'ادعاءات صحية',
    short: 'عبارات مثل الوقاية من المرض أو علاجه في النصوص؛ ليست حكمًا نهائيًا ويقرر الخبير.',
  },
  'needs_finder.products': {
    title: 'المنتجات المحتملة',
    short: 'كل المنتجات في القواعد والبدائل مع أسبابها وحالتها في المتجر.',
  },
  'needs_finder.publish': { title: 'نشر', short: 'ينشر المسودة المعتمدة في المتجر على /ihtiyac-bulucu.' },
  'needs_finder.unpublish': { title: 'إلغاء النشر', short: 'يغلق صفحة المتجر؛ وتبقى المسودة والموافقة.' },
  'needs_finder.regenerate': {
    title: 'إعادة إنشاء المسودة',
    short: 'يستبدل المسودة الحالية بأخرى من بيانات المنتجات؛ وتضيع التعديلات والموافقة.',
  },
  'needs_finder.pet_profiles': {
    title: 'احفظ حيواني',
    short: 'يمكن للعضو حفظ المعلومات الأساسية لحيوانه بموافقة صريحة. معطّل افتراضيًا.',
  },
  'needs_finder.translations': {
    title: 'لغات أخرى',
    short: 'نسخ النص بالإنجليزية والألمانية والعربية؛ إن كانت فارغة يظهر النص التركي.',
  },
  'needs_finder.condition': {
    title: 'الشرط',
    short: 'متى تسري القاعدة أو السؤال أو الاستثناء: النوع والعمر والوزن والتعقيم والحمل والمجال والإجابة.',
  },
  'needs_finder.row_actions': {
    title: 'ترتيب وتعديل وحذف',
    short: 'يغيّر الترتيب أو يعدّل العنصر أو يزيله من المسودة؛ قابل للتراجع حتى الحفظ.',
  },
  'needs_finder.areas': {
    title: 'مجالات الدعم',
    short: 'الموضوعات التي يختارها الزائر؛ تظهر للأنواع المحددة فقط.',
  },
  'needs_finder.area_label': { title: 'اسم المجال', short: 'الاسم الظاهر في المتجر (مثل «المفاصل»).' },
  'needs_finder.area_description': { title: 'وصف قصير', short: 'جملة واحدة تحت المجال؛ اختيارية.' },
  'needs_finder.area_species': {
    title: 'يظهر للأنواع',
    short: 'لا يُعرض المجال إلا عند اختيار أحد هذه الأنواع.',
  },
  'needs_finder.area_categories': { title: 'الفئات المرتبطة', short: 'فئات المنتجات التي جاء منها المجال.' },
  'needs_finder.id': { title: 'المعرّف', short: 'اسم قصير يُستخدم في الشروط؛ لا تغيّره بعد الحفظ.' },
  'needs_finder.questions': {
    title: 'الأسئلة',
    short: 'أسئلة تُطرح بالترتيب؛ وتتفرّع حسب المجال أو الإجابات السابقة.',
  },
  'needs_finder.question_text': {
    title: 'نص السؤال',
    short: 'الجملة التي تُطرح على الزائر. لا تكتب أسئلة جرعات أو تشخيص.',
  },
  'needs_finder.question_help': { title: 'نص المساعدة', short: 'شرح قصير تحت السؤال؛ اختياري.' },
  'needs_finder.question_area': {
    title: 'المجال المرتبط',
    short: 'إن حُدّد يُطرح السؤال عند اختيار هذا المجال فقط؛ «عام» لكل زائر.',
  },
  'needs_finder.question_multiple': { title: 'اختيار متعدد', short: 'يمكن للزائر تحديد أكثر من خيار.' },
  'needs_finder.options': { title: 'الخيارات', short: 'إجابات السؤال (2–12).' },
  'needs_finder.option_label': { title: 'نص الخيار', short: 'يظهر إجابةً في المتجر.' },
  'needs_finder.option_emergency': {
    title: 'خيار طوارئ',
    short: 'عند اختياره لا تُقترح منتجات؛ ويظهر «يرجى مراجعة طبيب بيطري أولًا».',
  },
  'needs_finder.option_exclusive': {
    title: 'يُختار وحده',
    short: 'مثل «لا شيء مما سبق»: اختياره يلغي غيره.',
  },
  'needs_finder.rules': {
    title: 'قواعد التوصية',
    short: 'إذا تحقق الشرط يُقترح المنتج بسببه المعتمد؛ وتُرتب حسب الأولوية.',
  },
  'needs_finder.rule_product': { title: 'المنتج المقترح', short: 'المنتج الذي يُقترح عند تحقق الشرط.' },
  'needs_finder.rule_reason': {
    title: 'سبب الاقتراح',
    short: 'سبب معتمد يظهر تحت المنتج. لا تستخدم ادعاءات الوقاية من المرض أو علاجه.',
  },
  'needs_finder.rule_priority': { title: 'الأولوية', short: 'الاقتراحات الأعلى أولوية تأتي أولًا (0–100).' },
  'needs_finder.rule_alternatives': {
    title: 'البدائل',
    short: 'بدائل معتمدة تُجرّب بالترتيب عند نفاد المنتج (5 كحد أقصى).',
  },
  'needs_finder.exclusions': {
    title: 'الاستثناءات',
    short: 'إذا تحقق الشرط لا تُقترح المنتجات المدرجة من أي قاعدة؛ ولها الأولوية دائمًا.',
  },
  'needs_finder.exclusion_products': {
    title: 'منتجات لا تُقترح',
    short: 'منتجات لا تقترحها أي قاعدة عند تحقق الشرط.',
  },
  'needs_finder.exclusion_note': { title: 'ملاحظة', short: 'سبب الاستثناء (في اللوحة والمعاينة).' },
  'needs_finder.texts': { title: 'النصوص', short: 'نص المقدمة ونص الطوارئ وحملة الحزمة.' },
  'needs_finder.intro': {
    title: 'نص المقدمة',
    short: 'يظهر أعلى الصفحة؛ وإن كان فارغًا يظهر النص الافتراضي.',
  },
  'needs_finder.emergency_text': {
    title: 'نص الطوارئ',
    short: 'يظهر تحت «يرجى مراجعة طبيب بيطري أولًا» عند اختيار حالة طوارئ.',
  },
  'needs_finder.bundle': {
    title: 'حملة حزمة الاحتياجات',
    short: 'حملة تلقائية اختيارية (معطّلة افتراضيًا)؛ إن كانت تعمل يظهر اسمها وشرطها.',
  },
  'needs_finder.preview': { title: 'معاينة', short: 'الحساب نفسه لمحرك المتجر؛ ولا يراعي المخزون.' },
  'needs_finder.report': { title: 'التقرير', short: 'إجماليات فقط؛ دون هوية الزائر أو إجاباته.' },
  'needs_finder.report_days': { title: 'المدة', short: 'آخر 7 أو 30 أو 90 يومًا (بتوقيت إسطنبول).' },
  'page_designs.needs_finder': {
    title: 'تصميم «احتياجات حيواني الأليف»',
    short: 'مظهر تدفق الأسئلة: بطاقات أو محادثة أو صفحة واحدة مع ملخّص مباشر.',
  },
  'page.ads': {
    title: 'مركز الإعلانات',
    short:
      'يعرض الإنفاق الإعلاني إلى جانب الطلبات الفعلية للمتجر: أداء الحملات، وROAS، وتكلفة الطلب الواحد، والربح، والتنبيهات، وتغييرات الميزانية المعتمدة.',
  },
  'ads.connections': {
    title: 'اتصالات الإعلانات',
    short: 'يتم ربط Meta وTikTok من صفحة «الاتصالات» (للقراءة فقط).',
  },
  'ads.sync_now': {
    title: 'المزامنة الآن',
    short: 'يقرأ بيانات آخر 7 أيام (30 يومًا في المزامنة الأولى) من اتصالات Meta/TikTok المباشرة.',
  },
  'ads.add_account': { title: 'إضافة حساب', short: 'يضيف حسابًا إعلانيًا تقوم برفع تقريره كملف.' },
  'ads.save_account': { title: 'حفظ', short: 'يحفظ الحساب. تُخفى الحسابات المؤرشفة من التقرير.' },
  'ads.account_platform': { title: 'المنصة', short: 'مكان عرض الإعلانات؛ ويحدد مصادر المطابقة الافتراضية.' },
  'ads.account_name': { title: 'اسم الحساب', short: 'الاسم المعروض في التقرير (2–80 حرفًا).' },
  'ads.account_external_id': {
    title: 'معرّف الحساب على المنصة',
    short: 'اختياري؛ ويجب أن يكون فريدًا لكل منصة.',
  },
  'ads.account_currency': {
    title: 'العملة',
    short: 'عملة الحساب الإعلاني؛ ويجب أن تكون المبالغ المرفوعة بهذه العملة.',
  },
  'ads.account_utm_sources': {
    title: 'مصادر المطابقة (utm_source)',
    short: 'تُنسب إلى هذا الحساب الطلبات التي يكون مصدر آخر زيارة لها أحد هذه المصادر.',
  },
  'ads.account_status': {
    title: 'الحالة',
    short: 'تُستبعد الحسابات المؤرشفة من التقرير؛ مع الاحتفاظ ببياناتها.',
  },
  'ads.account_actions': { title: 'رفع التقرير والتعديل', short: 'ارفع تقرير المنصة أو عدّل الحساب.' },
  'ads.upload_file': {
    title: 'ملف التقرير',
    short: 'ملف CSV أو XLSX بحجم أقصاه 10 MB يتضمن أعمدة التاريخ والحملة والإنفاق.',
  },
  'ads.apply_import': {
    title: 'حفظ البيانات',
    short: 'يحفظ الصفوف الصالحة المعروضة في المعاينة؛ وتُستبدل الصفوف الموجودة.',
  },
  'ads.report': {
    title: 'أداء الحملات',
    short: 'CTR وCPC وCPM وتكلفة الطلب الواحد وROAS بناءً على الطلبات الفعلية.',
  },
  'ads.period': { title: 'الفترة', short: 'آخر 7 أو 30 أو 90 يومًا (بتوقيت إسطنبول).' },
  'ads.platform_filter': { title: 'المنصة', short: 'يقصر التقرير على منصة واحدة.' },
  'ads.compare': { title: 'مقارنة', short: 'اختر حتى 4 حملات لمقارنتها جنبًا إلى جنب.' },
  'ads.anomalies': {
    title: 'التنبيهات',
    short: 'الارتفاعات المفاجئة في الإنفاق، وانخفاض CTR، والإنفاق دون نقرات، والمزامنات المتأخرة.',
  },
  'ads.product_ads': {
    title: 'منتجات إعلانات التسوق',
    short: 'الإنفاق والنقرات والتحويلات لكل منتج من إعلانات Google Shopping، مع صافي المبيعات وROAS المنتج.',
  },
  'ads.products': { title: 'أداء المنتجات', short: 'المنتجات الواردة في الطلبات المنسوبة إلى الإعلانات.' },
  'ads.request_change': {
    title: 'طلب تغيير',
    short: 'يرسل تغييرًا في الميزانية أو في حالة العرض للموافقة عليه.',
  },
  'ads.change_kind': { title: 'التغيير', short: 'الميزانية اليومية أو حالة العرض.' },
  'ads.change_budget': { title: 'الميزانية اليومية الجديدة', short: 'بعملة الحساب.' },
  'ads.change_status': { title: 'الحالة الجديدة', short: 'إيقاف الحملة مؤقتًا أو استئنافها.' },
  'ads.change_note': { title: 'السبب', short: 'سبب الحاجة إلى التغيير (3–500 حرف).' },
  'ads.send_request': { title: 'إرسال للموافقة', short: 'يحفظ الطلب؛ ولا يتغير أي شيء على المنصة.' },
  'ads.history': { title: 'سجل التغييرات', short: 'الطلبات والموافقات وعمليات الرفع والمزامنة.' },
  'ads.change_actions': {
    title: 'البتّ، تم التطبيق، الإلغاء',
    short: 'الموافقة على الطلب أو رفضه، أو وضع علامة «مطبّق» عليه، أو سحبه.',
  },
  'ads.approve': { title: 'موافقة', short: 'يوافق على الطلب (يلزم التحقق بخطوتين).' },
  'ads.reject': { title: 'رفض', short: 'يرفض الطلب.' },
  'ads.decision_note': { title: 'ملاحظة القرار', short: 'ملاحظة اختيارية تظهر في السجل.' },
  'payments.go_live_skip_sandbox': {
    title: 'التحويل إلى الوضع المباشر دون دفعة تجريبية',
    short:
      'للمالك فقط. يتيح التحويل إلى الوضع المباشر دون دفعة Sandbox ناجحة؛ ويتطلب التحقق بخطوتين ويُسجَّل في سجل التدقيق.',
  },
  'payments.go_live_confirm': {
    title: 'التحويل إلى الوضع المباشر',
    short:
      'يحوّل الدفع بالبطاقة إلى الوضع المباشر؛ وسيتم الخصم من بطاقات حقيقية. يتطلب اجتياز اختبار الاتصال المباشر بنجاح.',
  },
  'payments.first_live_order': {
    title: 'فحص أول طلب مباشر',
    short:
      'قدّم طلبًا صغيرًا ببطاقتك الخاصة، وتحقق من أنه مدفوع، ثم استرد المبلغ. يختفي هذا التنبيه بعد استرداد المبلغ.',
  },
  'page.retention': {
    title: 'الاحتفاظ والإتلاف',
    short:
      'الحذف التلقائي للبيانات الشخصية التي انتهت مدة الاحتفاظ بها (معطّل افتراضيًا)، والمدد الثابتة، وسجل الإتلاف.',
  },
  'page.sales_regions': {
    title: 'مناطق المبيعات',
    short: 'مناطق تتكون من ولايات/أقضية ومديروها؛ وإسناد الموزّعين إلى المناطق حسب الموقع.',
  },
  'sales_regions.new': { title: 'إضافة منطقة', short: 'منطقة مبيعات جديدة باسم ومواقع ومدير اختياري.' },
  'sales_regions.auto_assign': {
    title: 'الإسناد حسب الولاية/القضاء',
    short:
      'يطابق ولاية/قضاء الموزّعين مع المناطق: المعاينة أولًا ثم التطبيق. ويشمل افتراضيًا الموزّعين الذين ليست لهم منطقة فقط.',
  },
  'sales_regions.manager': {
    title: 'مدير المنطقة',
    short:
      'يرى جميع الموزّعين في المنطقة (مع نطاق «الموزّعون المسندون فقط»). يجب أن يكون مستخدمًا نشطًا في لوحة التحكم يمكنه رؤية الموزّعين.',
  },
  'sales_regions.places': {
    title: 'الولايات والأقضية',
    short: 'اترك القضاء فارغًا لتضمين الولاية بأكملها؛ أو اختر قضاءً لتضمينه وحده.',
  },
  'dealers.sales_assignment': {
    title: 'مندوب المبيعات والمنطقة',
    short:
      'مندوب الموزّع ومنطقته. يرى هذا الموزّعَ المندوبون ذوو النطاق المحدد ومديرو المناطق؛ وتسجّل الطلبات المندوب وقت الطلب.',
  },
  'dealers.sales_rep': {
    title: 'مندوب المبيعات',
    short: 'مستخدم نشط في لوحة التحكم يمكنه رؤية الموزّعين. فارغ: بلا مندوب.',
  },
  'dealers.sales_region': {
    title: 'منطقة المبيعات',
    short: 'تُختار هنا أو تُسند بشكل جماعي حسب الولاية/القضاء من صفحة «مناطق المبيعات».',
  },
  'dealers.sales_filter': {
    title: 'تصفية حسب المندوب والمنطقة',
    short: 'موزّعو مندوب أو منطقة؛ ويعرض خيارا «بلا مندوب» / «بلا منطقة» الموزّعين غير المسندين.',
  },
  'page.bizimhesap': {
    title: 'BizimHesap',
    short:
      'يُعدّ BizimHesap السجل الرئيسي لحسابات الموزّعين: حسابات الصندوق، ومطابقة الموزّع ↔ الحساب، وصلاحيات الكتابة، وتصحيح الفواتير المرسلة دون حساب صندوق، وقائمة انتظار التحصيل.',
  },
  'dealers.bizimhesap_code': {
    title: 'حساب BizimHesap',
    short: 'رمز حساب الموزّع في BizimHesap؛ ولا تُرسل الفواتير ما دام غير مرتبط.',
  },
  'dealers.bizimhesap_link': { title: 'رمز الحساب', short: 'يُتحقق منه مقابل قائمة حسابات BizimHesap.' },
  'bizimhesap.statement': { title: 'كشف حساب BizimHesap', short: 'حركات الحساب والرصيد في BizimHesap.' },
  'bizimhesap.refresh_one': {
    title: 'تحديث هذا الموزّع',
    short: 'يجلب كشف حساب هذا الموزّع الآن (للقراءة فقط).',
  },
  'bizimhesap.refresh_all': {
    title: 'التحديث الآن',
    short: 'يضع كشوف حسابات جميع الموزّعين المرتبطين في قائمة الانتظار.',
  },
  'bizimhesap.diff': {
    title: 'تقرير الفروقات',
    short: 'رصيد BizimHesap + ما لم يُنقل مقابل دفتر الأستاذ في هذا النظام.',
  },
  'invoices.provider_cancel': {
    title: 'الإلغاء في BizimHesap',
    short:
      'يلغي سجل الفاتورة في BizimHesap لطلب أُلغي بالكامل؛ وتحتاج المستندات الإلكترونية إلى فاتورة إرجاع.',
  },
  'invoices.provider_cancel_resolve': { title: 'نتيجة الإلغاء', short: 'ما رأيته في لوحة BizimHesap.' },
  'bizimhesap.cash_map': {
    title: 'حسابات الصندوق',
    short: 'حساب صندوق في BizimHesap لكل طريقة دفع. وتُصدر فواتير الطلبات المدفوعة باستخدامه.',
  },
  'bizimhesap.refresh_cashiers': { title: 'جلب حسابات الصندوق', short: 'يجلب حسابات الصندوق من BizimHesap.' },
  'bizimhesap.cash_card': { title: 'حساب الدفع بالبطاقة', short: 'الطلبات المدفوعة عبر iyzico/PayTR.' },
  'bizimhesap.cash_bank_transfer': {
    title: 'حساب التحويل البنكي',
    short: 'الطلبات المدفوعة بالتحويل البنكي.',
  },
  'bizimhesap.cash_cash_on_delivery': {
    title: 'حساب الدفع عند الاستلام',
    short: 'الطلبات المحصّلة عند الباب.',
  },
  'bizimhesap.cash_manual': {
    title: 'حساب الدفع اليدوي',
    short: 'المدفوعات المعلَّمة في لوحة التحكم بخيار «تم استلام الدفعة».',
  },
  'bizimhesap.cash_cash': {
    title: 'حساب التحصيل النقدي',
    short: 'التحصيلات النقدية المُدخلة لحسابات الموزّعين.',
  },
  'bizimhesap.save_cash': { title: 'حفظ حسابات الصندوق', short: 'يحفظ الاختيار؛ ويُسجَّل في سجل التدقيق.' },
  'bizimhesap.links': {
    title: 'الموزّع ↔ حساب BizimHesap',
    short: 'تستخدم فواتير الموزّع رمز الحساب هذا. ولا تُرسل فواتير الموزّعين غير المرتبطين.',
  },
  'bizimhesap.import_customers': {
    title: 'استيراد الحسابات',
    short: 'يطابق قائمة حسابات BizimHesap مع الموزّعين (رمز الموزّع أولًا ثم الرقم الضريبي). المعاينة أولًا.',
  },
  'bizimhesap.ambiguous': {
    title: 'مطابقة غير محسومة',
    short: 'عدة مرشحين؛ اختر الحساب الصحيح أو اتركه غير مرتبط.',
  },
  'bizimhesap.writes': {
    title: 'الكتابة إلى BizimHesap',
    short: 'خطوات تكتب في حسابك المحاسبي الفعلي. معطّلة افتراضيًا؛ وتتطلب صلاحية المالك/المسؤول والتأكيد.',
  },
  'bizimhesap.write_collections': {
    title: 'إرسال التحصيلات',
    short: 'تُرسل التحصيلات الموجودة في قائمة الانتظار بالضغط على «إرسال».',
  },
  'bizimhesap.write_customers': {
    title: 'إضافة الحسابات',
    short: 'يفتح حسابًا في BizimHesap لموزّع ليس لديه حساب.',
  },
  'bizimhesap.write_cancel': {
    title: 'إلغاء الفواتير',
    short:
      'يلغي سجل BizimHesap لطلب أُلغي بالكامل. أما الفاتورة الإلكترونية فتحتاج إلى إرجاع بدلًا من ذلك (بانتظار تأكيد المحاسب).',
  },
  'bizimhesap.save_writes': {
    title: 'حفظ إعدادات الكتابة',
    short: 'يتطلب التحقق بخطوتين؛ ويُسجَّل في سجل التدقيق.',
  },
  'bizimhesap.corrections': {
    title: 'الطلبات المدفوعة المرسلة دون حساب صندوق',
    short: 'افتح سجلات تحصيل لها.',
  },
  'bizimhesap.queue_corrections': { title: 'فتح سجلات التحصيل', short: 'لا يُرسل أي شيء إلى BizimHesap.' },
  'bizimhesap.collections': {
    title: 'قائمة انتظار التحصيل',
    short: 'التحصيلات المعلّقة والمرسلة والفاشلة وغير المؤكدة.',
  },
  'bizimhesap.collection_actions': {
    title: 'إرسال · التحقق من الكشف · إلغاء السجل',
    short: 'يُتحقق من التحصيلات غير المؤكدة بالبحث عن رقم التحصيل في كشف الحساب.',
  },
  'bizimhesap.cancel_note': {
    title: 'السبب',
    short: 'مثلًا: «أُدخل يدويًا في BizimHesap». ويُسجَّل في سجل التدقيق.',
  },
  'bizimhesap.samples': {
    title: 'نماذج الاستجابات',
    short: 'أولى الاستجابات الفعلية مع إخفاء البيانات الشخصية.',
  },
  'page.sales_commissions': {
    title: 'عمولات المندوبين',
    short: 'قواعد عمولات مندوبي المبيعات والكشوف الشهرية: الحساب، والموافقة، وتسجيل الدفع، وملف CSV.',
  },
  'sales_commissions.rules': {
    title: 'قواعد العمولة',
    short:
      'يُطبَّق على كل بند القاعدة الأكثر تحديدًا: الخاصة بالمندوب قبل العامة، والمنتج قبل الفئة، والفئة قبل جميع المنتجات؛ وعند التساوي تُطبَّق أحدث قاعدة.',
  },
  'sales_commissions.rate': {
    title: 'نسبة العمولة',
    short: 'نسبة مئوية من المبلغ الصافي (50% كحد أقصى). وتُثبَّت عند أول حساب للطلب.',
  },
  'sales_commissions.rule_rep': {
    title: 'المندوب',
    short: 'فارغ: تنطبق على جميع المندوبين. محدد: طلبات ذلك المندوب فقط.',
  },
  'sales_commissions.rule_scope': {
    title: 'نطاق الفئة والمنتج',
    short: 'عند عدم اختيار فئات أو منتجات: تنطبق على جميع المنتجات.',
  },
  'sales_commissions.period': {
    title: 'الكشوف الشهرية',
    short:
      'كشف واحد لكل مندوب ولكل شهر. تؤدي «الموافقة» إلى قفله (ويُحتفظ به عند إعادة الحساب)؛ ويسجّل «وضع علامة مدفوع» الدفعة التي تمت خارج النظام.',
  },
  'sales_commissions.calculate': {
    title: 'حساب الفترة',
    short: 'يحسب طلبات الشهر وتغييرات التحصيل/الاسترداد للطلبات السابقة؛ ويعيد إنشاء مسودات الكشوف.',
  },
  'sales_commissions.csv': {
    title: 'تنزيل CSV',
    short: 'جميع بنود الكشف للفترة (الطلب، والنوع، والحصة المحصّلة، والأساس، والعمولة).',
  },
  'sales_commissions.paid_note': {
    title: 'ملاحظة الدفع',
    short: 'كيفية إجراء الدفع (مثلًا: كشف رواتب أكتوبر). ويُسجَّل في سجل التدقيق.',
  },
  'page.quotes': {
    title: 'عروض الأسعار',
    short: 'عروض الأسعار التي يطلبها الموزّعون والتي تعدّها أنت؛ الحالة ومدة الصلاحية.',
  },
  'page.quote_detail': {
    title: 'عرض السعر',
    short: 'البنود والأسعار ومدة الصلاحية والملاحظة؛ الإرسال والإلغاء والطباعة.',
  },
  'quotes.new': { title: 'عرض سعر جديد', short: 'يفتح عرض سعر فارغًا لموزّع معتمد.' },
  'quotes.status_filter': {
    title: 'الحالة',
    short: 'مطلوب، أو مسودة، أو مرسل، أو تم الطلب، أو مرفوض، أو ملغى.',
  },
  'quotes.search': { title: 'بحث', short: 'جزء من رقم عرض السعر أو اسم الموزّع.' },
  'quotes.dealer': { title: 'الموزّع', short: 'الموزّعون المعتمدون فقط؛ وتتبع الأسعار مجموعة الموزّع.' },
  'quotes.print': {
    title: 'طباعة',
    short: 'يطبع عرض السعر؛ احفظه بصيغة PDF من المتصفح. ولا تُطبع الملاحظة الداخلية.',
  },
  'quotes.save': { title: 'حفظ', short: 'يحفظ البنود والأسعار والشروط؛ ويعود عرض السعر المرسل إلى مسودة.' },
  'quotes.send': {
    title: 'إرسال',
    short:
      'ينشئ نسخة غير قابلة للتعديل يراها الموزّع في «حسابي»؛ ويرسل بريدًا إلكترونيًا إذا كان إرسال البريد مُعدًّا.',
  },
  'quotes.cancel': { title: 'إلغاء', short: 'لا يعود بالإمكان قبول عرض السعر؛ ويلزم ذكر سبب.' },
  'quotes.valid_until': { title: 'صالح حتى', short: 'آخر يوم يمكن فيه قبول عرض السعر؛ وهو مطلوب للإرسال.' },
  'quotes.note': { title: 'ملاحظة للموزّع', short: 'تظهر للموزّع في عرض السعر.' },
  'quotes.internal_note': { title: 'ملاحظة داخلية', short: 'في لوحة التحكم فقط؛ لا تظهر للموزّع ولا تُطبع.' },
  'quotes.cancel_reason': {
    title: 'سبب الإلغاء',
    short: '3 أحرف على الأقل؛ ويُحفظ في لوحة التحكم وسجل التدقيق.',
  },
  'page.ledger': {
    title: 'حسابات الموزّعين',
    short: 'أرصدة الموزّعين والمبالغ المتأخرة وأقدم تواريخ الاستحقاق؛ واستيراد الأرصدة الافتتاحية.',
  },
  'page.company_ledger': {
    title: 'حساب الموزّع',
    short: 'الرصيد وتقادم الديون وكشف الحساب (الرصيد المُرحَّل والرصيد الجاري)؛ وتسجيل المدفوعات والتسويات.',
  },
  'ledger.search': { title: 'البحث عن الموزّعين', short: 'جزء من اسم الشركة أو رمز الموزّع.' },
  'ledger.only_overdue': {
    title: 'المتأخرة فقط',
    short: 'يعرض الموزّعين الذين لديهم مبالغ غير مدفوعة تجاوزت تاريخ استحقاقها.',
  },
  'ledger.import': {
    title: 'استيراد الأرصدة الافتتاحية',
    short:
      'استورد أرصدة الموزّعين من نظامك المحاسبي السابق (CSV/Excel): رمز الموزّع أو الرقم الضريبي، والمبلغ (المدين موجب والدائن سالب)، والعملة اختياريًا، والتاريخ، وتاريخ الاستحقاق، والوصف. المعاينة أولًا.',
  },
  'page.ledger_bank_import': {
    title: 'المعاملات البنكية',
    short: 'ارفع كشف حسابك البنكي وقيّد مدفوعات الموزّعين في حساباتهم بشكل جماعي.',
  },
  'ledger.bank_import': {
    title: 'رفع المعاملات البنكية',
    short: 'يقيّد مدفوعات الموزّعين من كشف الحساب البنكي كتحصيلات، بعد المعاينة.',
  },
  'ledger.bank_import_file': {
    title: 'كشف الحساب البنكي',
    short: 'ملف CSV أو XLSX يتضمن التاريخ والمبلغ (أو الدائن/المدين). ويتم تخطي المعاملات الصادرة.',
  },
  'ledger.bank_import_dealer': {
    title: 'الموزّع',
    short: 'تحقق من الموزّع المقترح أو اختر واحدًا من القائمة.',
  },
  'ledger.bank_import_apply': {
    title: 'قيد المحدد',
    short: 'يقيّد المعاملات المحددة كتحصيلات بالتحويل البنكي؛ وتُطبَّق المعاينة مرة واحدة فقط.',
  },
  'organization.system_name': {
    title: 'اسم اللوحة (اسم النظام)',
    short:
      'الاسم الظاهر أعلى لوحة الإدارة وفي علامة تبويب المتصفح وصفحة الدخول. اتركه فارغًا لاستخدام «Zootopia Panel».',
  },
  'integrations.verify_all': {
    title: 'التحقق من جميع الاتصالات',
    short:
      'يختبر جميع الاتصالات المحفوظة الآن ويعرض النتيجة. تُشغَّل فقط الاختبارات التي لا ترسل رسائل ولا تفتح مدفوعات ولا تُنشئ تكلفة؛ ولا تتغير حالة الاتصال.',
  },
  'ledger.balance_payments': {
    title: 'مدفوعات الرصيد بالبطاقة',
    short: 'مدفوعات بالبطاقة أجراها الموزّع من «حسابي»؛ وتُقيَّد المدفوعات المؤكدة كتحصيلات بالبطاقة.',
  },
  'dashboard.dealer_payments': {
    title: 'أحدث مدفوعات الموزّعين',
    short:
      'مدفوعات بالبطاقة أجراها الموزّعون من «حسابي ← كشف الحساب» خلال آخر 30 يومًا (أحدث 10). تُقيَّد كل دفعة في حساب الموزّع تلقائيًا، وتذهب الأموال إلى حسابك لدى مزوّد الدفع.',
  },
  'dashboard.dealer_payment_email': {
    title: 'بريد إلكتروني عند دفع الموزّع',
    short:
      'عند التفعيل، يتلقى مستلمو التنبيهات (أو المالكون والمسؤولون إن لم يوجدوا) بريدًا بالمبلغ ومفتاح الدفع عندما يدفع موزّع بالبطاقة. لا يتأثر إشعار Android بهذا الخيار.',
  },
  'ledger.import_apply': {
    title: 'القيد في الدفتر',
    short:
      'يقيّد صفوف المعاينة الصالحة كأرصدة افتتاحية. ويتم تخطي الصفوف غير الصالحة؛ ويُطبَّق الملف مرة واحدة فقط.',
  },
  'ledger.currency': { title: 'العملة', short: 'لكل عملة دفترها ورصيدها الخاص.' },
  'ledger.period': { title: 'الفترة', short: 'تاريخا بداية الكشف ونهايته؛ وتُرحَّل القيود السابقة.' },
  'ledger.payment': {
    title: 'تسجيل دفعة',
    short: 'يسجّل المبلغ المستلم من الموزّع كقيد دائن، ويُخصم من أقدم دين مستحق.',
  },
  'ledger.adjustment': {
    title: 'تسجيل تسوية',
    short: 'قيد مدين أو دائن يدوي (مثل فرق الشحن)؛ ويلزم إدخال وصف.',
  },
  'ledger.reverse': {
    title: 'عكس القيد',
    short: 'يلغي قيدًا يدويًا بقيد معاكس. لا يُحذف أي شيء؛ وتتبع قيود الطلبات الطلبَ نفسه.',
  },
  'ledger.statement_csv': { title: 'تنزيل كشف الحساب (CSV)', short: 'كشف حساب الفترة المحددة.' },
  'ledger.print': { title: 'طباعة', short: 'اطبع كشف الحساب أو احفظه بصيغة PDF من المتصفح.' },
  'ledger.amount': { title: 'المبلغ', short: 'بخانات عشرية (مثلًا 1,250.50). ويُحدَّد الاتجاه من النوع.' },
  'ledger.entry_date': { title: 'تاريخ القيد', short: 'يوم الدفع أو التسوية؛ ولا يكون في المستقبل.' },
  'ledger.method': {
    title: 'طريقة الدفع',
    short: 'تحويل بنكي، أو نقدًا، أو شيك، أو سند لأمر، أو بطاقة، أو غير ذلك.',
  },
  'ledger.reference': { title: 'رقم المستند', short: 'رقم الإيصال أو الشيك أو السند (اختياري).' },
  'ledger.direction': { title: 'الاتجاه', short: 'يزيد المدين دين الموزّع؛ ويخفضه الدائن.' },
  'ledger.due_date': {
    title: 'تاريخ الاستحقاق',
    short: 'موعد استحقاق التسوية المدينة؛ وإذا تُرك فارغًا يُعتمد تاريخ القيد.',
  },
  'ledger.open_items': {
    title: 'البنود المفتوحة',
    short:
      'المبالغ غير المدفوعة، بدءًا بأقدم تاريخ استحقاق. تُخصم المدفوعات والمبالغ المستردة من أقدم دين مستحق. ويرى الموزّع القائمة نفسها في «حسابي».',
  },
  'ledger.reminders': {
    title: 'تذكيرات الدفع',
    short:
      'عند التفعيل، يتلقى الموزّع (البريد الإلكتروني للشركة والمسؤولون المفوّضون فيها) كل صباح في الساعة 09:10 رسالة بريد إلكتروني واحدة بشأن البنود التي يقترب استحقاقها أو المتأخرة. ويُذكَّر بكل بند مرة واحدة على الأكثر في كل مرحلة. معطّل افتراضيًا.',
  },
  'ledger.reminders_enabled': {
    title: 'تفعيل التذكيرات',
    short:
      'يؤدي التفعيل إلى إرسال رسائل بريد إلكتروني حقيقية إلى موزّعيك؛ وسيُطلب منك تحديد مربع التأكيد. ولا يُرسل أي شيء ما لم يكن إرسال البريد الإلكتروني مُعدًّا.',
  },
  'ledger.reminders_days': {
    title: 'عدد الأيام قبل الاستحقاق',
    short:
      'عدد الأيام قبل تاريخ الاستحقاق التي يُرسل فيها التذكير (0–30). عند اختيار 0 يُذكَّر بالبنود المتأخرة فقط.',
  },
  'ledger.reminders_save': {
    title: 'حفظ',
    short:
      'يحفظ إعداد التذكير. ويُسجَّل التغيير في سجل التدقيق؛ ويكون أول تشغيل في صباح اليوم التالي الساعة 09:10.',
  },
  'dealers.member_role': {
    title: 'الدور في الشركة',
    short:
      'المسؤول المفوّض: يطلب ويرى طلبات الشركة وكشف الحساب والمستخدمين ويدير المواقع. المشتري: يطلب ويرى طلباته الخاصة؛ وقد يُطبَّق عليه حدّ. العرض فقط: يرى الأسعار وطلبات الشركة وكشف الحساب؛ ولا يمكنه الطلب. وتحتفظ الشركة بمسؤول مفوّض واحد على الأقل.',
  },
  'dealers.order_limit': {
    title: 'حدّ الطلب',
    short:
      'لا يمكن للمشتري تقديم طلب يتجاوز هذا المبلغ (شاملًا الشحن)؛ وتطلب واجهة المتجر موافقة المسؤول المفوّض. فارغ: بلا حدّ. ولا يُطبَّق على الطلبات المقدَّمة من لوحة التحكم.',
  },
  'dealers.locations': {
    title: 'المواقع',
    short:
      'عناوين الفروع والتسليم والفوترة. يختار مستخدمو الشركة أحدها عند إتمام الطلب؛ ويحتفظ الطلب بنسخة منه. ويمكن للمسؤول المفوّض في الشركة أيضًا إضافة مواقع من «حسابي».',
  },
  'dealers.location_label': {
    title: 'اسم الموقع',
    short: 'اسم قصير يظهر في القوائم وعند إتمام الطلب (مثل «المكتب الرئيسي»)؛ حتى 40 حرفًا.',
  },
  'orders.location_fill': {
    title: 'التعبئة من موقع الشركة',
    short: 'اختر أحد مواقع شركة العميل الموزّع لتعبئة عنوان التسليم؛ ويمكنك تعديله بعد ذلك.',
  },
  'dealers.credit_limit': {
    title: 'حدّ الائتمان',
    short: 'لا يجوز أن يتجاوز رصيد الحساب الآجل مضافًا إليه طلب جديد هذا المبلغ. فارغ: بلا حدّ.',
  },
  'dealers.credit_currency': {
    title: 'عملة الحدّ',
    short: 'يُطبَّق الحدّ على الرصيد بهذه العملة؛ وتُحظر العملات الأخرى للحساب الآجل.',
  },
  'dealers.block_when_overdue': {
    title: 'حظر الحساب الآجل عند التأخر في السداد',
    short: 'تُحظر طلبات الحساب الآجل الجديدة ما دام لدى الموزّع دين متأخر.',
  },
  'orders.credit_override': {
    title: 'سبب التجاوز',
    short:
      'يتجاوز الطلب حدّ الائتمان أو أن الموزّع متأخر في السداد. عند ذكر سبب يُقدَّم الطلب رغم ذلك؛ ويُسجَّل في سجل التدقيق.',
  },
  'dealers.payment_term': {
    title: 'مهلة الدفع (بالأيام)',
    short: 'تستحق طلبات الحساب الآجل بعد هذا العدد من الأيام من تاريخ الطلب. ويُطبَّق على الطلبات الجديدة.',
  },
  'retention.rules': {
    title: 'قواعد الإتلاف التلقائي',
    short: 'مدة الاحتفاظ والحذف التلقائي لكل نوع من البيانات. جميعها معطّلة افتراضيًا.',
  },
  'retention.days': { title: 'مدة الاحتفاظ (بالأيام)', short: 'تُحذف السجلات الأقدم من ذلك.' },
  'retention.due': { title: 'المستحق اليوم', short: 'السجلات التي ستُحذف الليلة وفق المدة المحفوظة.' },
  'retention.enabled': {
    title: 'الإتلاف التلقائي',
    short: 'عند التفعيل، تُحذف السجلات المنتهية مدتها نهائيًا كل ليلة.',
  },
  'retention.save': {
    title: 'حفظ',
    short: 'يحفظ المدد وحالة التشغيل/الإيقاف. ويُطلب التأكيد أولًا عند تفعيل قاعدة.',
  },
  'retention.confirm': {
    title: 'التفعيل والحفظ',
    short: 'القواعد التي تفعّلها تحذف السجلات المنتهية مدتها نهائيًا بدءًا من الليلة.',
  },
  'retention.fixed': {
    title: 'مدد الاحتفاظ الثابتة',
    short: 'مدة التنظيف الخاصة بكل ميزة؛ وتُسجَّل أيضًا في سجل الإتلاف.',
  },
  'retention.log': {
    title: 'سجل الإتلاف',
    short: 'عدد السجلات من كل نوع بيانات التي حُذفت أو أُخفيت هويتها، وفي أي يوم.',
  },
  'retention.log_period': { title: 'الفترة', short: 'آخر 30 أو 90 أو 365 أو 1095 يومًا.' },
  'page.google_reports': {
    title: 'تقارير Google',
    short: 'تقرير GA4 حسب القناة/اليوم، وتفاصيل الموقع والمراجعات من Google Business Profile للمتجر.',
  },
  'google_reports.ga4': { title: 'تقرير Analytics (GA4)', short: 'يُقرأ من خاصية GA4 المرتبطة بالمتجر.' },
  'google_reports.period': { title: 'الفترة', short: 'آخر 7 أو 28 أو 90 يومًا (حتى أمس).' },
  'google_reports.business_profile': {
    title: 'Google Business Profile',
    short: 'تفاصيل الموقع وآخر 50 مراجعة (للقراءة فقط).',
  },
  'google_reports.reply': { title: 'الرد على المراجعات', short: 'يفتح الموقع في Google Maps للرد هناك.' },
  'ads.google_conversions': {
    title: 'رفع التحويلات إلى Google Ads',
    short:
      'يرسل الطلبات المدفوعة القادمة من الإعلانات (gclid، ورقم الطلب، والقيمة) إلى Google Ads. معطّل افتراضيًا.',
  },
  'ads.google_conversions_enabled': {
    title: 'رفع التحويلات',
    short: 'يتطلب صلاحية الموافقة والتحقق بخطوتين.',
  },
  'ads.google_conversion_action': {
    title: 'إجراء التحويل',
    short: 'اسم المورد customers/<id>/conversionActions/<id>.',
  },
  'ads.google_conversions_save': { title: 'حفظ', short: 'يحفظ الإعداد؛ ويُسجَّل في سجل التدقيق.' },
  'blog.title': { title: 'عنوان المقالة', short: 'يظهر في واجهة المتجر (160 حرفًا كحد أقصى).' },
  'blog.slug': {
    title: 'الاسم المختصر (العنوان)',
    short: '/blog/<short-name>. في المقالة المنشورة يتغيّر عند الحفظ ويُعاد توجيه العنوان القديم.',
  },
  'blog.excerpt': { title: 'المقتطف', short: 'نص قصير يظهر في القائمة (300 حرف كحد أقصى).' },
  'blog.category': { title: 'الفئة', short: 'فئة المدونة (اختيارية).' },
  'blog.tags': { title: 'الوسوم', short: 'مفصولة بفواصل (10 كحد أقصى).' },
  'blog.author': { title: 'الكاتب', short: 'الاسم واللقب المعروضان في المقالة.' },
  'blog.cover': { title: 'صورة الغلاف', short: 'اختيارية؛ ويلزم نص بديل.' },
  'blog.health_content': {
    title: 'المحتوى الصحي',
    short: 'يتطلب موافقة المراجع المختص؛ ويظهر تنبيه في واجهة المتجر.',
  },
  'blog.references': { title: 'المراجع', short: 'مصادر مع روابط اختيارية (30 كحد أقصى).' },
  'blog.related': { title: 'المنتجات ذات الصلة', short: 'تظهر في نهاية المقالة (8 كحد أقصى).' },
  'blog.preview': {
    title: 'معاينة',
    short: 'يحفظ المسودة ويفتحها في علامة تبويب جديدة (رابط موقّع، صالح لمدة ساعتين).',
  },
  'blog.save': { title: 'حفظ المسودة', short: 'لا تتغير واجهة المتجر حتى تنشر مرة أخرى.' },
  'blog.feature': { title: 'تمييز', short: 'يجعل المقالة المقالة المميزة في صفحة المقالات.' },
  'blog.publish': { title: 'نشر', short: 'ينشر المسودة كإصدار جديد.' },
  'blog.schedule': { title: 'تاريخ النشر', short: 'إذا تُرك فارغًا يُنشر الآن.' },
  'blog.unpublish': { title: 'إلغاء النشر', short: 'يزيل المقالة من واجهة المتجر.' },
  'blog.delete': { title: 'حذف المقالة', short: 'يحذف نهائيًا مقالة لم تُنشر قط.' },
  'blog.category_add': { title: 'إضافة فئة', short: 'يضيف فئة للمدونة.' },
  'blog.category_edit': {
    title: 'تعديل الفئة أو حذفها',
    short: 'عند إعادة التسمية يُعاد توجيه العنوان القديم؛ ويُحتفظ بالمقالات.',
  },
  'menus.post': { title: 'مقالة المدونة', short: 'تظهر في القائمة فقط ما دامت المقالة منشورة.' },
  'page.product_bulk': {
    title: 'سجل الإجراءات الجماعية',
    short: 'التغييرات الجماعية على المنتجات ونتائجها والصفوف المتخطاة؛ ويمكن التراجع عن الإجراءات المطبّقة.',
  },
  'page.product_grid': {
    title: 'التعديل في جدول',
    short: 'اعرض المنتجات والمتغيرات في جدول وعدّل SKU والباركود والحالة والسعر والمخزون كما في جدول بيانات.',
  },
  'page.reviews': {
    title: 'مراجعات المنتجات',
    short: 'وافق على مراجعات العملاء الذين اشتروا المنتج واستلموه، أو ردّ عليها، أو ارفضها.',
  },
  'page.review_detail': { title: 'المراجعة', short: 'الموافقة على المراجعة أو الرد عليها أو رفضها.' },
  'reviews.enabled': {
    title: 'عرض المراجعات في واجهة المتجر',
    short: 'عند التعطيل، تُخفى المراجعات ولا يمكن كتابتها.',
  },
  'reviews.filter': { title: 'الحالة', short: 'المراجعات المعلّقة أو المنشورة أو المرفوضة.' },
  'reviews.reply': { title: 'رد المتجر', short: 'يظهر أسفل المراجعة باسم المتجر (2000 حرف كحد أقصى).' },
  'reviews.save_reply': { title: 'حفظ الرد', short: 'يحفظ الرد؛ ويؤدي ترك الرد فارغًا إلى إزالته.' },
  'reviews.publish': { title: 'الموافقة والنشر', short: 'ينشر المراجعة في صفحة المنتج.' },
  'reviews.reject': { title: 'سبب الرفض', short: 'مرئي في لوحة التحكم فقط.' },
  'page.questions': { title: 'أسئلة المنتجات', short: 'أجب عن أسئلة العملاء وانشرها في صفحات المنتجات.' },
  'page.question_detail': { title: 'السؤال', short: 'الإجابة عن السؤال أو نشره أو رفضه.' },
  'questions.filter': { title: 'الحالة', short: 'الأسئلة التي تنتظر الإجابة أو المنشورة أو المرفوضة.' },
  'questions.answer': { title: 'الإجابة', short: 'تظهر مع السؤال باسم المتجر (2000 حرف كحد أقصى).' },
  'questions.save': { title: 'حفظ الإجابة', short: 'إذا كان السؤال منشورًا، تتغير واجهة المتجر فورًا.' },
  'questions.publish': {
    title: 'نشر',
    short: 'يعرض السؤال والإجابة في صفحة المنتج؛ ويُرسل إلى العميل بريد إلكتروني مرة واحدة.',
  },
  'questions.reject': {
    title: 'رفض / إلغاء النشر',
    short: 'يُخفي السؤال؛ ولا يظهر السبب إلا في لوحة التحكم.',
  },
  'content.locale': {
    title: 'لغة المحتوى',
    short: 'يعرض المحتوى باللغة المحددة؛ وتُنشأ العناصر الجديدة بهذه اللغة.',
  },
  'content.translate': { title: 'إضافة ترجمة', short: 'ينسخ المحتوى كمسودة باللغة المختارة ويفتح محرره.' },
  'content.translate_target': {
    title: 'اللغة الهدف',
    short: 'تُدرج لغات المتجر التي لا تتوفر لها ترجمة فقط.',
  },
  'blog.category_translation_name': {
    title: 'اسم الفئة (اللغة الهدف)',
    short: 'اسم الفئة باللغة الهدف؛ ويُنشأ العنوان منه.',
  },
  'menus.translation_draft': {
    title: 'البدء من لغة أخرى',
    short: 'يحمّل القائمة من لغة أخرى كمسودة غير محفوظة، مع ربط الصفحات والمقالات بترجماتها.',
  },
  'pages.hero_text': {
    title: 'النص أسفل العنوان',
    short: 'نص قصير أسفل العنوان الكبير؛ ويُفحص بحثًا عن ادعاءات صحية.',
  },
  'pages.grid_category': { title: 'الفئة', short: 'تعرض الشبكة المنتجات المرئية من هذه الفئة.' },
  'pages.post_limit': { title: 'عدد المقالات', short: 'عدد أحدث المقالات المنشورة المراد عرضها (1–12).' },
  'pages.add_section': { title: 'إضافة قسم', short: 'يضيف قسمًا من النوع المحدد إلى نهاية الصفحة.' },
  'pages.faq_items': {
    title: 'إضافة / إزالة سؤال',
    short: 'يضيف زوج سؤال وجواب إلى قسم الأسئلة الشائعة أو يزيله منه.',
  },
  'pages.review_decision': {
    title: 'موافقة / رفض',
    short: 'يوافق المراجع البيطري المختص على المحتوى المحفوظ أو يرفضه مع ذكر السبب.',
  },
  'blog.category_name': { title: 'اسم الفئة', short: 'يظهر كعنوان لفئة المدونة في واجهة المتجر.' },
  'blog.category_slug': {
    title: 'الاسم المختصر',
    short: 'عنوان الفئة؛ ويُعاد توجيه العنوان القديم عند تغييره.',
  },
  'blog.category_description': { title: 'وصف الفئة', short: 'نص قصير يظهر أعلى صفحة الفئة.' },
  'editor.link_url': {
    title: 'عنوان الرابط',
    short: 'مسار داخل الموقع، أو عنوان https://، أو mailto:، أو tel:.',
  },
  'editor.image_alt': { title: 'النص البديل', short: 'وصف قصير ومطلوب للصورة.' },
  'editor.image_caption': { title: 'تعليق الصورة', short: 'تعليق اختياري يظهر أسفل الصورة.' },
  'editor.table': {
    title: 'الجدول',
    short: 'عندما يكون المؤشر داخل جدول يمكنك إضافة الصفوف والأعمدة وحذفها. الصف الأول هو صف العناوين.',
  },
  'editor.video': {
    title: 'عنوان الفيديو',
    short: 'عنوان من YouTube أو Vimeo. ولا تُضمَّن مقاطع الفيديو من مواقع أخرى.',
  },
  'editor.import': {
    title: 'استيراد Markdown أو HTML',
    short: 'يحوّل نصًا مكتوبًا في مكان آخر؛ وتُزال النصوص البرمجية والأنماط والنماذج والصور الخارجية.',
  },
  'menus.translation_source': { title: 'اللغة المصدر', short: 'لغة القائمة التي سيبدأ منها.' },
  'categories.name': {
    title: 'اسم الفئة',
    short: 'يظهر في القوائم وصفحة الفئة ومسار التنقل الخاص بالمنتجات.',
  },
  'categories.slug': {
    title: 'الاسم المختصر (العنوان)',
    short: 'عنوان الفئة؛ ويُعاد توجيه العنوان القديم (301) عند تغييره.',
  },
  'categories.description': {
    title: 'وصف الفئة',
    short: 'يظهر أعلى صفحة الفئة؛ ويُستخدم وصفًا احتياطيًا لنتائج البحث.',
  },
  'categories.seo_title': {
    title: 'العنوان في نتائج البحث',
    short: 'حتى 70 حرفًا؛ ويُستخدم اسم الفئة إذا تُرك فارغًا.',
  },
  'categories.seo_description': {
    title: 'الوصف في نتائج البحث',
    short: 'حتى 170 حرفًا؛ ويُستخدم وصف الفئة إذا تُرك فارغًا.',
  },
  'categories.edit': { title: 'تعديل الفئة', short: 'يغيّر الاسم والعنوان والوصف وحقول نتائج البحث.' },
  'redirects.not_found': {
    title: 'العناوين غير الموجودة',
    short: 'يسرد عناوين واجهة المتجر التي تُرجع 404 مع عدد مرات ظهورها.',
  },
  'redirects.not_found_filter': { title: 'عرض', short: 'يعرض العناوين المعلّقة أو المتجاهَلة.' },
  'redirects.not_found_actions': {
    title: 'إعادة توجيه / 410 / تجاهل',
    short:
      'يفتح خيار «إعادة توجيه» نافذة إعادة التوجيه؛ ويضع «410» علامة «أُزيل نهائيًا» على العنوان؛ ويُخفيه «تجاهل».',
  },
  'redirects.filter_source': {
    title: 'المصدر',
    short: 'يصفّي القواعد حسب مصدرها: يدوي، استيراد، تلقائي (تغيّر العنوان) أو مطابقة (أكّدها النظام).',
  },
  'redirects.filter_host': {
    title: 'النطاق',
    short:
      'قواعد «كل النطاقات» تُطبَّق على نطاق المتجر وكل النطاقات القديمة؛ اختر نطاقًا قديمًا لعرض قواعده فقط.',
  },
  'redirects.host': {
    title: 'نطاق المصدر',
    short:
      'اتركه فارغًا لتُطبَّق القاعدة على كل النطاقات (موصى به)؛ أو اكتب نطاقًا قديمًا (بدون www.) لقاعدة خاصة به.',
  },
  'redirects.shadowed': {
    title: 'قواعد تحجب صفحات المتجر',
    short:
      'العنوان القديم لهذه القواعد صفحة حقيقية في المتجر، لذلك يُعاد توجيه الزائر بدلًا من عرضها. احذف القاعدة لتظهر الصفحة.',
  },
  'page.broken_links': {
    title: 'الروابط المعطّلة',
    short: 'عناوين المتجر التي تُرجع 404 والعناوين القديمة التي أُرسلت إلى صفحة آمنة لعدم وجود مقابل لها.',
  },
  'broken_links.collect': {
    title: 'جمع العناوين القديمة من الأرشيف',
    short: 'يجلب عناوين صفحات النطاقات القديمة من أرشيف الإنترنت (Wayback Machine) ويطابقها.',
  },
  'broken_links.host': { title: 'النطاق', short: '«نطاق المتجر» هو نطاق المتجر نفسه؛ والبقية نطاقات قديمة.' },
  'broken_links.found_via': {
    title: 'المصدر',
    short: 'زيارة: فُتح العنوان. الأرشيف: جُمع من Wayback Machine. Search Console: شوهد في Google.',
  },
  'sc_setup.connect': {
    title: 'الاتصال بـ Google والإعداد',
    short:
      'يُعدّ النظام Search Console: يُتحقق من خصائص نطاق المتجر والنطاقات القديمة وتُضاف، وتُرسل خريطة الموقع وتُطابق الصفحات القديمة.',
  },
  'sc_setup.run': {
    title: 'الاتصال بـ Google / تشغيل الإعداد مجددًا',
    short: 'يشغّل الإعداد فورًا إذا كان الاتصال والأذونات مكتملة؛ وإلا يفتح شاشة موافقة Google.',
  },
  'sc_setup.enable_api': {
    title: 'فعّل الواجهة البرمجية في Google Cloud',
    short:
      'يستخدم الإعداد واجهتين مجانيتين من Google: خطوات التحقق تستخدم Site Verification API، وإضافة الخصائص وخريطة الموقع والصفحات القديمة تستخدم Search Console API. افتح الرابط في مشروع Google Cloud الخاص بعميل OAuth الذي اتصلت به، واضغط تفعيل، ثم أعد تشغيل الإعداد بعد دقيقة أو دقيقتين.',
  },
  'sc_setup.inspections': {
    title: 'حالة الفهرسة في Google',
    short:
      'كل صباح تُفحص صفحات المنتجات المنشورة والعناوين القديمة الأكثر استخدامًا بأداة فحص العناوين في Google.',
  },
  'indexnow.section': {
    title: 'IndexNow (Bing وYandex)',
    short: 'يبلّغ Bing وYandex بالعناوين المتغيرة كل عشر دقائق؛ وتُرسل كل العناوين مرة واحدة في أول تشغيل.',
  },
  'indexnow.submit': {
    title: 'إرسال كل العناوين الآن',
    short: 'يرسل كل عناوين المتجر القابلة للفهرسة إلى IndexNow.',
  },
  'system.staging_banner': {
    title: 'بيئة الاختبار (Staging)',
    short:
      'تعمل لوحة التحكم هذه على خادم الاختبار (Staging)؛ ولا تُرسل رسائل البريد الإلكتروني إلا إلى العناوين المدرجة في قائمة السماح.',
  },
  'system.mail_allowlist': {
    title: 'قائمة السماح للبريد الإلكتروني',
    short:
      'العناوين أو النطاقات (@domain) التي يُسمح لها باستلام البريد الإلكتروني في بيئة الاختبار. والقائمة الفارغة تحظر جميع الرسائل.',
  },
  'system.mail_allowlist_save': {
    title: 'حفظ قائمة السماح',
    short: 'يحفظ القائمة؛ وتسري اعتبارًا من الرسالة التالية. ويُسجَّل في سجل التدقيق.',
  },
  'products.media_retry': {
    title: 'إعادة محاولة الصورة',
    short:
      'يعيد صورة الاستيراد الفاشلة إلى قائمة الانتظار؛ وتعيد المهمة الخلفية المحاولة خلال 30 ثانية تقريبًا.',
  },
  'imports.sku_generate': {
    title: 'إعادة المعاينة مع رموز SKU المقترحة',
    short: 'يقترح رموز SKU للمتغيرات التي لا تملكها (الباركود، أو رمز المنتج + الخيار). راجعها قبل التطبيق.',
  },
  'imports.media_retry_all': {
    title: 'إعادة محاولة التنزيلات الفاشلة',
    short: 'يعيد جميع صور الاستيراد الفاشلة إلى قائمة الانتظار.',
  },
  'imports.categories_file': {
    title: 'اختيار ملف الفئات ومعاينته',
    short:
      'الأعمدة: الاسم، والفئة الأم، والوصف، والترتيب، والاسم المختصر (slug)، والحالة، وعنوان/وصف SEO. المعاينة أولًا.',
  },
  'imports.categories_apply': {
    title: 'تطبيق الفئات',
    short: 'يكتب جميع الإضافات والتحديثات في معاملة واحدة، بدءًا بالفئات الأم.',
  },
  'imports.products_apply': {
    title: 'استيراد المنتجات',
    short: 'يضيف المنتجات الجديدة كمسودات ويحدّث الموجودة؛ وتُعالَج أكثر من 50 منتجًا في الخلفية.',
  },
  'imports.dealers_apply': {
    title: 'استيراد الموزّعين',
    short: 'يضيف الموزّعين المعروضين في المعاينة أو يحدّثهم في معاملة واحدة ويربط مستخدميهم.',
  },
  'imports.categories_export': {
    title: 'القالب / تصدير الفئات',
    short: 'ينزّل القالب أو شجرة الفئات الحالية بالأعمدة نفسها.',
  },
  'imports.create_missing_categories': {
    title: 'إنشاء الفئات المفقودة',
    short:
      'ينشئ الفئات غير الموجودة الواردة في عمود «الفئة»، بما في ذلك الفئات الأم في المسارات من نوع «A > B».',
  },
  'imports.category_mode': {
    title: 'فئات المنتجات الموجودة',
    short: 'يحتفظ خيار «إضافة» بالفئات الحالية؛ ويستخدم «استبدال» الفئات الواردة في الملف فقط.',
  },
  'stock.transfer_receipt': {
    title: 'إدخال الاستلام',
    short: 'يفتح أول إدخال للمخزون (استلام مع الدفعة وتاريخ انتهاء الصلاحية) بدلًا من التحويل.',
  },
  'stores.archive': {
    title: 'أرشفة',
    short: 'يغلق واجهة متجر غير مستخدم ويدرجه في آخر القائمة؛ ولا يُحذف أي شيء.',
  },
  'stores.delete': {
    title: 'حذف المتجر',
    short: 'فقط متجر في وضع المعاينة أو مؤرشف وليس له طلبات؛ وتُحذف نطاقاته وأسواقه وقوائم أسعاره ومحتواه.',
  },
  'stores.delete_code': { title: 'رمز المتجر', short: 'اكتب رمز المتجر تمامًا كما هو للتأكيد.' },
  'products.price_list_missing': {
    title: 'الانتقال إلى التسعير',
    short: 'تأتي أسعار واجهة المتجر من قائمة الأسعار الأساسية النشطة للمتجر (بدون مجموعة).',
  },
  'payments.card_status': {
    title: 'الدفع بالبطاقة في واجهة المتجر',
    short:
      'معطّل، أو تجريبي (Sandbox، دون أموال حقيقية)، أو مباشر. تُظهر شارة «التكاملات» نتيجة اختبار اتصال المفاتيح فقط.',
  },
  'migration.export': {
    title: 'تنزيل حزمة الترحيل',
    short: 'ينزّل المتجر المحدد كملف ZIP؛ دون بيانات شخصية أو مفاتيح.',
  },
  'migration.target_store': {
    title: 'المتجر الهدف',
    short: 'المتجر الذي ستُطبَّق عليه الحزمة؛ وإذا تُرك فارغًا يُطابَق مع رمز المتجر في الحزمة أو يُنشأ.',
  },
  'migration.include_stock': {
    title: 'المخزون الافتتاحي',
    short: 'يكتب الأرصدة الحالية لكل مستودع/دفعة كمخزون افتتاحي.',
  },
  'migration.overwrite': {
    title: 'الاستبدال',
    short: 'معطّل: تُضاف السجلات المفقودة فقط. مفعّل: تُحدَّث السجلات المختلفة.',
  },
  'migration.legal_reviewed': {
    title: 'مراجعة المحامي',
    short: 'ينشر النصوص القانونية بعلامة «تمت المراجعة» باسمك.',
  },
  'migration.carry_approvals': {
    title: 'نقل الموافقات البيطرية',
    short: 'يسجّل موافقات بيئة الاختبار باسمك؛ وإلا تبقى العناصر بانتظار الموافقة.',
  },
  'migration.file': {
    title: 'اختيار الحزمة ومعاينتها',
    short: 'يرفع ملف ZIP ويعرض معاينته؛ ولا يُكتب أي شيء.',
  },
  'migration.refresh': { title: 'تحديث المعاينة', short: 'يعيد حساب المعاينة بالخيارات المعدّلة.' },
  'migration.apply': { title: 'استيراد', short: 'يطبّق الحزمة المعاينة في معاملة واحدة.' },
  'privacy.create': {
    title: 'تسجيل الطلب',
    short: 'يسجّل طلبًا ورد عبر البريد الإلكتروني أو KEP أو البريد العادي أو شخصيًا.',
  },
  'privacy.requester_email': {
    title: 'البريد الإلكتروني لمقدّم الطلب',
    short: 'تُرسل النتيجة إلى هذا العنوان؛ وتُطابَق الحسابات وطلبات الزوار بهذا العنوان.',
  },
  'privacy.received_at': { title: 'تاريخ الطلب', short: 'تُحتسب مهلة الثلاثين يومًا من هذا التاريخ.' },
  'privacy.export': { title: 'تنزيل نسخة من البيانات', short: 'ينزّل سجلات الشخص بصيغة JSON.' },
  'privacy.note': {
    title: 'الرد على مقدّم الطلب',
    short: 'يُرسل إلى مقدّم الطلب بالبريد الإلكتروني عند إنجاز الطلب أو رفضه.',
  },
  'privacy.start_review': { title: 'بدء المراجعة', short: 'يضع علامة على الطلب بأنه قيد المعالجة.' },
  'privacy.complete': { title: 'إنجاز', short: 'يُغلق الطلب مع رد.' },
  'privacy.reject': { title: 'رفض', short: 'يُغلق الطلب مع ذكر السبب.' },
  'privacy.anonymize': { title: 'إخفاء الهوية', short: 'يُخفي هوية البيانات الشخصية نهائيًا في طلب المحو.' },
  'privacy.confirm_email': {
    title: 'التأكيد',
    short: 'اكتب البريد الإلكتروني لمقدّم الطلب كما هو تمامًا لتفعيل الزر.',
  },
  'system.error_tracking': {
    title: 'التتبع الخارجي للأخطاء',
    short: 'تُرسل أخطاء الخادم غير المتوقعة إلى خدمة متوافقة مع Sentry، دون بيانات شخصية.',
  },
  'system.alert_recipients': {
    title: 'مستلمو التنبيهات',
    short: 'عناوين التنبيهات الحرجة؛ وإذا تُركت فارغة تُرسل إلى المالكين.',
  },
  'system.mail_dns': { title: 'فحص نطاق البريد الإلكتروني', short: 'تُقرأ سجلات SPF وDKIM وDMARC من DNS.' },
  'system.dkim_selector': { title: 'محدِّد DKIM', short: 'الجزء الأول من اسم سجل DKIM.' },
  'page.exports': {
    title: 'عمليات التصدير',
    short: 'نزّل الطلبات وبنود الطلبات والعملاء والمخزون والفواتير والمدفوعات بصيغة XLSX أو CSV.',
  },
  'exports.period': {
    title: 'الفترة',
    short: 'الأيام بتوقيت تركيا، ويشمل ذلك يوم النهاية. المخزون دائمًا بحسب الوضع الحالي.',
  },
  'exports.from': {
    title: 'تاريخ البدء',
    short: 'السجلات اعتبارًا من الساعة 00:00 من هذا اليوم (بتوقيت تركيا).',
  },
  'exports.to': { title: 'تاريخ الانتهاء', short: 'السجلات حتى نهاية هذا اليوم.' },
  'exports.store': { title: 'المتجر', short: 'يقصر الطلبات والفواتير والمدفوعات على متجر واحد.' },
  'exports.format': {
    title: 'صيغة الملف',
    short: 'تحتفظ صيغة XLSX بالمبالغ كأرقام، أما CSV فمفصولة بفواصل منقوطة.',
  },
  'exports.personal_data': {
    title: 'البيانات الشخصية',
    short: 'مُخفاة افتراضيًا. يتطلب عرضها دون إخفاء صلاحية البيانات الشخصية والتحقق بخطوتين.',
  },
  'exports.orders': { title: 'تنزيل الطلبات', short: 'صف واحد لكل طلب مع الإجماليات وضريبة القيمة المضافة.' },
  'exports.order_lines': {
    title: 'تنزيل بنود الطلبات',
    short: 'صف واحد لكل صنف مع نسبة ضريبة القيمة المضافة والدفعات.',
  },
  'exports.customers': { title: 'تنزيل العملاء', short: 'العملاء المسجّلون خلال الفترة، مع موافقاتهم.' },
  'exports.stock': {
    title: 'تنزيل المخزون',
    short: 'المخزون الحالي حسب المستودع والدفعة، مع تواريخ انتهاء الصلاحية.',
  },
  'exports.invoices': {
    title: 'تنزيل الفواتير',
    short: 'الفواتير المؤرخة ضمن الفترة مع الصافي وضريبة القيمة المضافة والإجمالي.',
  },
  'exports.payments': {
    title: 'تنزيل المدفوعات',
    short: 'المدفوعات والمبالغ المستردة (بالسالب) مرتبة حسب التاريخ.',
  },
  'stock.critical': {
    title: 'مخزون منخفض',
    short: 'المنتجات التي تكون كميتها القابلة للبيع مساوية لحدّها أو أقل منه.',
  },
  'stock.default_threshold': {
    title: 'الحد الافتراضي',
    short: 'يُطبّق على المنتجات التي ليس لها حد خاص بها والتي توفّر لها مخزون مرة واحدة على الأقل.',
  },
  'stock.daily_digest': {
    title: 'ملخص يومي بالبريد الإلكتروني',
    short: 'رسالة بريد إلكتروني واحدة كل صباح في الساعة 08:00 (بتوقيت تركيا) عند انخفاض المخزون.',
  },
  'stock.thresholds': {
    title: 'حدود المخزون المنخفض',
    short: 'لجميع المستودعات (الإجمالي) أو لكل مستودع؛ والحقل الفارغ يعني عدم وجود حد.',
  },
  'stock.thresholds_save': { title: 'حفظ الحدود', short: 'يحفظ حدود هذا المنتج، وتُحدَّث القائمة فورًا.' },
  'page.seo': { title: 'مركز SEO', short: 'مشكلات SEO في المنتجات والفئات والصفحات والمقالات المنشورة.' },
  'seo.indexing': {
    title: 'الفهرسة',
    short: 'متاح لمحركات البحث عندما يكون المتجر مباشرًا والفهرسة مفعّلة.',
  },
  'seo.issues': {
    title: 'مشكلات SEO',
    short:
      'يُفحص المحتوى المنشور فقط. الصور الرئيسية التي يقل ضلعها القصير عن 500 px تُعدّ صغيرة، وما يقل عن 1500 px يُعدّ منخفض الدقة.',
  },
  'seo.issue_filter': { title: 'نوع المشكلة', short: 'يُصفّي القائمة حسب نوع مشكلة واحد.' },
  'seo.history': {
    title: 'سجل تغييرات SEO',
    short: 'التغييرات على عناوين SEO وأوصافها والروابط المختصرة (slug).',
  },
  'seo.crawl': { title: 'زاحف الموقع', short: 'يزحف إلى واجهة متجرك ويكتشف مشكلات SEO التقنية.' },
  'seo.crawl_start': {
    title: 'بدء الزحف',
    short: 'يضع عملية زحف في قائمة الانتظار؛ تُجلب صفحة واحدة في الثانية، لذا تستغرق 150 صفحة بضع دقائق.',
  },
  'seo.crawl_filter': { title: 'نوع المشكلة (الزحف)', short: 'يُصفّي مشكلات آخر عملية زحف حسب النوع.' },
  'page.google': {
    title: 'اتصالات Google',
    short: 'يربط حساب Google الخاص بك ويختار موارد Search Console وGA4 وMerchant Center لكل متجر.',
  },
  'google.client': { title: 'عميل OAuth', short: 'يُنشأ في Google Cloud Console ويُدخل ضمن التكاملات.' },
  'google.redirect_uri': {
    title: 'عنوان URI المعتمد لإعادة التوجيه',
    short: 'أضف هذا العنوان كما هو تمامًا إلى عميل OAuth في Google Cloud.',
  },
  'google.connect': { title: 'الاتصال عبر Google', short: 'يفتح شاشة الموافقة من Google للخدمات المحددة.' },
  'google.services': {
    title: 'الخدمات والأذونات',
    short: 'Search Console، وAnalytics (قراءة فقط)، وMerchant Center.',
  },
  'google.test': {
    title: 'اختبار الاتصال',
    short: 'يُحدّث الرمز المميز (token) ويتحقق من الموارد المرتبطة.',
  },
  'google.disconnect': {
    title: 'إزالة الاتصال',
    short: 'يُلغي الوصول لدى Google ويحذف الرمز المميز والروابط.',
  },
  'google.resources': { title: 'موارد المتجر', short: 'تُختار مما يمكن للحساب المتصل الوصول إليه.' },
  'google.logs': {
    title: 'السجل',
    short: 'عمليات الاتصال والرمز المميز وعرض القوائم والاختبار وإلغاء الوصول.',
  },
  'page.search_console': {
    title: 'أداء البحث',
    short:
      'النقرات ومرات الظهور ونسبة النقر إلى الظهور (CTR) ومتوسط الترتيب في بحث Google حسب الاستعلام والصفحة والبلد والجهاز.',
  },
  'sc.sync': { title: 'مزامنة الآن', short: 'يجلب آخر 28 يومًا في المرة الأولى، ثم آخر 5 أيام.' },
  'sc.metrics': { title: 'المقاييس', short: 'النقرات ومرات الظهور ونسبة النقر إلى الظهور ومتوسط الترتيب.' },
  'sc.dimension': { title: 'جدول التفاصيل', short: 'أعلى 100 صف حسب النقرات؛ للتصفية استخدم "بحث".' },
  'sc.movers': {
    title: 'الصفحات الصاعدة والهابطة',
    short: 'النقرات مقارنةً بالفترة السابقة المماثلة في الطول.',
  },
  'sc.sitemaps': { title: 'خرائط الموقع', short: 'خرائط الموقع في Search Console وحالتها.' },
  'sc.sitemap_submit': {
    title: 'إرسال خريطة الموقع',
    short: 'يُرسل فهرس خرائط موقع المتجر إلى Search Console.',
  },
  'sc.inspect': {
    title: 'فحص عنوان URL',
    short: 'حالة فهرسة الصفحة في Google؛ 2,000 فحص لكل خاصية (property) يوميًا.',
  },
  'sc.digest': { title: 'ملخص أسبوعي بالبريد الإلكتروني', short: 'يُرسل إلى مستلمي التنبيهات كل يوم اثنين.' },
  'page.merchant': {
    title: 'Google Shopping',
    short: 'يُرسل المنتجات إلى Google Merchant Center: فحص ما قبل الخلاصة، وملف الخلاصة، وMerchant API.',
  },
  'merchant.preview': {
    title: 'فحص ما قبل الخلاصة',
    short:
      'لا تُرسل المنتجات التي لديها مشكلات في المحتوى الصحي أو التي ليس لها صورة أو سعر. تُتخطى الصور الأصغر من الحد الأدنى الذي تشترطه Google، ويوصى بصور لا تقل عن 1500×1500 px.',
  },
  'merchant.feed': { title: 'ملف الخلاصة', short: 'عنوان سري لعملية الجلب المجدولة في Merchant Center.' },
  'merchant.feed_rotate': {
    title: 'تجديد العنوان',
    short: 'يُنشئ عنوانًا جديدًا ويتوقف العنوان القديم عن العمل.',
  },
  'merchant.api': { title: 'Merchant API', short: 'يُرسل المنتجات كل صباح عبر اتصال Google.' },
  'merchant.sync': {
    title: 'إرسال الآن',
    short: 'يُرسل المنتجات المعدّلة، ويحذف المنتجات المُزالة، ويحدّث الحالات.',
  },
  'merchant.performance': {
    title: 'أداء المنتجات',
    short: 'تقرير Merchant Center: مرات الظهور والنقرات للقوائم المجانية وإعلانات Shopping لكل منتج.',
  },
  'merchant.performance_period': { title: 'الفترة', short: 'آخر 7 أو 28 أو 90 يومًا (حتى الأمس).' },
  'merchant.issues': {
    title: 'المشكلات لدى Google',
    short: 'المنتجات المرفوضة أو التي تلقت تحذيرات مع أسباب Google.',
  },
  'products.merchant': {
    title: 'Google Shopping',
    short: 'ما إذا كان المنتج يُرسل إلى Merchant Center، وحقول Google.',
  },
  'products.google_category': { title: 'فئة منتج Google', short: 'رقم تصنيف Google أو المسار الكامل.' },
  'products.identifier_exists': {
    title: 'باركود المصنّع',
    short: 'اختر "بدون باركود" فقط إذا لم يكن للمنتج باركود.',
  },
  'products.sku_is_mpn': {
    title: 'SKU = MPN',
    short: 'فعّله لمنتجاتك الخاصة فقط: يُرسل SKU إلى Google بوصفه MPN.',
  },
  'products.custom_labels': { title: 'التسميات المخصصة', short: 'تسميات حرة لتجميع المنتجات في Google Ads.' },
  'page.attribution': {
    title: 'الحملات والمصادر',
    short: 'يُنشئ روابط حملات UTM ويعرض تقارير الطلبات حسب المصدر.',
  },
  'attribution.builder': {
    title: 'رابط الحملة',
    short: 'المصدر والوسيط والحملة؛ يُنشأ الرابط على الشاشة فقط.',
  },
  'attribution.url': { title: 'عنوان الصفحة', short: 'صفحة واجهة المتجر التي يصل إليها الزائر.' },
  'attribution.source': { title: 'المصدر', short: 'من أين تأتي الزيارات: google، instagram، newsletter…' },
  'attribution.medium': { title: 'الوسيط', short: 'نوع الزيارات: cpc، social، email، sms، qr…' },
  'attribution.campaign': { title: 'الحملة', short: 'اسم الحملة؛ تُجمَّع الصفوف حسبه.' },
  'attribution.term': { title: 'الكلمة المفتاحية', short: 'اختياري: الكلمة المفتاحية في البحث المدفوع.' },
  'attribution.content': { title: 'المحتوى', short: 'اختياري: يميّز بين الروابط داخل الحملة نفسها.' },
  'attribution.report': {
    title: 'الطلبات حسب المصدر',
    short: 'الطلبات والإيرادات المدفوعة والمبالغ المستردة والصافي حسب المصدر.',
  },
  'attribution.model': {
    title: 'نقطة الاتصال',
    short: 'آخر نقطة اتصال: آخر مصدر غير مباشر قبل الطلب. أول نقطة اتصال: الزيارة الأولى.',
  },
  'page.web_vitals': {
    title: 'سرعة الصفحة',
    short: 'يقيس سرعة واجهة المتجر باستخدام PageSpeed Insights (مؤشرات Core Web Vitals ونتيجة Lighthouse).',
  },
  'web_vitals.run': {
    title: 'القياس الآن',
    short: 'ثمانية قياسات (أربع صفحات × الجوال/سطح المكتب)؛ يستغرق بضع دقائق.',
  },
  'web_vitals.results': {
    title: 'النتائج',
    short: 'LCP: زمن عرض أكبر محتوى. INP: الاستجابة للنقرات. CLS: إزاحة التخطيط.',
  },
  'page.attributes': {
    title: 'خصائص المنتج',
    short: 'تعريفات الخصائص التقنية (رقم، خيار، نعم/لا، نص) والوسوم المستخدمة.',
  },
  'attributes.list': {
    title: 'قائمة الخصائص',
    short: 'النوع والخيارات ومكان العرض والمنتجات التي لها قيمة.',
  },
  'attributes.code': {
    title: 'الرمز المختصر',
    short: 'يُستخدم كعمود في الاستيراد وكعنوان للتصفية في واجهة المتجر.',
  },
  'attributes.type': { title: 'نوع الخاصية', short: 'لا يمكن تغييره بعد أن تصبح للمنتجات قيم.' },
  'attributes.options': {
    title: 'الخيارات',
    short: 'خيار واحد في كل سطر؛ لا يمكن إزالة الخيارات التي تستخدمها المنتجات.',
  },
  'attributes.visible': {
    title: 'العرض في صفحة المنتج',
    short: 'يظهر في جدول "المواصفات" وفي بيانات المنتج المرسلة إلى محركات البحث.',
  },
  'attributes.filterable': {
    title: 'العرض في عوامل تصفية واجهة المتجر',
    short: 'يتيح للعملاء التصفية حسبه.',
  },
  'attributes.position': { title: 'الترتيب', short: 'الأرقام الأصغر تظهر أولًا.' },
  'products.tags': {
    title: 'الوسوم',
    short:
      'مفصولة بفواصل وتُحفظ بأحرف صغيرة؛ لا تظهر في واجهة المتجر. تستخدمها قواعد المجموعات وعوامل التصفية.',
  },
  'products.copy': {
    title: 'نسخ',
    short: 'يُنشئ نسخة مسودة بأرقام SKU جديدة؛ لا يُنسخ النشر في المتجر ولا المخزون.',
  },
  'products.save_template': {
    title: 'الحفظ كقالب',
    short: 'يحفظ الحقول القابلة لإعادة الاستخدام من هذا المنتج كقالب.',
  },
  'products.template': { title: 'القالب', short: 'يملأ نموذج المنتج الجديد بقيم القالب.' },
  'products.sku_suggest': {
    title: 'اقتراح أرقام SKU',
    short: 'يملأ أرقام SKU الفارغة باستخدام نمط SKU؛ وتكون دائمًا فريدة.',
  },
  'products.sku_pattern': { title: 'نمط SKU', short: 'الرموز: {marka} {kategori} {urun} {secenek} {sira}.' },
  'products.schedule': { title: 'جدولة النشر', short: 'ينشر المنتج في هذا المتجر في وقت لاحق.' },
  'products.bulk': {
    title: 'إجراء جماعي',
    short:
      'يغيّر الحالة أو الفئات أو الوسوم أو المجموعة أو المخزون أو SEO أو Google Shopping أو النشر في المتجر لعدد كبير من المنتجات دفعة واحدة، بعد معاينة.',
  },
  'products.bulk_select_all': {
    title: 'تحديد كل النتائج المطابقة',
    short: 'يحدد كل المنتجات المطابقة للبحث وعوامل التصفية (حتى 5,000)، وليس هذه الصفحة فقط.',
  },
  'products.bulk_kind': {
    title: 'الإجراء',
    short: 'التغيير المطلوب إجراؤه. يتطلب التطبيق صلاحية التطبيق الجماعي والتحقق بخطوتين.',
  },
  'products.bulk_store': {
    title: 'المتجر',
    short:
      'المتجر الذي يُنشر فيه أو يُلغى النشر منه. لا تُنشر إلا المنتجات النشطة والمعتمدة بيطريًا (حيثما يلزم) والتي لها سعر أساسي، وتُتخطى المنتجات الأخرى مع ذكر السبب.',
  },
  'products.bulk_stock': {
    title: 'كمية المخزون',
    short: 'اضبط كل متغير نشط على عدد محدد، أو أضف وحدات أو أزلها. تُسجَّل كحركات مخزون.',
  },
  'products.bulk_seo': {
    title: 'نمط SEO',
    short: 'الرموز: {urun} المنتج، {marka} العلامة التجارية، {kategori} الفئة الأولى.',
  },
  'products.bulk_preview': {
    title: 'معاينة',
    short: 'يعرض القيم قبل التغيير وبعده والمنتجات المتخطاة مع الأسباب. لا يتغير شيء.',
  },
  'products.bulk_apply': {
    title: 'تطبيق',
    short: 'يُجري التغييرات المعروضة في المعاينة؛ وتبقى الصفوف التي تغيّرت منذ المعاينة دون تعديل.',
  },
  'products.bulk_history': {
    title: 'سجل الإجراءات الجماعية',
    short: 'آخر 50 إجراءً جماعيًا مع نتائجها؛ ويمكن التراجع عن الإجراءات المطبّقة.',
  },
  'products.bulk_revert': {
    title: 'تراجع',
    short: 'يستعيد القيم السابقة؛ وتُتخطى الصفوف التي عُدّلت يدويًا منذ ذلك الحين.',
  },
  'products.grid': {
    title: 'التحرير في جدول',
    short: 'يفتح المنتجات كصفوف متغيرات لتحرير SKU والباركود والحالة والسعر والمخزون كما في جدول بيانات.',
  },
  'products.grid_price_list': {
    title: 'قائمة الأسعار',
    short: 'يعرض عمود السعر سعر الوحدة الواحدة في هذه القائمة ويتيح تعديله.',
  },
  'products.grid_warehouse': {
    title: 'المستودع',
    short: 'يعرض عمود المخزون الوحدات المتوفرة في هذا المستودع ويتيح تعديلها.',
  },
  'products.grid_save': {
    title: 'حفظ التغييرات',
    short: 'يعرض أولًا معاينة بالتعارضات والخلايا غير الصالحة؛ ويمكن التراجع عن التغييرات المحفوظة.',
  },
  'products.grid_discard': { title: 'تجاهل', short: 'يزيل جميع تغييرات الخلايا غير المحفوظة.' },
  'stock.lot_pick': {
    title: 'الدفعة',
    short:
      'اختر الدفعة التي ينطبق عليها الجرد أو التعديل أو التلف؛ و"مخزون بدون دفعة" للرصيد غير المرتبط بدفعة.',
  },
  'imports.column_map': {
    title: 'ربط الأعمدة',
    short: 'الحقل الذي يُوجَّه إليه كل عمود؛ يُحفظ عند التطبيق ويُعاد استخدامه مع عناوين الأعمدة نفسها.',
  },
  'imports.retry': { title: 'إعادة محاولة المنتجات الفاشلة', short: 'يُعيد تطبيق المنتجات التي فشلت فقط.' },
  'pricing.cost_based': {
    title: 'السعر القائم على التكلفة',
    short: 'يحسب الأسعار من التكلفة بإضافة نسبة ربح أو هامش ربح إجمالي مستهدف.',
  },
  'pricing.min_margin': {
    title: 'الحد الأدنى للهامش',
    short: 'يضع علامة على المنتجات (أو يتخطاها) التي سينخفض هامشها عن هذا الحد.',
  },
  'pricing.fx_rate': {
    title: 'سعر الصرف',
    short: 'يحوّل سعر القائمة المصدر باستخدام سعر الصرف هذا المُدخل يدويًا.',
  },
  'pricing.campaign_dates': { title: 'فترة السريان', short: 'لا تقدّم القائمة الأسعار إلا خلال هذه الفترة.' },
  'products.price_tiers': { title: 'أسعار الكميات', short: 'سعر الوحدة ابتداءً من حد أدنى للكمية.' },
  'products.extras': {
    title: 'الفيديوهات والمستندات والمنتجات المرافقة',
    short: 'الفيديوهات ومستندات PDF ومنتجات "يتناسب جيدًا مع" المعروضة في صفحة المنتج.',
  },
  'products.videos': {
    title: 'الفيديوهات',
    short: 'الصق رابط YouTube أو Vimeo وعنوانًا (حتى 5). لا يُحمَّل أي شيء حتى يشغّل الزائر الفيديو.',
  },
  'products.video_add': { title: 'إضافة فيديو', short: 'يضيف صف فيديو. أدخل الرابط والعنوان ثم احفظ.' },
  'products.documents': {
    title: 'المستندات',
    short: 'مستندات PDF مثل شهادة التحليل (حتى 10)، مرتبطة علنًا في صفحة المنتج.',
  },
  'products.document_upload': {
    title: 'رفع مستند PDF',
    short: 'حتى 10 MB. تُرفض ملفات PDF التي تحتوي على JavaScript أو ملفات مضمّنة أو إجراءات تشغيل.',
  },
  'products.complementary': {
    title: 'المنتجات المرافقة',
    short: 'منتجات يوصى بها مع هذا المنتج (حتى 12)، تُعرض تحت "يتناسب جيدًا مع".',
  },
  'products.attributes': {
    title: 'خصائص المنتج',
    short: 'قيم الخصائص المعرّفة لهذا المنتج؛ لا تُحفظ القيم الفارغة.',
  },
  'page.collections': { title: 'المجموعات', short: 'مجموعات منتجات مختارة يدويًا أو قائمة على قواعد.' },
  'page.collection_editor': { title: 'المجموعة', short: 'اسم المجموعة وعنوانها وحالتها ومنتجاتها.' },
  'collections.slug': {
    title: 'الرابط المختصر (slug)',
    short: 'عنوان واجهة المتجر /koleksiyon/<slug>؛ ويُعاد توجيه العنوان القديم.',
  },
  'collections.status': { title: 'الحالة', short: 'لا تظهر المجموعات المخفية في واجهة المتجر.' },
  'collections.kind': { title: 'يدوية أو بقاعدة', short: 'تتحدّث المجموعات القائمة على القواعد تلقائيًا.' },
  'collections.manual': { title: 'إضافة منتج', short: 'ابحث بالاسم أو SKU أو الباركود؛ حتى 500 منتج.' },
  'collections.match': { title: 'الجمع بين الشروط', short: 'جميع الشروط، أو أيّ شرط منها.' },
  'collections.preview': { title: 'عرض المطابقات', short: 'يعرض المنتجات المطابقة دون حفظ.' },
  'page.site_search': {
    title: 'البحث في الموقع',
    short: 'عمليات البحث الأكثر تكرارًا وعمليات البحث بلا نتائج؛ مجموعات المرادفات.',
  },
  'site_search.report': {
    title: 'تقرير البحث',
    short: 'يُحتسب أول عرض لصفحة البحث، ولا تُحتسب الاقتراحات. بلا بيانات شخصية؛ مدة الاحتفاظ 90 يومًا.',
  },
  'site_search.zero': {
    title: 'عمليات البحث بلا نتائج',
    short: 'أضف مرادفًا أو أضف الكلمة إلى أسماء المنتجات.',
  },
  'site_search.synonyms': {
    title: 'المرادفات',
    short: 'عند البحث عن أي كلمة في المجموعة يُبحث أيضًا عن الكلمات الأخرى.',
  },
  'site_search.terms': { title: 'الكلمات', short: 'من كلمتين إلى 20 كلمة مفردة، مفصولة بفواصل.' },
  'page.keywords': {
    title: 'الكلمات المفتاحية',
    short: 'مجمّع عمليات البحث المستهدفة مع مقاييس Search Console والتنبيهات.',
  },
  'keywords.pool': {
    title: 'مجمّع الكلمات المفتاحية',
    short: 'تُحفظ بأحرف صغيرة؛ إدخال واحد لكل كلمة مفتاحية. آخر 28 يومًا من Search Console.',
  },
  'keywords.alerts': {
    title: 'التنبيهات',
    short: 'تنافس الصفحات على الكلمة نفسها (Cannibalization) وفجوات المحتوى.',
  },
  'keywords.intent': { title: 'نية البحث', short: 'معلوماتية أو تجارية أو معاملاتية أو تنقلية.' },
  'keywords.cluster': { title: 'العنقود', short: 'يجمع الكلمات المفتاحية ذات الموضوع الواحد.' },
  'keywords.target': {
    title: 'الصفحة المستهدفة',
    short: 'مسار واجهة المتجر الذي ينبغي أن يتصدر نتائج هذه الكلمة المفتاحية.',
  },
  'keywords.candidates': {
    title: 'اقتراحات Search Console',
    short: 'أكثر 100 عملية بحث لم تُضف إلى المجمّع بعد.',
  },
  'keywords.rank_tracking': { title: 'تتبع الترتيب', short: 'يتطلب مزوّد بيانات مرخّصًا (مدفوعًا).' },
  'page.tracking': {
    title: 'القياس',
    short:
      'يضيف علامات تتبع GTM وGA4 وGoogle Ads وMeta وTikTok إلى واجهة المتجر ويدير الموافقة على ملفات تعريف الارتباط.',
  },
  'tracking.status': {
    title: 'حالة واجهة المتجر',
    short: 'نشطة عند تعيين علامة تتبع ونشر سياسة ملفات تعريف الارتباط.',
  },
  'tracking.gtm': { title: 'معرّف Google Tag Manager', short: 'GTM-XXXXXXX. لا يُحمَّل إلا بعد الموافقة.' },
  'tracking.ga4': { title: 'معرّف قياس GA4', short: 'G-XXXXXXXXXX. لا يُحمَّل إلا بموافقة التحليلات.' },
  'tracking.google_ads': {
    title: 'معرّف Google Ads',
    short: 'AW-123456789. لا يُحمَّل إلا بموافقة التسويق.',
  },
  'tracking.google_ads_label': {
    title: 'تسمية تحويل الشراء',
    short: 'الجزء الذي يلي "AW-…/" في إعدادات علامة التحويل.',
  },
  'tracking.meta': { title: 'معرّف بكسل Meta', short: 'أرقام فقط. لا يُحمَّل إلا بموافقة التسويق.' },
  'tracking.tiktok': { title: 'معرّف بكسل TikTok', short: 'لا يُحمَّل إلا بموافقة التسويق.' },
  'tracking.server_events': {
    title: 'الأحداث من جانب الخادم',
    short: 'تُرسل الطلبات المدفوعة والمبالغ المستردة من الخادم إلى GA4 وMeta وTikTok مع احترام الموافقة.',
  },
  'tracking.server_ga4': {
    title: 'GA4 Measurement Protocol',
    short: 'GA4 ← المشرف ← مصادر البيانات ← أسرار Measurement Protocol API ← إنشاء.',
  },
  'tracking.server_meta': {
    title: 'Meta Conversions API',
    short: 'Events Manager ← البكسل ← الإعدادات ← Conversions API ← إنشاء رمز وصول.',
  },
  'tracking.server_tiktok': {
    title: 'TikTok Events API',
    short: 'TikTok Ads Manager ← الأحداث ← أحداث الويب ← البكسل ← الإعدادات ← إنشاء رمز وصول.',
  },
  'tracking.server_test_code': { title: 'رمز حدث الاختبار', short: 'يستخدمه زر "إرسال حدث اختباري" فقط.' },
  'tracking.server_test': {
    title: 'إرسال حدث اختباري',
    short: 'GA4: نقطة نهاية التحقق؛ Meta/TikTok: مشاهدة صفحة مع رمز الاختبار.',
  },
  'tracking.server_user_data': {
    title: 'مطابقة البيانات الشخصية',
    short: 'يُرسل البريد الإلكتروني ورقم الهاتف كقيم تجزئة SHA-256. معطّل افتراضيًا.',
  },
  'tracking.server_log': {
    title: 'سجل أحداث الخادم',
    short: 'البيانات المرسلة والحالة وأخطاء المزوّد؛ ويمكن إعادة محاولة الأحداث الفاشلة.',
  },
  'tracking.events': {
    title: 'مدير الأحداث',
    short: 'اختر الأحداث القياسية التي تُرسل إلى كل خدمة، وعرّف أحداثًا مخصصة. لا تتغير قواعد الموافقة.',
  },
  'tracking.events_standard': {
    title: 'الأحداث القياسية',
    short:
      'أزل علامة الاختيار لإيقاف إرسال ذلك الحدث إلى تلك الخدمة. الأحداث التي ليس لها مقابل في Meta/TikTok لا تُرسل أبدًا (—).',
  },
  'tracking.custom_events': {
    title: 'الأحداث المخصصة',
    short:
      'حتى 20 حدثًا مخصصًا: مشاهدة صفحة أو نقرات على روابط الهاتف أو البريد الإلكتروني أو WhatsApp أو الروابط الخارجية. بلا بيانات شخصية.',
  },
  'tracking.custom_event_name': {
    title: 'اسم الحدث',
    short:
      'يبدأ بحرف صغير؛ a–z والأرقام والشرطة السفلية، من 3 إلى 40 حرفًا. لا يُسمح بالأسماء القياسية والمحجوزة.',
  },
  'tracking.custom_event_trigger': { title: 'متى', short: 'مشاهدة صفحة أو نقرة على نوع من الروابط.' },
  'tracking.custom_event_path': {
    title: 'مسار الصفحة',
    short: 'مسار مطابق تمامًا، أو أنهِه بـ * لمطابقة البداية.',
  },
  'tracking.custom_event_destinations': {
    title: 'الإرسال إلى',
    short: 'الخدمات التي تستقبل الحدث (فقط عند تعيين علامة التتبع وموافقة الزائر).',
  },
  'tracking.custom_event_add': {
    title: 'إضافة إلى القائمة',
    short: 'يضيف الحدث؛ احفظ لتطبيقه على واجهة المتجر.',
  },
  'tracking.custom_event_remove': { title: 'إزالة الحدث', short: 'يزيل الحدث؛ احفظ للتطبيق.' },
  'tracking.events_save': { title: 'حفظ إعدادات الأحداث', short: 'يطبّق اختيارات الأحداث والأحداث المخصصة.' },
  'tracking.save': { title: 'حفظ علامات التتبع', short: 'الحقل الفارغ يزيل علامة التتبع المقابلة له.' },
  'tracking.legal': {
    title: 'التأثير على النصوص القانونية',
    short: 'ملفات تعريف الارتباط ومستلمو علامات التتبع المُعدّة، مقارنةً بالنصوص المنشورة.',
  },
  'tracking.stats': {
    title: 'إحصاءات الموافقة على ملفات تعريف الارتباط',
    short: 'الاختيارات خلال آخر 30 يومًا (آخر اختيار لكل متصفح).',
  },
  'stores.market_tax_mode': {
    title: 'الوضع الضريبي',
    short:
      'ضريبة القيمة المضافة المطبّقة على الطلبات في هذا السوق: ضريبة القيمة المضافة المحلية، أو إعفاء التصدير (بلا ضريبة)، أو ضريبة القيمة المضافة لبلد الوجهة.',
  },
  'pricing.tax_country_rate': {
    title: 'نسب ضريبة القيمة المضافة حسب البلد',
    short:
      'نسبة فئة ضريبية في بلد ما؛ تُطبّق في الأسواق التي يكون وضعها الضريبي "ضريبة القيمة المضافة لبلد الوجهة".',
  },
  'shipping.countries': {
    title: 'بلدان الوجهة',
    short: 'بلدان السوق التي تُتاح فيها الطريقة؛ وإذا لم يُحدَّد أي بلد فهي متاحة في كل مكان.',
  },
  'products.customs': {
    title: 'الجمارك والتصدير',
    short:
      'رمز النظام المنسق (HS) وبلد المنشأ والوصف الجمركي المستخدمة في الفاتورة المبدئية والبيان الجمركي.',
  },
  'products.hs_code': {
    title: 'رمز النظام المنسق HS (GTİP)',
    short: 'البند التعريفي الجمركي للبضاعة (من 6 إلى 12 رقمًا).',
  },
  'products.origin_country': { title: 'بلد المنشأ', short: 'البلد الذي أُنتجت فيه البضاعة.' },
  'products.customs_description': {
    title: 'الوصف الجمركي',
    short: 'وصف قصير وواضح للبضاعة لأجل البيان الجمركي.',
  },
  'orders.tax_exemption': {
    title: 'تصدير — معفى من ضريبة القيمة المضافة',
    short: 'ورد الطلب من سوق وضعه الضريبي هو التصدير؛ ولم تُحتسب ضريبة القيمة المضافة.',
  },
  'orders.proforma': {
    title: 'الفاتورة المبدئية',
    short: 'مستند طلب قابل للطباعة للجمارك وللمشتري؛ وليس فاتورة تجارية.',
  },
  'payments.bank_account_currency': {
    title: 'عملة الحساب',
    short: 'لا يُعرض التحويل البنكي بهذا الحساب إلا للطلبات بهذه العملة.',
  },
  'page.order_proforma': {
    title: 'الفاتورة المبدئية',
    short: 'الفاتورة المبدئية للطلب؛ اطبعها أو احفظها بصيغة PDF.',
  },
  'products.translations': {
    title: 'الترجمات',
    short: 'اسم المنتج وأوصافه وحقول SEO بلغات أخرى، تُنشر على عناوين بنمط /en/….',
  },
  'translations.seo': {
    title: 'حقول SEO في الترجمة',
    short: 'العنوان (70 حرفًا) والوصف (170 حرفًا) المعروضان في نتائج البحث بتلك اللغة.',
  },
  'keywords.language': {
    title: 'لغة الكلمة المفتاحية',
    short: 'اللغة التي يُبحث بها عن الكلمة المفتاحية؛ ويمكن تصفية المجمّع حسب اللغة.',
  },
  'merchant.markets': {
    title: 'الأسواق المرسلة إلى Google',
    short: 'كل سوق (بلد + لغة + عملة) هو خلاصة مستقلة ومصدر بيانات مستقل في Merchant API.',
  },
  'payments.intl': {
    title: 'المدفوعات الأجنبية (Stripe، PayPal)',
    short: 'الدفع بالبطاقة بالعملات الأجنبية عبر Stripe، والدفع عبر PayPal على الصفحة الآمنة لدى المزوّد.',
  },
  'payments.intl_entity': {
    title: 'يلزم وجود شركة أجنبية',
    short: 'لا تفتح Stripe وPayPal حسابات للشركات في تركيا؛ استخدم شركتك في بلد مدعوم.',
  },
  'payments.intl_card_provider': {
    title: 'الدفع بالبطاقة بالعملات الأجنبية',
    short: 'عند اختيار Stripe، تمر مدفوعات البطاقة بغير TRY عبر Stripe، وتستخدم مدفوعات TRY المزوّد المحلي.',
  },
  'payments.paypal': {
    title: 'الدفع عبر PayPal',
    short: 'يظهر في صفحة إتمام الطلب لأسواق EUR وUSD وGBP فقط.',
  },
  'payments.intl_notify_urls': {
    title: 'عناوين URL لـ Webhook في Stripe وPayPal',
    short: 'أضفها في Stripe Dashboard ← Webhooks وفي PayPal Developer ← التطبيق ← Webhooks.',
  },
  'page.ui_translations': { title: 'الترجمات', short: 'حالة ترجمة نصوص الواجهة والمساعدة حسب اللغة.' },
  'ui_translations.coverage': {
    title: 'تغطية الترجمة',
    short: 'عدد نصوص الواجهة والمساعدة المترجمة في كل لغة؛ صفر ناقص يعني أن اللغة مكتملة.',
  },
  'page.subscriptions': {
    title: 'الطلبات المتكررة',
    short: 'التوصيلات المنتظمة التي يبدؤها العملاء «كل N أسابيع»: الإعدادات والجاهزية وقائمة الاشتراكات.',
  },
  'subscriptions.settings': {
    title: 'إعدادات الطلبات المتكررة',
    short: 'لكل متجر؛ معطّلة افتراضيًا. يتطلب التفعيل مزوّد دفع بالبطاقة ونصوص العقود.',
  },
  'subscriptions.enabled': {
    title: 'تفعيل التوصيل المنتظم',
    short:
      'عند التفعيل يظهر مربع «التوصيل المنتظم» في صفحات المنتجات المؤهلة. عند التعطيل لا تُفتح طلبات جديدة وتنتظر الاشتراكات.',
  },
  'subscriptions.intervals': {
    title: 'الفترات',
    short: 'تكرارات التوصيل (بالأسابيع) التي يمكن للعملاء اختيارها. اختر واحدة على الأقل.',
  },
  'subscriptions.discount': {
    title: 'خصم الاشتراك',
    short: 'خصم بالنسبة المئوية على الطلبات المتكررة (0–30). تبقى النسبة عند بدء الاشتراك ثابتة له.',
  },
  'subscriptions.link_hours': {
    title: 'مدة صلاحية رابط الدفع',
    short: 'مدة دفع طلب الفترة (24–168 ساعة). بعد انتهائها يُلغى الطلب ويعود المخزون.',
  },
  'subscriptions.save': {
    title: 'حفظ الإعدادات',
    short: 'يحفظ الإعدادات ويطلب التأكيد عند التفعيل. يُسجَّل التغيير في سجل التدقيق.',
  },
  'subscriptions.list': {
    title: 'الاشتراكات',
    short: 'العميل والمنتج والكمية والفترة ويوم الطلب التالي والحالة والطلب الذي ينتظر الدفع.',
  },
  'subscriptions.runs': {
    title: 'الفترات',
    short: 'كل فترة من الاشتراك: فُتح الطلب، دُفع، تم التخطي، غير متوفر، لم يُدفع.',
  },
  'subscriptions.cancel': {
    title: 'إلغاء الاشتراك',
    short: 'سبب من 3 أحرف على الأقل يُسجَّل في سجل التدقيق. لا يتلقى العميل بريدًا؛ ويرى «ملغى» في «حسابي».',
  },
  'products.subscribable': {
    title: 'متاح للتوصيل المنتظم',
    short: 'عند التفعيل ومع تفعيل التوصيل المنتظم في المتجر، يظهر مربع «التوصيل المنتظم» في صفحة المنتج.',
  },
  'tracking.cross_domain': {
    title: 'التتبع عبر النطاقات',
    short:
      'عند وجود عدة نطاقات للواجهة يُنقل رابط GA4 وبيانات المصدر بينها؛ يُفعَّل تلقائيًا عند إضافة نطاق ثانٍ.',
  },
  'shipping.geliver': {
    title: 'الشحن عبر Geliver',
    short:
      'أنشئ الشحنات من الطلبات بحساب Geliver، وقارن أسعار شركات الشحن، واشترِ الملصق من اللوحة. يتم الربط من التكاملات ← الشحن ← Geliver.',
  },
  'shipping.geliver_sender': {
    title: 'عنوان المرسل',
    short:
      'العنوان الذي يُستلم منه الطرد. يُختار من عناوين المرسل المعرّفة في Geliver؛ وتُقرأ القائمة من Geliver.',
  },
  'shipping.geliver_parcel': {
    title: 'أبعاد الطرد الافتراضية',
    short: 'الطول والعرض والارتفاع المقترحة في نافذة الشحن (سم، 1–300). يمكن تغييرها لكل شحنة.',
  },
  'shipping.geliver_weight': {
    title: 'الوزن الافتراضي',
    short: 'الوزن (بالغرام) للبنود التي لا يوجد لمنتجها وزن. إدخال أوزان المنتجات يجعل العروض دقيقة.',
  },
  'shipping.geliver_save': {
    title: 'احفظ إعدادات Geliver',
    short:
      'يحفظ عنوان المرسل والطرد الافتراضي؛ ولا يُحفظ عنوان مرسل غير موجود في Geliver. يُسجَّل التغيير في سجل التدقيق.',
  },
  'orders.ship_geliver': {
    title: 'الشحن عبر Geliver',
    short:
      'اختر المنتجات المعبأة وأبعاد الطرد ووزنه، واحصل على عروض شركات الشحن من Geliver، واشترِ الملصق بالعرض المختار.',
  },
  'orders.geliver_parcel': {
    title: 'أبعاد الطرد ووزنه',
    short:
      'الأبعاد (سم) والوزن (غرام) التي تحدد سعر الشحن. يُقترح الوزن من أوزان المنتجات؛ زِن الطرد وصحّحه.',
  },
  'orders.geliver_offers': {
    title: 'احصل على العروض',
    short:
      'ينشئ الشحنة في Geliver ويجلب أسعار شركات الشحن؛ دون أي رسوم. أعد الجلب إذا تغيّرت الأبعاد أو المنتجات.',
  },
  'orders.geliver_offer': {
    title: 'عرض الشحن',
    short: 'الشركة والخدمة والمدة المتوقعة والسعر الذي تبلغه Geliver. الأرخص والأسرع مميّزان.',
  },
  'orders.geliver_buy': {
    title: 'اشترِ الملصق',
    short:
      'يشتري الملصق بالعرض المختار؛ وبعد التأكيد تُخصم الرسوم من رصيد Geliver (شحنة اختبار في بيئة الاختبار). لا يُشترى العرض نفسه مرتين.',
  },
  'orders.geliver_label': {
    title: 'افتح الملصق',
    short: 'يفتح ملصق الشحن (PDF) الذي أنشأته Geliver في علامة تبويب جديدة؛ اطبعه وألصقه على الطرد.',
  },
  'orders.geliver_sync': {
    title: 'حدّث الحالة',
    short:
      'يقرأ حالة الشحنة ورقم التتبع من Geliver الآن (تُقرأ تلقائيًا كل 30 دقيقة). يُرسل بريد إلى العميل عند وصول رقم التتبع لأول مرة.',
  },
  'orders.geliver_cancel': {
    title: 'الإلغاء في Geliver',
    short:
      'يلغي الشحنة في Geliver قبل أن تستلمها شركة الشحن؛ تعود المنتجات المعبأة إلى المخزون ويمكن شحن الطلب مجددًا. تُسترد رسوم الملصق وفق قواعد Geliver.',
  },
  'stores.customer_auth': {
    title: 'تسجيل دخول العملاء',
    short:
      '«المتابعة باستخدام Google» في واجهة المتجر: الدخول والتسجيل والدفع. يُفعَّل لكل متجر؛ معطّل افتراضيًا.',
  },
  'stores.customer_auth_toggle': {
    title: 'تفعيل/تعطيل الدخول عبر Google',
    short:
      'يفعّله مالك النشاط فقط مع التحقق بخطوتين؛ ويجب إعداد عميل تسجيل الدخول عبر Google في التكاملات. التعطيل يوقف عمليات الدخول الجديدة عبر Google.',
  },
  'stores.customer_auth_redirects': {
    title: 'عناوين إعادة التوجيه',
    short:
      'أدخل هذه العناوين لكل نطاق متجر في Google Cloud ← واجهات API والخدمات ← بيانات الاعتماد ← عميل OAuth ← عناوين URI المعتمدة لإعادة التوجيه.',
  },
};

export const MOBILE_HELP_AR: Record<MobileHelpKey, Loc> = {
  'mobile.page.home': { title: 'الرئيسية (الجوال)', short: 'طلبات اليوم والأمور التي تحتاج إلى اهتمامك.' },
  'mobile.page.more': {
    title: 'المزيد',
    short: 'العملاء والإرجاعات ومراجعة المحتوى وSEO ورموز الخصم والإعدادات.',
  },
  'mobile.page.count': {
    title: 'جرد المخزون بالباركود',
    short: 'امسح ما تعدّه على الرف وصحّح مخزون المستودع.',
  },
  'mobile.page.review': {
    title: 'بانتظار مراجعة المختص',
    short: 'المنتجات والمقالات والصفحات واللافتات والأسئلة التي تنتظر المراجع البيطري المختص.',
  },
  'mobile.page.settings': {
    title: 'الإعدادات',
    short: 'الحساب والنشاط التجاري والمتجر والقفل البيومتري واللغة والجلسات المفتوحة.',
  },
  'mobile.server_url': {
    title: 'عنوان لوحة التحكم',
    short: 'لوحة التحكم المراد الاتصال بها (مثل panel.zootopia.com.tr).',
  },
  'mobile.biometric': {
    title: 'القفل البيومتري',
    short: 'يطلب بصمة الإصبع أو بصمة الوجه أو قفل الشاشة عند فتح التطبيق.',
  },
  'mobile.scan': { title: 'مسح الباركود', short: 'يقرأ الباركود بالكاميرا.' },
  'mobile.take_photo': { title: 'إضافة صورة', short: 'التقط صورة للمنتج أو اختر واحدة من المعرض.' },
  'mobile.barcode_assign': { title: 'تعيين الباركود', short: 'يحفظ الباركود الممسوح لهذا المتغير.' },
  'mobile.count_lot': { title: 'الدفعة', short: 'رقم دفعة العبوات التي عددتها.' },
  'mobile.count_submit': { title: 'إرسال الجرد', short: 'يسجّل البنود الجاهزة كعمليات جرد للمخزون.' },
  'mobile.count_discard': {
    title: 'تجاهل الجرد',
    short: 'يحذف الجرد على هذا الجهاز؛ وتبقى البنود المُرسلة مسجّلة.',
  },
  'mobile.store_switch': { title: 'المتجر', short: 'الشاشات الخاصة بالمتجر تستخدم هذا المتجر.' },
  'mobile.organization_switch': {
    title: 'تبديل النشاط التجاري',
    short: 'انتقل إلى نشاط تجاري آخر تنتمي إليه.',
  },
  'mobile.sign_out': { title: 'تسجيل الخروج', short: 'يُنهي الجلسة ويحذف البيانات على هذا الجهاز.' },
  'mobile.notifications': {
    title: 'الإشعارات الفورية',
    short: 'إشعارات الطلبات الجديدة ومراجعات الدفع وطلبات الإرجاع وطلبات الوكالة ورسائل التواصل.',
  },
  'mobile.notifications.device': {
    title: 'هذا الهاتف',
    short: 'إذن الإشعارات وتسجيل هذا الهاتف.',
  },
  'mobile.notifications.allow': {
    title: 'تفعيل الإشعارات',
    short: 'يطلب الإذن ويسجّل هذا الهاتف لتلقي الإشعارات.',
  },
  'mobile.notifications.open_settings': {
    title: 'فتح إعدادات الهاتف',
    short: 'إذا تعذّر طلب الإذن مرة أخرى، فعّل الإشعارات من إعدادات الهاتف.',
  },
  'mobile.notifications.devices': {
    title: 'أجهزتي',
    short: 'الهواتف التي تتلقى إشعارات حسابك.',
  },
  'mobile.notifications.remove': {
    title: 'إزالة الجهاز',
    short: 'لن تُرسل إشعارات إلى هذا الجهاز.',
  },
  'mobile.offline': { title: 'بلا اتصال', short: 'بدون إنترنت، لا يمكن متابعة سوى الجرد على الجهاز.' },
};
